var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/core/fetcher/stream-wrappers/Node18UniversalStreamWrapper.ts
var Node18UniversalStreamWrapper_exports = {};
__export(Node18UniversalStreamWrapper_exports, {
  Node18UniversalStreamWrapper: () => Node18UniversalStreamWrapper
});
var Node18UniversalStreamWrapper;
var init_Node18UniversalStreamWrapper = __esm({
  "src/core/fetcher/stream-wrappers/Node18UniversalStreamWrapper.ts"() {
    "use strict";
    Node18UniversalStreamWrapper = class _Node18UniversalStreamWrapper {
      readableStream;
      reader;
      events;
      paused;
      resumeCallback;
      encoding;
      constructor(readableStream) {
        this.readableStream = readableStream;
        this.reader = this.readableStream.getReader();
        this.events = {
          data: [],
          end: [],
          error: [],
          readable: [],
          close: [],
          pause: [],
          resume: []
        };
        this.paused = false;
        this.resumeCallback = null;
        this.encoding = null;
      }
      on(event, callback) {
        this.events[event]?.push(callback);
      }
      off(event, callback) {
        this.events[event] = this.events[event]?.filter((cb) => cb !== callback);
      }
      pipe(dest) {
        this.on("data", async (chunk) => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._write(chunk);
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.write(chunk).then(() => writer.releaseLock());
          } else {
            dest.write(chunk);
          }
        });
        this.on("end", async () => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._end();
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.close();
          } else {
            dest.end();
          }
        });
        this.on("error", async (error) => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._error(error);
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.abort(error);
          } else {
            dest.destroy(error);
          }
        });
        this._startReading();
        return dest;
      }
      pipeTo(dest) {
        return this.pipe(dest);
      }
      unpipe(dest) {
        this.off("data", async (chunk) => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._write(chunk);
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.write(chunk).then(() => writer.releaseLock());
          } else {
            dest.write(chunk);
          }
        });
        this.off("end", async () => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._end();
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.close();
          } else {
            dest.end();
          }
        });
        this.off("error", async (error) => {
          if (dest instanceof _Node18UniversalStreamWrapper) {
            dest._error(error);
          } else if (dest instanceof WritableStream) {
            const writer = dest.getWriter();
            writer.abort(error);
          } else {
            dest.destroy(error);
          }
        });
      }
      destroy(error) {
        this.reader.cancel(error).then(() => {
          this._emit("close");
        }).catch((err) => {
          this._emit("error", err);
        });
      }
      pause() {
        this.paused = true;
        this._emit("pause");
      }
      resume() {
        if (this.paused) {
          this.paused = false;
          this._emit("resume");
          if (this.resumeCallback) {
            this.resumeCallback();
            this.resumeCallback = null;
          }
        }
      }
      get isPaused() {
        return this.paused;
      }
      async read() {
        if (this.paused) {
          await new Promise((resolve) => {
            this.resumeCallback = resolve;
          });
        }
        const { done, value } = await this.reader.read();
        if (done) {
          return void 0;
        }
        return value;
      }
      setEncoding(encoding) {
        this.encoding = encoding;
      }
      async text() {
        const chunks = [];
        while (true) {
          const { done, value } = await this.reader.read();
          if (done) {
            break;
          }
          if (value) {
            chunks.push(value);
          }
        }
        const decoder = new TextDecoder(this.encoding || "utf-8");
        return decoder.decode(await new Blob(chunks).arrayBuffer());
      }
      async json() {
        const text = await this.text();
        return JSON.parse(text);
      }
      _write(chunk) {
        this._emit("data", chunk);
      }
      _end() {
        this._emit("end");
      }
      _error(error) {
        this._emit("error", error);
      }
      _emit(event, data) {
        if (this.events[event]) {
          for (const callback of this.events[event] || []) {
            callback(data);
          }
        }
      }
      async _startReading() {
        try {
          this._emit("readable");
          while (true) {
            if (this.paused) {
              await new Promise((resolve) => {
                this.resumeCallback = resolve;
              });
            }
            const { done, value } = await this.reader.read();
            if (done) {
              this._emit("end");
              this._emit("close");
              break;
            }
            if (value) {
              this._emit("data", value);
            }
          }
        } catch (error) {
          this._emit("error", error);
        }
      }
      [Symbol.asyncIterator]() {
        return {
          next: async () => {
            if (this.paused) {
              await new Promise((resolve) => {
                this.resumeCallback = resolve;
              });
            }
            const { done, value } = await this.reader.read();
            if (done) {
              return { done: true, value: void 0 };
            }
            return { done: false, value };
          },
          [Symbol.asyncIterator]() {
            return this;
          }
        };
      }
    };
  }
});

// src/core/fetcher/stream-wrappers/UndiciStreamWrapper.ts
var UndiciStreamWrapper_exports = {};
__export(UndiciStreamWrapper_exports, {
  UndiciStreamWrapper: () => UndiciStreamWrapper
});
var UndiciStreamWrapper;
var init_UndiciStreamWrapper = __esm({
  "src/core/fetcher/stream-wrappers/UndiciStreamWrapper.ts"() {
    "use strict";
    UndiciStreamWrapper = class _UndiciStreamWrapper {
      readableStream;
      reader;
      events;
      paused;
      resumeCallback;
      encoding;
      constructor(readableStream) {
        this.readableStream = readableStream;
        this.reader = this.readableStream.getReader();
        this.events = {
          data: [],
          end: [],
          error: [],
          readable: [],
          close: [],
          pause: [],
          resume: []
        };
        this.paused = false;
        this.resumeCallback = null;
        this.encoding = null;
      }
      on(event, callback) {
        this.events[event]?.push(callback);
      }
      off(event, callback) {
        this.events[event] = this.events[event]?.filter((cb) => cb !== callback);
      }
      pipe(dest) {
        this.on("data", (chunk) => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._write(chunk);
          } else {
            const writer = dest.getWriter();
            writer.write(chunk).then(() => writer.releaseLock());
          }
        });
        this.on("end", () => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._end();
          } else {
            const writer = dest.getWriter();
            writer.close();
          }
        });
        this.on("error", (error) => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._error(error);
          } else {
            const writer = dest.getWriter();
            writer.abort(error);
          }
        });
        this._startReading();
        return dest;
      }
      pipeTo(dest) {
        return this.pipe(dest);
      }
      unpipe(dest) {
        this.off("data", (chunk) => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._write(chunk);
          } else {
            const writer = dest.getWriter();
            writer.write(chunk).then(() => writer.releaseLock());
          }
        });
        this.off("end", () => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._end();
          } else {
            const writer = dest.getWriter();
            writer.close();
          }
        });
        this.off("error", (error) => {
          if (dest instanceof _UndiciStreamWrapper) {
            dest._error(error);
          } else {
            const writer = dest.getWriter();
            writer.abort(error);
          }
        });
      }
      destroy(error) {
        this.reader.cancel(error).then(() => {
          this._emit("close");
        }).catch((err) => {
          this._emit("error", err);
        });
      }
      pause() {
        this.paused = true;
        this._emit("pause");
      }
      resume() {
        if (this.paused) {
          this.paused = false;
          this._emit("resume");
          if (this.resumeCallback) {
            this.resumeCallback();
            this.resumeCallback = null;
          }
        }
      }
      get isPaused() {
        return this.paused;
      }
      async read() {
        if (this.paused) {
          await new Promise((resolve) => {
            this.resumeCallback = resolve;
          });
        }
        const { done, value } = await this.reader.read();
        if (done) {
          return void 0;
        }
        return value;
      }
      setEncoding(encoding) {
        this.encoding = encoding;
      }
      async text() {
        const chunks = [];
        while (true) {
          const { done, value } = await this.reader.read();
          if (done) {
            break;
          }
          if (value) {
            chunks.push(value);
          }
        }
        const decoder = new TextDecoder(this.encoding || "utf-8");
        return decoder.decode(await new Blob(chunks).arrayBuffer());
      }
      async json() {
        const text = await this.text();
        return JSON.parse(text);
      }
      _write(chunk) {
        this._emit("data", chunk);
      }
      _end() {
        this._emit("end");
      }
      _error(error) {
        this._emit("error", error);
      }
      _emit(event, data) {
        if (this.events[event]) {
          for (const callback of this.events[event] || []) {
            callback(data);
          }
        }
      }
      async _startReading() {
        try {
          this._emit("readable");
          while (true) {
            if (this.paused) {
              await new Promise((resolve) => {
                this.resumeCallback = resolve;
              });
            }
            const { done, value } = await this.reader.read();
            if (done) {
              this._emit("end");
              this._emit("close");
              break;
            }
            if (value) {
              this._emit("data", value);
            }
          }
        } catch (error) {
          this._emit("error", error);
        }
      }
      [Symbol.asyncIterator]() {
        return {
          next: async () => {
            if (this.paused) {
              await new Promise((resolve) => {
                this.resumeCallback = resolve;
              });
            }
            const { done, value } = await this.reader.read();
            if (done) {
              return { done: true, value: void 0 };
            }
            return { done: false, value };
          },
          [Symbol.asyncIterator]() {
            return this;
          }
        };
      }
    };
  }
});

// src/core/fetcher/stream-wrappers/NodePre18StreamWrapper.ts
var NodePre18StreamWrapper_exports = {};
__export(NodePre18StreamWrapper_exports, {
  NodePre18StreamWrapper: () => NodePre18StreamWrapper
});
var NodePre18StreamWrapper;
var init_NodePre18StreamWrapper = __esm({
  "src/core/fetcher/stream-wrappers/NodePre18StreamWrapper.ts"() {
    "use strict";
    NodePre18StreamWrapper = class {
      readableStream;
      encoding;
      constructor(readableStream) {
        this.readableStream = readableStream;
      }
      on(event, callback) {
        this.readableStream.on(event, callback);
      }
      off(event, callback) {
        this.readableStream.off(event, callback);
      }
      pipe(dest) {
        this.readableStream.pipe(dest);
        return dest;
      }
      pipeTo(dest) {
        return this.pipe(dest);
      }
      unpipe(dest) {
        if (dest) {
          this.readableStream.unpipe(dest);
        } else {
          this.readableStream.unpipe();
        }
      }
      destroy(error) {
        this.readableStream.destroy(error);
      }
      pause() {
        this.readableStream.pause();
      }
      resume() {
        this.readableStream.resume();
      }
      get isPaused() {
        return this.readableStream.isPaused();
      }
      async read() {
        return new Promise((resolve, reject) => {
          const chunk = this.readableStream.read();
          if (chunk) {
            resolve(chunk);
          } else {
            this.readableStream.once("readable", () => {
              const chunk2 = this.readableStream.read();
              resolve(chunk2);
            });
            this.readableStream.once("error", reject);
          }
        });
      }
      setEncoding(encoding) {
        this.readableStream.setEncoding(encoding);
        this.encoding = encoding;
      }
      async text() {
        const chunks = [];
        const encoder = new TextEncoder();
        this.readableStream.setEncoding(this.encoding || "utf-8");
        for await (const chunk of this.readableStream) {
          chunks.push(encoder.encode(chunk));
        }
        const decoder = new TextDecoder(this.encoding || "utf-8");
        return decoder.decode(Buffer.concat(chunks));
      }
      async json() {
        const text = await this.text();
        return JSON.parse(text);
      }
      [Symbol.asyncIterator]() {
        const readableStream = this.readableStream;
        const iterator = readableStream[Symbol.asyncIterator]();
        return {
          async next() {
            const { value, done } = await iterator.next();
            return { value, done };
          },
          [Symbol.asyncIterator]() {
            return this;
          }
        };
      }
    };
  }
});

// src/api/index.ts
var api_exports = {};
__export(api_exports, {
  BadRequestError: () => BadRequestError,
  ForbiddenError: () => ForbiddenError,
  InternalError: () => InternalError,
  NotFoundError: () => NotFoundError,
  RateLimitError: () => RateLimitError,
  UnauthorizedError: () => UnauthorizedError,
  actors: () => actors_exports,
  auth: () => auth_exports2,
  builds: () => builds_exports,
  captcha: () => captcha_exports,
  cloud: () => cloud_exports,
  common: () => common_exports12,
  coreIntercom: () => coreIntercom_exports,
  edgeIntercom: () => edgeIntercom_exports,
  game: () => game_exports,
  games: () => games_exports2,
  geo: () => geo_exports,
  group: () => group_exports,
  identity: () => identity_exports2,
  job: () => job_exports,
  matchmaker: () => matchmaker_exports3,
  portal: () => portal_exports,
  provision: () => provision_exports,
  regions: () => regions_exports,
  routes: () => routes_exports,
  servers: () => servers_exports2,
  upload: () => upload_exports
});

// src/api/resources/actors/index.ts
var actors_exports = {};
__export(actors_exports, {
  EndpointType: () => EndpointType,
  NetworkMode: () => NetworkMode,
  PortProtocol: () => PortProtocol,
  common: () => common_exports,
  logs: () => logs_exports,
  metrics: () => metrics_exports
});

// src/api/resources/actors/resources/common/index.ts
var common_exports = {};
__export(common_exports, {
  EndpointType: () => EndpointType,
  NetworkMode: () => NetworkMode,
  PortProtocol: () => PortProtocol
});

// src/api/resources/actors/resources/common/types/NetworkMode.ts
var NetworkMode = {
  Bridge: "bridge",
  Host: "host"
};

// src/api/resources/actors/resources/common/types/PortProtocol.ts
var PortProtocol = {
  Http: "http",
  Https: "https",
  Tcp: "tcp",
  TcpTls: "tcp_tls",
  Udp: "udp"
};

// src/api/resources/actors/resources/common/types/EndpointType.ts
var EndpointType = {
  Hostname: "hostname",
  Path: "path"
};

// src/api/resources/actors/resources/logs/index.ts
var logs_exports = {};

// src/api/resources/actors/resources/metrics/index.ts
var metrics_exports = {};

// src/api/resources/builds/index.ts
var builds_exports = {};
__export(builds_exports, {
  BuildCompression: () => BuildCompression,
  BuildKind: () => BuildKind,
  common: () => common_exports2
});

// src/api/resources/builds/types/BuildKind.ts
var BuildKind = {
  DockerImage: "docker_image",
  OciBundle: "oci_bundle",
  Javascript: "javascript"
};

// src/api/resources/builds/types/BuildCompression.ts
var BuildCompression = {
  None: "none",
  Lz4: "lz4"
};

// src/api/resources/builds/resources/common/index.ts
var common_exports2 = {};

// src/api/resources/cloud/index.ts
var cloud_exports = {};
__export(cloud_exports, {
  BootstrapAccess: () => BootstrapAccess,
  BootstrapCluster: () => BootstrapCluster,
  CdnAuthType: () => CdnAuthType,
  CdnNamespaceDomainVerificationStatus: () => CdnNamespaceDomainVerificationStatus,
  UniversalRegion: () => UniversalRegion,
  auth: () => auth_exports,
  common: () => common_exports4,
  devices: () => devices_exports,
  games: () => games_exports,
  groups: () => groups_exports,
  logs: () => logs_exports3,
  tiers: () => tiers_exports,
  uploads: () => uploads_exports,
  version: () => version_exports
});

// src/api/resources/cloud/types/BootstrapCluster.ts
var BootstrapCluster = {
  Enterprise: "enterprise",
  Oss: "oss"
};

// src/api/resources/cloud/types/BootstrapAccess.ts
var BootstrapAccess = {
  Public: "public",
  Private: "private",
  Development: "development"
};

// src/api/resources/cloud/resources/games/index.ts
var games_exports = {};
__export(games_exports, {
  BuildCompression: () => BuildCompression2,
  BuildKind: () => BuildKind2,
  LogStream: () => LogStream,
  avatars: () => avatars_exports,
  builds: () => builds_exports2,
  cdn: () => cdn_exports,
  matchmaker: () => matchmaker_exports,
  namespaces: () => namespaces_exports,
  tokens: () => tokens_exports,
  versions: () => versions_exports
});

// src/api/resources/cloud/resources/games/resources/namespaces/index.ts
var namespaces_exports = {};
__export(namespaces_exports, {
  analytics: () => analytics_exports,
  logs: () => logs_exports2
});

// src/api/resources/cloud/resources/games/resources/namespaces/resources/analytics/index.ts
var analytics_exports = {};

// src/api/resources/cloud/resources/games/resources/namespaces/resources/logs/index.ts
var logs_exports2 = {};

// src/api/resources/cloud/resources/games/resources/avatars/index.ts
var avatars_exports = {};

// src/api/resources/cloud/resources/games/resources/builds/index.ts
var builds_exports2 = {};
__export(builds_exports2, {
  BuildCompression: () => BuildCompression2,
  BuildKind: () => BuildKind2
});

// src/api/resources/cloud/resources/games/resources/builds/types/BuildKind.ts
var BuildKind2 = {
  DockerImage: "docker_image",
  OciBundle: "oci_bundle"
};

// src/api/resources/cloud/resources/games/resources/builds/types/BuildCompression.ts
var BuildCompression2 = {
  None: "none",
  Lz4: "lz4"
};

// src/api/resources/cloud/resources/games/resources/cdn/index.ts
var cdn_exports = {};

// src/api/resources/cloud/resources/games/resources/matchmaker/index.ts
var matchmaker_exports = {};
__export(matchmaker_exports, {
  LogStream: () => LogStream
});

// src/api/resources/cloud/resources/games/resources/matchmaker/types/LogStream.ts
var LogStream = {
  StdOut: "std_out",
  StdErr: "std_err"
};

// src/api/resources/cloud/resources/games/resources/tokens/index.ts
var tokens_exports = {};

// src/api/resources/cloud/resources/games/resources/versions/index.ts
var versions_exports = {};

// src/api/resources/cloud/resources/version/index.ts
var version_exports = {};
__export(version_exports, {
  cdn: () => cdn_exports2,
  engine: () => engine_exports,
  identity: () => identity_exports,
  kv: () => kv_exports,
  matchmaker: () => matchmaker_exports2
});

// src/api/resources/cloud/resources/version/resources/cdn/index.ts
var cdn_exports2 = {};

// src/api/resources/cloud/resources/version/resources/engine/index.ts
var engine_exports = {};
__export(engine_exports, {
  custom: () => custom_exports,
  godot: () => godot_exports,
  html5: () => html5_exports,
  unity: () => unity_exports,
  unreal: () => unreal_exports
});

// src/api/resources/cloud/resources/version/resources/engine/resources/custom/index.ts
var custom_exports = {};

// src/api/resources/cloud/resources/version/resources/engine/resources/godot/index.ts
var godot_exports = {};

// src/api/resources/cloud/resources/version/resources/engine/resources/html5/index.ts
var html5_exports = {};

// src/api/resources/cloud/resources/version/resources/engine/resources/unity/index.ts
var unity_exports = {};

// src/api/resources/cloud/resources/version/resources/engine/resources/unreal/index.ts
var unreal_exports = {};

// src/api/resources/cloud/resources/version/resources/identity/index.ts
var identity_exports = {};

// src/api/resources/cloud/resources/version/resources/kv/index.ts
var kv_exports = {};

// src/api/resources/cloud/resources/version/resources/matchmaker/index.ts
var matchmaker_exports2 = {};
__export(matchmaker_exports2, {
  CaptchaHcaptchaLevel: () => CaptchaHcaptchaLevel,
  GameModeIdentityRequirement: () => GameModeIdentityRequirement,
  NetworkMode: () => NetworkMode2,
  PortProtocol: () => PortProtocol2,
  ProxyKind: () => ProxyKind,
  common: () => common_exports3,
  gameMode: () => gameMode_exports,
  lobbyGroup: () => lobbyGroup_exports
});

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/common/index.ts
var common_exports3 = {};
__export(common_exports3, {
  CaptchaHcaptchaLevel: () => CaptchaHcaptchaLevel,
  NetworkMode: () => NetworkMode2,
  PortProtocol: () => PortProtocol2,
  ProxyKind: () => ProxyKind
});

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/common/types/PortProtocol.ts
var PortProtocol2 = {
  Http: "http",
  Https: "https",
  Tcp: "tcp",
  TcpTls: "tcp_tls",
  Udp: "udp"
};

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/common/types/ProxyKind.ts
var ProxyKind = {
  None: "none",
  GameGuard: "game_guard"
};

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/common/types/CaptchaHcaptchaLevel.ts
var CaptchaHcaptchaLevel = {
  Easy: "easy",
  Moderate: "moderate",
  Difficult: "difficult",
  AlwaysOn: "always_on"
};

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/common/types/NetworkMode.ts
var NetworkMode2 = {
  Bridge: "bridge",
  Host: "host"
};

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/index.ts
var gameMode_exports = {};
__export(gameMode_exports, {
  GameModeIdentityRequirement: () => GameModeIdentityRequirement
});

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeIdentityRequirement.ts
var GameModeIdentityRequirement = {
  None: "none",
  Guest: "guest",
  Registered: "registered"
};

// src/api/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/index.ts
var lobbyGroup_exports = {};

// src/api/resources/cloud/resources/auth/index.ts
var auth_exports = {};

// src/api/resources/cloud/resources/common/index.ts
var common_exports4 = {};
__export(common_exports4, {
  CdnAuthType: () => CdnAuthType,
  CdnNamespaceDomainVerificationStatus: () => CdnNamespaceDomainVerificationStatus,
  UniversalRegion: () => UniversalRegion
});

// src/api/resources/cloud/resources/common/types/UniversalRegion.ts
var UniversalRegion = {
  Unknown: "unknown",
  Local: "local",
  Amsterdam: "amsterdam",
  Atlanta: "atlanta",
  Bangalore: "bangalore",
  Dallas: "dallas",
  Frankfurt: "frankfurt",
  London: "london",
  Mumbai: "mumbai",
  Newark: "newark",
  NewYorkCity: "new_york_city",
  SanFrancisco: "san_francisco",
  Singapore: "singapore",
  Sydney: "sydney",
  Tokyo: "tokyo",
  Toronto: "toronto",
  WashingtonDc: "washington_dc",
  Chicago: "chicago",
  Paris: "paris",
  Seattle: "seattle",
  SaoPaulo: "sao_paulo",
  Stockholm: "stockholm",
  Chennai: "chennai",
  Osaka: "osaka",
  Milan: "milan",
  Miami: "miami",
  Jakarta: "jakarta",
  LosAngeles: "los_angeles"
};

// src/api/resources/cloud/resources/common/types/CdnAuthType.ts
var CdnAuthType = {
  None: "none",
  Basic: "basic"
};

// src/api/resources/cloud/resources/common/types/CdnNamespaceDomainVerificationStatus.ts
var CdnNamespaceDomainVerificationStatus = {
  Active: "active",
  Pending: "pending",
  Failed: "failed"
};

// src/api/resources/cloud/resources/devices/index.ts
var devices_exports = {};
__export(devices_exports, {
  links: () => links_exports
});

// src/api/resources/cloud/resources/devices/resources/links/index.ts
var links_exports = {};

// src/api/resources/cloud/resources/groups/index.ts
var groups_exports = {};

// src/api/resources/cloud/resources/logs/index.ts
var logs_exports3 = {};

// src/api/resources/cloud/resources/tiers/index.ts
var tiers_exports = {};

// src/api/resources/cloud/resources/uploads/index.ts
var uploads_exports = {};

// src/api/resources/coreIntercom/index.ts
var coreIntercom_exports = {};
__export(coreIntercom_exports, {
  pegboard: () => pegboard_exports
});

// src/api/resources/coreIntercom/resources/pegboard/index.ts
var pegboard_exports = {};

// src/api/resources/edgeIntercom/index.ts
var edgeIntercom_exports = {};
__export(edgeIntercom_exports, {
  pegboard: () => pegboard_exports2
});

// src/api/resources/edgeIntercom/resources/pegboard/index.ts
var pegboard_exports2 = {};

// src/api/resources/group/index.ts
var group_exports = {};
__export(group_exports, {
  Publicity: () => Publicity,
  common: () => common_exports5,
  invites: () => invites_exports,
  joinRequests: () => joinRequests_exports
});

// src/api/resources/group/resources/common/index.ts
var common_exports5 = {};
__export(common_exports5, {
  Publicity: () => Publicity
});

// src/api/resources/group/resources/common/types/Publicity.ts
var Publicity = {
  Open: "open",
  Closed: "closed"
};

// src/api/resources/group/resources/invites/index.ts
var invites_exports = {};

// src/api/resources/group/resources/joinRequests/index.ts
var joinRequests_exports = {};

// src/api/resources/identity/index.ts
var identity_exports2 = {};
__export(identity_exports2, {
  DevState: () => DevState,
  GameLinkStatus: () => GameLinkStatus,
  Status: () => Status,
  activities: () => activities_exports,
  common: () => common_exports6,
  events: () => events_exports
});

// src/api/resources/identity/resources/activities/index.ts
var activities_exports = {};

// src/api/resources/identity/resources/common/index.ts
var common_exports6 = {};
__export(common_exports6, {
  DevState: () => DevState,
  GameLinkStatus: () => GameLinkStatus,
  Status: () => Status
});

// src/api/resources/identity/resources/common/types/Status.ts
var Status = {
  Online: "online",
  Away: "away",
  Offline: "offline"
};

// src/api/resources/identity/resources/common/types/DevState.ts
var DevState = {
  Inactive: "inactive",
  Pending: "pending",
  Accepted: "accepted"
};

// src/api/resources/identity/resources/common/types/GameLinkStatus.ts
var GameLinkStatus = {
  Incomplete: "incomplete",
  Complete: "complete",
  Cancelled: "cancelled"
};

// src/api/resources/identity/resources/events/index.ts
var events_exports = {};

// src/api/resources/provision/index.ts
var provision_exports = {};
__export(provision_exports, {
  PoolType: () => PoolType,
  common: () => common_exports7,
  datacenters: () => datacenters_exports,
  servers: () => servers_exports,
  tunnel: () => tunnel_exports
});

// src/api/resources/provision/resources/datacenters/index.ts
var datacenters_exports = {};

// src/api/resources/provision/resources/servers/index.ts
var servers_exports = {};

// src/api/resources/provision/resources/tunnel/index.ts
var tunnel_exports = {};

// src/api/resources/provision/resources/common/index.ts
var common_exports7 = {};
__export(common_exports7, {
  PoolType: () => PoolType
});

// src/api/resources/provision/resources/common/types/PoolType.ts
var PoolType = {
  Job: "job",
  Gg: "gg",
  Ats: "ats",
  Pegboard: "pegboard",
  PegboardIsolate: "pegboard_isolate",
  Fdb: "fdb",
  Worker: "worker",
  Nats: "nats",
  Guard: "guard"
};

// src/api/resources/regions/index.ts
var regions_exports = {};
__export(regions_exports, {
  common: () => common_exports8
});

// src/api/resources/regions/resources/common/index.ts
var common_exports8 = {};

// src/api/resources/routes/index.ts
var routes_exports = {};
__export(routes_exports, {
  common: () => common_exports9
});

// src/api/resources/routes/resources/common/index.ts
var common_exports9 = {};

// src/api/resources/servers/index.ts
var servers_exports2 = {};
__export(servers_exports2, {
  BuildCompression: () => BuildCompression3,
  BuildKind: () => BuildKind3,
  LogStream: () => LogStream2,
  NetworkMode: () => NetworkMode3,
  PortProtocol: () => PortProtocol3,
  builds: () => builds_exports3,
  common: () => common_exports10,
  datacenters: () => datacenters_exports2,
  logs: () => logs_exports4
});

// src/api/resources/servers/resources/builds/index.ts
var builds_exports3 = {};
__export(builds_exports3, {
  BuildCompression: () => BuildCompression3,
  BuildKind: () => BuildKind3
});

// src/api/resources/servers/resources/builds/types/BuildKind.ts
var BuildKind3 = {
  DockerImage: "docker_image",
  OciBundle: "oci_bundle"
};

// src/api/resources/servers/resources/builds/types/BuildCompression.ts
var BuildCompression3 = {
  None: "none",
  Lz4: "lz4"
};

// src/api/resources/servers/resources/common/index.ts
var common_exports10 = {};
__export(common_exports10, {
  NetworkMode: () => NetworkMode3,
  PortProtocol: () => PortProtocol3
});

// src/api/resources/servers/resources/common/types/NetworkMode.ts
var NetworkMode3 = {
  Bridge: "bridge",
  Host: "host"
};

// src/api/resources/servers/resources/common/types/PortProtocol.ts
var PortProtocol3 = {
  Http: "http",
  Https: "https",
  Tcp: "tcp",
  TcpTls: "tcp_tls",
  Udp: "udp"
};

// src/api/resources/servers/resources/datacenters/index.ts
var datacenters_exports2 = {};

// src/api/resources/servers/resources/logs/index.ts
var logs_exports4 = {};
__export(logs_exports4, {
  LogStream: () => LogStream2
});

// src/api/resources/servers/resources/logs/types/LogStream.ts
var LogStream2 = {
  StdOut: "std_out",
  StdErr: "std_err"
};

// src/api/resources/auth/index.ts
var auth_exports2 = {};
__export(auth_exports2, {
  CompleteStatus: () => CompleteStatus,
  common: () => common_exports11,
  identity: () => identity_exports3,
  tokens: () => tokens_exports2
});

// src/api/resources/auth/resources/common/index.ts
var common_exports11 = {};
__export(common_exports11, {
  CompleteStatus: () => CompleteStatus
});

// src/api/resources/auth/resources/common/types/CompleteStatus.ts
var CompleteStatus = {
  SwitchIdentity: "switch_identity",
  LinkedAccountAdded: "linked_account_added",
  AlreadyComplete: "already_complete",
  Expired: "expired",
  TooManyAttempts: "too_many_attempts",
  Incorrect: "incorrect"
};

// src/api/resources/auth/resources/identity/index.ts
var identity_exports3 = {};
__export(identity_exports3, {
  email: () => email_exports
});

// src/api/resources/auth/resources/identity/resources/email/index.ts
var email_exports = {};

// src/api/resources/auth/resources/tokens/index.ts
var tokens_exports2 = {};

// src/api/resources/captcha/index.ts
var captcha_exports = {};
__export(captcha_exports, {
  config: () => config_exports
});

// src/api/resources/captcha/resources/config/index.ts
var config_exports = {};

// src/api/resources/common/index.ts
var common_exports12 = {};
__export(common_exports12, {
  BadRequestError: () => BadRequestError,
  ForbiddenError: () => ForbiddenError,
  InternalError: () => InternalError,
  NotFoundError: () => NotFoundError,
  RateLimitError: () => RateLimitError,
  UnauthorizedError: () => UnauthorizedError
});

// src/core/json.ts
var toJson = (value, replacer, space) => {
  return JSON.stringify(value, replacer, space);
};

// src/errors/RivetError.ts
var RivetError = class _RivetError extends Error {
  statusCode;
  body;
  constructor({ message, statusCode, body }) {
    super(buildMessage({ message, statusCode, body }));
    Object.setPrototypeOf(this, _RivetError.prototype);
    if (statusCode != null) {
      this.statusCode = statusCode;
    }
    if (body !== void 0) {
      this.body = body;
    }
  }
};
function buildMessage({
  message,
  statusCode,
  body
}) {
  let lines = [];
  if (message != null) {
    lines.push(message);
  }
  if (statusCode != null) {
    lines.push(`Status code: ${statusCode.toString()}`);
  }
  if (body != null) {
    lines.push(`Body: ${toJson(body, void 0, 2)}`);
  }
  return lines.join("\n");
}

// src/errors/RivetTimeoutError.ts
var RivetTimeoutError = class _RivetTimeoutError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, _RivetTimeoutError.prototype);
  }
};

// src/api/resources/common/errors/InternalError.ts
var InternalError = class _InternalError extends RivetError {
  constructor(body) {
    super({
      message: "InternalError",
      statusCode: 500,
      body
    });
    Object.setPrototypeOf(this, _InternalError.prototype);
  }
};

// src/api/resources/common/errors/RateLimitError.ts
var RateLimitError = class _RateLimitError extends RivetError {
  constructor(body) {
    super({
      message: "RateLimitError",
      statusCode: 429,
      body
    });
    Object.setPrototypeOf(this, _RateLimitError.prototype);
  }
};

// src/api/resources/common/errors/ForbiddenError.ts
var ForbiddenError = class _ForbiddenError extends RivetError {
  constructor(body) {
    super({
      message: "ForbiddenError",
      statusCode: 403,
      body
    });
    Object.setPrototypeOf(this, _ForbiddenError.prototype);
  }
};

// src/api/resources/common/errors/UnauthorizedError.ts
var UnauthorizedError = class _UnauthorizedError extends RivetError {
  constructor(body) {
    super({
      message: "UnauthorizedError",
      statusCode: 408,
      body
    });
    Object.setPrototypeOf(this, _UnauthorizedError.prototype);
  }
};

// src/api/resources/common/errors/NotFoundError.ts
var NotFoundError = class _NotFoundError extends RivetError {
  constructor(body) {
    super({
      message: "NotFoundError",
      statusCode: 404,
      body
    });
    Object.setPrototypeOf(this, _NotFoundError.prototype);
  }
};

// src/api/resources/common/errors/BadRequestError.ts
var BadRequestError = class _BadRequestError extends RivetError {
  constructor(body) {
    super({
      message: "BadRequestError",
      statusCode: 400,
      body
    });
    Object.setPrototypeOf(this, _BadRequestError.prototype);
  }
};

// src/api/resources/game/index.ts
var game_exports = {};
__export(game_exports, {
  StatAggregationMethod: () => StatAggregationMethod,
  StatFormatMethod: () => StatFormatMethod,
  StatSortingMethod: () => StatSortingMethod,
  common: () => common_exports13
});

// src/api/resources/game/resources/common/index.ts
var common_exports13 = {};
__export(common_exports13, {
  StatAggregationMethod: () => StatAggregationMethod,
  StatFormatMethod: () => StatFormatMethod,
  StatSortingMethod: () => StatSortingMethod
});

// src/api/resources/game/resources/common/types/StatFormatMethod.ts
var StatFormatMethod = {
  Integer: "integer",
  Float1: "float_1",
  Float2: "float_2",
  Float3: "float_3",
  DurationMinute: "duration_minute",
  DurationSecond: "duration_second",
  DurationHundredthSecond: "duration_hundredth_second"
};

// src/api/resources/game/resources/common/types/StatAggregationMethod.ts
var StatAggregationMethod = {
  Sum: "sum",
  Average: "average",
  Min: "min",
  Max: "max"
};

// src/api/resources/game/resources/common/types/StatSortingMethod.ts
var StatSortingMethod = {
  Desc: "desc",
  Asc: "asc"
};

// src/api/resources/games/index.ts
var games_exports2 = {};
__export(games_exports2, {
  environments: () => environments_exports
});

// src/api/resources/games/resources/environments/index.ts
var environments_exports = {};
__export(environments_exports, {
  tokens: () => tokens_exports3
});

// src/api/resources/games/resources/environments/resources/tokens/index.ts
var tokens_exports3 = {};

// src/api/resources/geo/index.ts
var geo_exports = {};
__export(geo_exports, {
  common: () => common_exports14
});

// src/api/resources/geo/resources/common/index.ts
var common_exports14 = {};

// src/api/resources/matchmaker/index.ts
var matchmaker_exports3 = {};
__export(matchmaker_exports3, {
  CustomLobbyPublicity: () => CustomLobbyPublicity,
  common: () => common_exports15,
  lobbies: () => lobbies_exports,
  players: () => players_exports,
  regions: () => regions_exports2
});

// src/api/resources/matchmaker/resources/common/index.ts
var common_exports15 = {};
__export(common_exports15, {
  CustomLobbyPublicity: () => CustomLobbyPublicity
});

// src/api/resources/matchmaker/resources/common/types/CustomLobbyPublicity.ts
var CustomLobbyPublicity = {
  Public: "public",
  Private: "private"
};

// src/api/resources/matchmaker/resources/lobbies/index.ts
var lobbies_exports = {};

// src/api/resources/matchmaker/resources/players/index.ts
var players_exports = {};

// src/api/resources/matchmaker/resources/regions/index.ts
var regions_exports2 = {};

// src/api/resources/portal/index.ts
var portal_exports = {};
__export(portal_exports, {
  NotificationUnregisterService: () => NotificationUnregisterService,
  common: () => common_exports16,
  games: () => games_exports3
});

// src/api/resources/portal/resources/common/index.ts
var common_exports16 = {};
__export(common_exports16, {
  NotificationUnregisterService: () => NotificationUnregisterService
});

// src/api/resources/portal/resources/common/types/NotificationUnregisterService.ts
var NotificationUnregisterService = {
  Firebase: "firebase"
};

// src/api/resources/portal/resources/games/index.ts
var games_exports3 = {};

// src/api/resources/upload/index.ts
var upload_exports = {};
__export(upload_exports, {
  common: () => common_exports17
});

// src/api/resources/upload/resources/common/index.ts
var common_exports17 = {};

// src/api/resources/job/index.ts
var job_exports = {};
__export(job_exports, {
  run: () => run_exports
});

// src/api/resources/job/resources/run/index.ts
var run_exports = {};

// src/environments.ts
var RivetEnvironment = {
  Production: "https://api.rivet.gg"
};

// src/core/fetcher/createRequestUrl.ts
import qs from "qs";
function createRequestUrl(baseUrl, queryParameters) {
  return Object.keys(queryParameters ?? {}).length > 0 ? `${baseUrl}?${qs.stringify(queryParameters, { arrayFormat: "repeat" })}` : baseUrl;
}

// src/core/runtime/runtime.ts
var RUNTIME = evaluateRuntime();
function evaluateRuntime() {
  const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
  if (isBrowser) {
    return {
      type: "browser",
      version: window.navigator.userAgent
    };
  }
  const isCloudflare = typeof globalThis !== "undefined" && globalThis?.navigator?.userAgent === "Cloudflare-Workers";
  if (isCloudflare) {
    return {
      type: "workerd"
    };
  }
  const isEdgeRuntime = typeof EdgeRuntime === "string";
  if (isEdgeRuntime) {
    return {
      type: "edge-runtime"
    };
  }
  const isWebWorker = typeof self === "object" && // @ts-ignore
  typeof self?.importScripts === "function" && (self.constructor?.name === "DedicatedWorkerGlobalScope" || self.constructor?.name === "ServiceWorkerGlobalScope" || self.constructor?.name === "SharedWorkerGlobalScope");
  if (isWebWorker) {
    return {
      type: "web-worker"
    };
  }
  const isDeno = typeof Deno !== "undefined" && typeof Deno.version !== "undefined" && typeof Deno.version.deno !== "undefined";
  if (isDeno) {
    return {
      type: "deno",
      version: Deno.version.deno
    };
  }
  const isBun = typeof Bun !== "undefined" && typeof Bun.version !== "undefined";
  if (isBun) {
    return {
      type: "bun",
      version: Bun.version
    };
  }
  const isNode = typeof process !== "undefined" && "version" in process && !!process.version && "versions" in process && !!process.versions?.node;
  if (isNode) {
    return {
      type: "node",
      version: process.versions.node,
      parsedVersion: Number(process.versions.node.split(".")[0])
    };
  }
  const isReactNative = typeof navigator !== "undefined" && navigator?.product === "ReactNative";
  if (isReactNative) {
    return {
      type: "react-native"
    };
  }
  return {
    type: "unknown"
  };
}

// src/core/fetcher/getFetchFn.ts
async function getFetchFn() {
  if (RUNTIME.type === "node" && RUNTIME.parsedVersion != null && RUNTIME.parsedVersion >= 18) {
    return fetch;
  }
  if (RUNTIME.type === "node") {
    return (await import("node-fetch")).default;
  }
  if (typeof fetch == "function") {
    return fetch;
  }
  return (await import("node-fetch")).default;
}

// src/core/fetcher/getRequestBody.ts
async function getRequestBody({ body, type }) {
  if (type.includes("json")) {
    return toJson(body);
  } else {
    return body;
  }
}

// src/core/fetcher/stream-wrappers/chooseStreamWrapper.ts
async function chooseStreamWrapper(responseBody) {
  if (RUNTIME.type === "node" && RUNTIME.parsedVersion != null && RUNTIME.parsedVersion >= 18) {
    return new (await Promise.resolve().then(() => (init_Node18UniversalStreamWrapper(), Node18UniversalStreamWrapper_exports))).Node18UniversalStreamWrapper(
      responseBody
    );
  } else if (RUNTIME.type !== "node" && typeof fetch === "function") {
    return new (await Promise.resolve().then(() => (init_UndiciStreamWrapper(), UndiciStreamWrapper_exports))).UndiciStreamWrapper(responseBody);
  } else {
    return new (await Promise.resolve().then(() => (init_NodePre18StreamWrapper(), NodePre18StreamWrapper_exports))).NodePre18StreamWrapper(responseBody);
  }
}

// src/core/fetcher/getResponseBody.ts
async function getResponseBody(response, responseType) {
  if (response.body != null && responseType === "blob") {
    return await response.blob();
  } else if (response.body != null && responseType === "arrayBuffer") {
    return await response.arrayBuffer();
  } else if (response.body != null && responseType === "sse") {
    return response.body;
  } else if (response.body != null && responseType === "streaming") {
    return chooseStreamWrapper(response.body);
  } else if (response.body != null && responseType === "text") {
    return await response.text();
  } else {
    const text = await response.text();
    if (text.length > 0) {
      try {
        let responseBody = JSON.parse(text);
        return responseBody;
      } catch (err) {
        return {
          ok: false,
          error: {
            reason: "non-json",
            statusCode: response.status,
            rawBody: text
          }
        };
      }
    } else {
      return void 0;
    }
  }
}

// src/core/fetcher/signals.ts
var TIMEOUT = "timeout";
function getTimeoutSignal(timeoutMs) {
  const controller = new AbortController();
  const abortId = setTimeout(() => controller.abort(TIMEOUT), timeoutMs);
  return { signal: controller.signal, abortId };
}
function anySignal(...args) {
  const signals = args.length === 1 && Array.isArray(args[0]) ? args[0] : args;
  const controller = new AbortController();
  for (const signal of signals) {
    if (signal.aborted) {
      controller.abort(signal?.reason);
      break;
    }
    signal.addEventListener("abort", () => controller.abort(signal?.reason), {
      signal: controller.signal
    });
  }
  return controller.signal;
}

// src/core/fetcher/makeRequest.ts
var makeRequest = async (fetchFn, url, method, headers, requestBody, timeoutMs, abortSignal, withCredentials, duplex) => {
  const signals = [];
  let timeoutAbortId = void 0;
  if (timeoutMs != null) {
    const { signal, abortId } = getTimeoutSignal(timeoutMs);
    timeoutAbortId = abortId;
    signals.push(signal);
  }
  if (abortSignal != null) {
    signals.push(abortSignal);
  }
  let newSignals = anySignal(signals);
  const response = await fetchFn(url, {
    method,
    headers,
    body: requestBody,
    signal: newSignals,
    credentials: withCredentials ? "include" : void 0,
    // @ts-ignore
    duplex
  });
  if (timeoutAbortId != null) {
    clearTimeout(timeoutAbortId);
  }
  return response;
};

// src/core/fetcher/requestWithRetries.ts
var INITIAL_RETRY_DELAY = 1e3;
var MAX_RETRY_DELAY = 6e4;
var DEFAULT_MAX_RETRIES = 2;
var JITTER_FACTOR = 0.2;
function addJitter(delay) {
  const jitterMultiplier = 1 + (Math.random() * 2 - 1) * JITTER_FACTOR;
  return delay * jitterMultiplier;
}
async function requestWithRetries(requestFn, maxRetries = DEFAULT_MAX_RETRIES) {
  let response = await requestFn();
  for (let i = 0; i < maxRetries; ++i) {
    if ([408, 429].includes(response.status) || response.status >= 500) {
      const baseDelay = Math.min(INITIAL_RETRY_DELAY * Math.pow(2, i), MAX_RETRY_DELAY);
      const delayWithJitter = addJitter(baseDelay);
      await new Promise((resolve) => setTimeout(resolve, delayWithJitter));
      response = await requestFn();
    } else {
      break;
    }
  }
  return response;
}

// src/core/fetcher/Fetcher.ts
async function fetcherImpl(args) {
  const headers = {};
  if (args.body !== void 0 && args.contentType != null) {
    headers["Content-Type"] = args.contentType;
  }
  if (args.headers != null) {
    for (const [key, value] of Object.entries(args.headers)) {
      if (value != null) {
        headers[key] = value;
      }
    }
  }
  const url = createRequestUrl(args.url, args.queryParameters);
  const requestBody = await getRequestBody({
    body: args.body,
    type: args.requestType === "json" ? "json" : "other"
  });
  const fetchFn = await getFetchFn();
  try {
    const response = await requestWithRetries(
      async () => makeRequest(
        fetchFn,
        url,
        args.method,
        headers,
        requestBody,
        args.timeoutMs,
        args.abortSignal,
        args.withCredentials,
        args.duplex
      ),
      args.maxRetries
    );
    const responseBody = await getResponseBody(response, args.responseType);
    if (response.status >= 200 && response.status < 400) {
      return {
        ok: true,
        body: responseBody,
        headers: response.headers
      };
    } else {
      return {
        ok: false,
        error: {
          reason: "status-code",
          statusCode: response.status,
          body: responseBody
        }
      };
    }
  } catch (error) {
    if (args.abortSignal != null && args.abortSignal.aborted) {
      return {
        ok: false,
        error: {
          reason: "unknown",
          errorMessage: "The user aborted a request"
        }
      };
    } else if (error instanceof Error && error.name === "AbortError") {
      return {
        ok: false,
        error: {
          reason: "timeout"
        }
      };
    } else if (error instanceof Error) {
      return {
        ok: false,
        error: {
          reason: "unknown",
          errorMessage: error.message
        }
      };
    }
    return {
      ok: false,
      error: {
        reason: "unknown",
        errorMessage: toJson(error)
      }
    };
  }
}
var fetcher = fetcherImpl;

// src/core/fetcher/Supplier.ts
var Supplier = {
  get: async (supplier) => {
    if (typeof supplier === "function") {
      return supplier();
    } else {
      return supplier;
    }
  }
};

// src/core/auth/BasicAuth.ts
import { Base64 } from "js-base64";

// src/core/schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  JsonError: () => JsonError,
  ParseError: () => ParseError,
  any: () => any,
  bigint: () => bigint,
  boolean: () => boolean,
  booleanLiteral: () => booleanLiteral,
  date: () => date,
  discriminant: () => discriminant,
  enum_: () => enum_,
  getObjectLikeUtils: () => getObjectLikeUtils,
  getObjectUtils: () => getObjectUtils,
  getSchemaUtils: () => getSchemaUtils,
  isProperty: () => isProperty,
  lazy: () => lazy,
  lazyObject: () => lazyObject,
  list: () => list,
  number: () => number,
  object: () => object,
  objectWithoutOptionalProperties: () => objectWithoutOptionalProperties,
  optional: () => optional,
  property: () => property,
  record: () => record,
  set: () => set,
  string: () => string,
  stringLiteral: () => stringLiteral,
  transform: () => transform,
  undiscriminatedUnion: () => undiscriminatedUnion,
  union: () => union,
  unknown: () => unknown,
  withParsedProperties: () => withParsedProperties
});

// src/core/schemas/Schema.ts
var SchemaType = {
  BIGINT: "bigint",
  DATE: "date",
  ENUM: "enum",
  LIST: "list",
  STRING_LITERAL: "stringLiteral",
  BOOLEAN_LITERAL: "booleanLiteral",
  OBJECT: "object",
  ANY: "any",
  BOOLEAN: "boolean",
  NUMBER: "number",
  STRING: "string",
  UNKNOWN: "unknown",
  RECORD: "record",
  SET: "set",
  UNION: "union",
  UNDISCRIMINATED_UNION: "undiscriminatedUnion",
  NULLABLE: "nullable",
  OPTIONAL: "optional",
  OPTIONAL_NULLABLE: "optionalNullable"
};

// src/core/schemas/utils/getErrorMessageForIncorrectType.ts
function getErrorMessageForIncorrectType(value, expectedType) {
  return `Expected ${expectedType}. Received ${getTypeAsString(value)}.`;
}
function getTypeAsString(value) {
  if (Array.isArray(value)) {
    return "list";
  }
  if (value === null) {
    return "null";
  }
  if (value instanceof BigInt) {
    return "BigInt";
  }
  switch (typeof value) {
    case "string":
      return `"${value}"`;
    case "bigint":
    case "number":
    case "boolean":
    case "undefined":
      return `${value}`;
  }
  return typeof value;
}

// src/core/schemas/utils/maybeSkipValidation.ts
function maybeSkipValidation(schema) {
  return {
    ...schema,
    json: transformAndMaybeSkipValidation(schema.json),
    parse: transformAndMaybeSkipValidation(schema.parse)
  };
}
function transformAndMaybeSkipValidation(transform2) {
  return (value, opts) => {
    const transformed = transform2(value, opts);
    const { skipValidation = false } = opts ?? {};
    if (!transformed.ok && skipValidation) {
      console.warn(
        [
          "Failed to validate.",
          ...transformed.errors.map(
            (error) => "  - " + (error.path.length > 0 ? `${error.path.join(".")}: ${error.message}` : error.message)
          )
        ].join("\n")
      );
      return {
        ok: true,
        value
      };
    } else {
      return transformed;
    }
  };
}

// src/core/schemas/builders/schema-utils/stringifyValidationErrors.ts
function stringifyValidationError(error) {
  if (error.path.length === 0) {
    return error.message;
  }
  return `${error.path.join(" -> ")}: ${error.message}`;
}

// src/core/schemas/builders/schema-utils/JsonError.ts
var JsonError = class _JsonError extends Error {
  constructor(errors) {
    super(errors.map(stringifyValidationError).join("; "));
    this.errors = errors;
    Object.setPrototypeOf(this, _JsonError.prototype);
  }
};

// src/core/schemas/builders/schema-utils/ParseError.ts
var ParseError = class _ParseError extends Error {
  constructor(errors) {
    super(errors.map(stringifyValidationError).join("; "));
    this.errors = errors;
    Object.setPrototypeOf(this, _ParseError.prototype);
  }
};

// src/core/schemas/builders/schema-utils/getSchemaUtils.ts
function getSchemaUtils(schema) {
  return {
    nullable: () => nullable(schema),
    optional: () => optional(schema),
    optionalNullable: () => optionalNullable(schema),
    transform: (transformer) => transform(schema, transformer),
    parseOrThrow: (raw, opts) => {
      const parsed = schema.parse(raw, opts);
      if (parsed.ok) {
        return parsed.value;
      }
      throw new ParseError(parsed.errors);
    },
    jsonOrThrow: (parsed, opts) => {
      const raw = schema.json(parsed, opts);
      if (raw.ok) {
        return raw.value;
      }
      throw new JsonError(raw.errors);
    }
  };
}
function nullable(schema) {
  const baseSchema = {
    parse: (raw, opts) => {
      if (raw == null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.parse(raw, opts);
    },
    json: (parsed, opts) => {
      if (parsed == null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.json(parsed, opts);
    },
    getType: () => SchemaType.NULLABLE
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function optional(schema) {
  const baseSchema = {
    parse: (raw, opts) => {
      if (raw == null) {
        return {
          ok: true,
          value: void 0
        };
      }
      return schema.parse(raw, opts);
    },
    json: (parsed, opts) => {
      if (opts?.omitUndefined && parsed === void 0) {
        return {
          ok: true,
          value: void 0
        };
      }
      if (parsed == null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.json(parsed, opts);
    },
    getType: () => SchemaType.OPTIONAL
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function optionalNullable(schema) {
  const baseSchema = {
    parse: (raw, opts) => {
      if (raw === void 0) {
        return {
          ok: true,
          value: void 0
        };
      }
      if (raw === null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.parse(raw, opts);
    },
    json: (parsed, opts) => {
      if (parsed === void 0) {
        return {
          ok: true,
          value: void 0
        };
      }
      if (parsed === null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.json(parsed, opts);
    },
    getType: () => SchemaType.OPTIONAL_NULLABLE
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function transform(schema, transformer) {
  const baseSchema = {
    parse: (raw, opts) => {
      const parsed = schema.parse(raw, opts);
      if (!parsed.ok) {
        return parsed;
      }
      return {
        ok: true,
        value: transformer.transform(parsed.value)
      };
    },
    json: (transformed, opts) => {
      const parsed = transformer.untransform(transformed);
      return schema.json(parsed, opts);
    },
    getType: () => schema.getType()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}

// src/core/schemas/builders/bigint/bigint.ts
function bigint() {
  const baseSchema = {
    parse: (raw, { breadcrumbsPrefix = [] } = {}) => {
      if (typeof raw === "bigint") {
        return {
          ok: true,
          value: raw
        };
      }
      if (typeof raw === "number") {
        return {
          ok: true,
          value: BigInt(raw)
        };
      }
      return {
        ok: false,
        errors: [
          {
            path: breadcrumbsPrefix,
            message: getErrorMessageForIncorrectType(raw, "bigint | number")
          }
        ]
      };
    },
    json: (bigint2, { breadcrumbsPrefix = [] } = {}) => {
      if (typeof bigint2 !== "bigint") {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(bigint2, "bigint")
            }
          ]
        };
      }
      return {
        ok: true,
        value: bigint2
      };
    },
    getType: () => SchemaType.BIGINT
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}

// src/core/schemas/builders/date/date.ts
var ISO_8601_REGEX = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function date() {
  const baseSchema = {
    parse: (raw, { breadcrumbsPrefix = [] } = {}) => {
      if (typeof raw !== "string") {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(raw, "string")
            }
          ]
        };
      }
      if (!ISO_8601_REGEX.test(raw)) {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(raw, "ISO 8601 date string")
            }
          ]
        };
      }
      return {
        ok: true,
        value: new Date(raw)
      };
    },
    json: (date2, { breadcrumbsPrefix = [] } = {}) => {
      if (date2 instanceof Date) {
        return {
          ok: true,
          value: date2.toISOString()
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(date2, "Date object")
            }
          ]
        };
      }
    },
    getType: () => SchemaType.DATE
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}

// src/core/schemas/utils/createIdentitySchemaCreator.ts
function createIdentitySchemaCreator(schemaType, validate) {
  return () => {
    const baseSchema = {
      parse: validate,
      json: validate,
      getType: () => schemaType
    };
    return {
      ...maybeSkipValidation(baseSchema),
      ...getSchemaUtils(baseSchema)
    };
  };
}

// src/core/schemas/builders/enum/enum.ts
function enum_(values) {
  const validValues = new Set(values);
  const schemaCreator = createIdentitySchemaCreator(
    SchemaType.ENUM,
    (value, { allowUnrecognizedEnumValues, breadcrumbsPrefix = [] } = {}) => {
      if (typeof value !== "string") {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(value, "string")
            }
          ]
        };
      }
      if (!validValues.has(value) && !allowUnrecognizedEnumValues) {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(value, "enum")
            }
          ]
        };
      }
      return {
        ok: true,
        value
      };
    }
  );
  return schemaCreator();
}

// src/core/schemas/builders/lazy/lazy.ts
function lazy(getter) {
  const baseSchema = constructLazyBaseSchema(getter);
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function constructLazyBaseSchema(getter) {
  return {
    parse: (raw, opts) => getMemoizedSchema(getter).parse(raw, opts),
    json: (parsed, opts) => getMemoizedSchema(getter).json(parsed, opts),
    getType: () => getMemoizedSchema(getter).getType()
  };
}
function getMemoizedSchema(getter) {
  const castedGetter = getter;
  if (castedGetter.__zurg_memoized == null) {
    castedGetter.__zurg_memoized = getter();
  }
  return castedGetter.__zurg_memoized;
}

// src/core/schemas/utils/entries.ts
function entries(object2) {
  return Object.entries(object2);
}

// src/core/schemas/utils/filterObject.ts
function filterObject(obj, keysToInclude) {
  const keysToIncludeSet = new Set(keysToInclude);
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (keysToIncludeSet.has(key)) {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
}

// src/core/schemas/utils/isPlainObject.ts
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  let proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(value) === proto;
}

// src/core/schemas/utils/keys.ts
function keys(object2) {
  return Object.keys(object2);
}

// src/core/schemas/utils/partition.ts
function partition(items, predicate) {
  const trueItems = [], falseItems = [];
  for (const item of items) {
    if (predicate(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  }
  return [trueItems, falseItems];
}

// src/core/schemas/builders/object-like/getObjectLikeUtils.ts
function getObjectLikeUtils(schema) {
  return {
    withParsedProperties: (properties) => withParsedProperties(schema, properties)
  };
}
function withParsedProperties(objectLike, properties) {
  const objectSchema = {
    parse: (raw, opts) => {
      const parsedObject = objectLike.parse(raw, opts);
      if (!parsedObject.ok) {
        return parsedObject;
      }
      const additionalProperties = Object.entries(properties).reduce(
        (processed, [key, value]) => {
          return {
            ...processed,
            [key]: typeof value === "function" ? value(parsedObject.value) : value
          };
        },
        {}
      );
      return {
        ok: true,
        value: {
          ...parsedObject.value,
          ...additionalProperties
        }
      };
    },
    json: (parsed, opts) => {
      if (!isPlainObject(parsed)) {
        return {
          ok: false,
          errors: [
            {
              path: opts?.breadcrumbsPrefix ?? [],
              message: getErrorMessageForIncorrectType(parsed, "object")
            }
          ]
        };
      }
      const addedPropertyKeys = new Set(Object.keys(properties));
      const parsedWithoutAddedProperties = filterObject(
        parsed,
        Object.keys(parsed).filter((key) => !addedPropertyKeys.has(key))
      );
      return objectLike.json(parsedWithoutAddedProperties, opts);
    },
    getType: () => objectLike.getType()
  };
  return {
    ...objectSchema,
    ...getSchemaUtils(objectSchema),
    ...getObjectLikeUtils(objectSchema)
  };
}

// src/core/schemas/builders/object/property.ts
function property(rawKey, valueSchema) {
  return {
    rawKey,
    valueSchema,
    isProperty: true
  };
}
function isProperty(maybeProperty) {
  return maybeProperty.isProperty;
}

// src/core/schemas/builders/object/object.ts
function object(schemas) {
  const baseSchema = {
    _getRawProperties: () => Object.entries(schemas).map(
      ([parsedKey, propertySchema]) => isProperty(propertySchema) ? propertySchema.rawKey : parsedKey
    ),
    _getParsedProperties: () => keys(schemas),
    parse: (raw, opts) => {
      const rawKeyToProperty = {};
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const rawKey = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.rawKey : parsedKey;
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        const property2 = {
          rawKey,
          parsedKey,
          valueSchema
        };
        rawKeyToProperty[rawKey] = property2;
        if (isSchemaRequired(valueSchema)) {
          requiredKeys.push(rawKey);
        }
      }
      return validateAndTransformObject({
        value: raw,
        requiredKeys,
        getProperty: (rawKey) => {
          const property2 = rawKeyToProperty[rawKey];
          if (property2 == null) {
            return void 0;
          }
          return {
            transformedKey: property2.parsedKey,
            transform: (propertyValue) => property2.valueSchema.parse(propertyValue, {
              ...opts,
              breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], rawKey]
            })
          };
        },
        unrecognizedObjectKeys: opts?.unrecognizedObjectKeys,
        skipValidation: opts?.skipValidation,
        breadcrumbsPrefix: opts?.breadcrumbsPrefix,
        omitUndefined: opts?.omitUndefined
      });
    },
    json: (parsed, opts) => {
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        if (isSchemaRequired(valueSchema)) {
          requiredKeys.push(parsedKey);
        }
      }
      return validateAndTransformObject({
        value: parsed,
        requiredKeys,
        getProperty: (parsedKey) => {
          const property2 = schemas[parsedKey];
          if (property2 == null) {
            return void 0;
          }
          if (isProperty(property2)) {
            return {
              transformedKey: property2.rawKey,
              transform: (propertyValue) => property2.valueSchema.json(propertyValue, {
                ...opts,
                breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], parsedKey]
              })
            };
          } else {
            return {
              transformedKey: parsedKey,
              transform: (propertyValue) => property2.json(propertyValue, {
                ...opts,
                breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], parsedKey]
              })
            };
          }
        },
        unrecognizedObjectKeys: opts?.unrecognizedObjectKeys,
        skipValidation: opts?.skipValidation,
        breadcrumbsPrefix: opts?.breadcrumbsPrefix,
        omitUndefined: opts?.omitUndefined
      });
    },
    getType: () => SchemaType.OBJECT
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
function validateAndTransformObject({
  value,
  requiredKeys,
  getProperty,
  unrecognizedObjectKeys = "fail",
  skipValidation = false,
  breadcrumbsPrefix = []
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: breadcrumbsPrefix,
          message: getErrorMessageForIncorrectType(value, "object")
        }
      ]
    };
  }
  const missingRequiredKeys = new Set(requiredKeys);
  const errors = [];
  const transformed = {};
  for (const [preTransformedKey, preTransformedItemValue] of Object.entries(value)) {
    const property2 = getProperty(preTransformedKey);
    if (property2 != null) {
      missingRequiredKeys.delete(preTransformedKey);
      const value2 = property2.transform(preTransformedItemValue);
      if (value2.ok) {
        transformed[property2.transformedKey] = value2.value;
      } else {
        transformed[preTransformedKey] = preTransformedItemValue;
        errors.push(...value2.errors);
      }
    } else {
      switch (unrecognizedObjectKeys) {
        case "fail":
          errors.push({
            path: [...breadcrumbsPrefix, preTransformedKey],
            message: `Unexpected key "${preTransformedKey}"`
          });
          break;
        case "strip":
          break;
        case "passthrough":
          transformed[preTransformedKey] = preTransformedItemValue;
          break;
      }
    }
  }
  errors.push(
    ...requiredKeys.filter((key) => missingRequiredKeys.has(key)).map((key) => ({
      path: breadcrumbsPrefix,
      message: `Missing required key "${key}"`
    }))
  );
  if (errors.length === 0 || skipValidation) {
    return {
      ok: true,
      value: transformed
    };
  } else {
    return {
      ok: false,
      errors
    };
  }
}
function getObjectUtils(schema) {
  return {
    extend: (extension) => {
      const baseSchema = {
        _getParsedProperties: () => [...schema._getParsedProperties(), ...extension._getParsedProperties()],
        _getRawProperties: () => [...schema._getRawProperties(), ...extension._getRawProperties()],
        parse: (raw, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: extension._getRawProperties(),
            value: raw,
            transformBase: (rawBase) => schema.parse(rawBase, opts),
            transformExtension: (rawExtension) => extension.parse(rawExtension, opts)
          });
        },
        json: (parsed, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: extension._getParsedProperties(),
            value: parsed,
            transformBase: (parsedBase) => schema.json(parsedBase, opts),
            transformExtension: (parsedExtension) => extension.json(parsedExtension, opts)
          });
        },
        getType: () => SchemaType.OBJECT
      };
      return {
        ...baseSchema,
        ...getSchemaUtils(baseSchema),
        ...getObjectLikeUtils(baseSchema),
        ...getObjectUtils(baseSchema)
      };
    },
    passthrough: () => {
      const baseSchema = {
        _getParsedProperties: () => schema._getParsedProperties(),
        _getRawProperties: () => schema._getRawProperties(),
        parse: (raw, opts) => {
          const transformed = schema.parse(raw, { ...opts, unrecognizedObjectKeys: "passthrough" });
          if (!transformed.ok) {
            return transformed;
          }
          return {
            ok: true,
            value: {
              ...raw,
              ...transformed.value
            }
          };
        },
        json: (parsed, opts) => {
          const transformed = schema.json(parsed, { ...opts, unrecognizedObjectKeys: "passthrough" });
          if (!transformed.ok) {
            return transformed;
          }
          return {
            ok: true,
            value: {
              ...parsed,
              ...transformed.value
            }
          };
        },
        getType: () => SchemaType.OBJECT
      };
      return {
        ...baseSchema,
        ...getSchemaUtils(baseSchema),
        ...getObjectLikeUtils(baseSchema),
        ...getObjectUtils(baseSchema)
      };
    }
  };
}
function validateAndTransformExtendedObject({
  extensionKeys,
  value,
  transformBase,
  transformExtension
}) {
  const extensionPropertiesSet = new Set(extensionKeys);
  const [extensionProperties, baseProperties] = partition(
    keys(value),
    (key) => extensionPropertiesSet.has(key)
  );
  const transformedBase = transformBase(filterObject(value, baseProperties));
  const transformedExtension = transformExtension(filterObject(value, extensionProperties));
  if (transformedBase.ok && transformedExtension.ok) {
    return {
      ok: true,
      value: {
        ...transformedBase.value,
        ...transformedExtension.value
      }
    };
  } else {
    return {
      ok: false,
      errors: [
        ...transformedBase.ok ? [] : transformedBase.errors,
        ...transformedExtension.ok ? [] : transformedExtension.errors
      ]
    };
  }
}
function isSchemaRequired(schema) {
  return !isSchemaOptional(schema);
}
function isSchemaOptional(schema) {
  switch (schema.getType()) {
    case SchemaType.ANY:
    case SchemaType.UNKNOWN:
    case SchemaType.OPTIONAL:
    case SchemaType.OPTIONAL_NULLABLE:
      return true;
    default:
      return false;
  }
}

// src/core/schemas/builders/object/objectWithoutOptionalProperties.ts
function objectWithoutOptionalProperties(schemas) {
  return object(schemas);
}

// src/core/schemas/builders/lazy/lazyObject.ts
function lazyObject(getter) {
  const baseSchema = {
    ...constructLazyBaseSchema(getter),
    _getRawProperties: () => getMemoizedSchema(getter)._getRawProperties(),
    _getParsedProperties: () => getMemoizedSchema(getter)._getParsedProperties()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}

// src/core/schemas/builders/list/list.ts
function list(schema) {
  const baseSchema = {
    parse: (raw, opts) => validateAndTransformArray(
      raw,
      (item, index) => schema.parse(item, {
        ...opts,
        breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `[${index}]`]
      })
    ),
    json: (parsed, opts) => validateAndTransformArray(
      parsed,
      (item, index) => schema.json(item, {
        ...opts,
        breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `[${index}]`]
      })
    ),
    getType: () => SchemaType.LIST
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}
function validateAndTransformArray(value, transformItem) {
  if (!Array.isArray(value)) {
    return {
      ok: false,
      errors: [
        {
          message: getErrorMessageForIncorrectType(value, "list"),
          path: []
        }
      ]
    };
  }
  const maybeValidItems = value.map((item, index) => transformItem(item, index));
  return maybeValidItems.reduce(
    (acc, item) => {
      if (acc.ok && item.ok) {
        return {
          ok: true,
          value: [...acc.value, item.value]
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!item.ok) {
        errors.push(...item.errors);
      }
      return {
        ok: false,
        errors
      };
    },
    { ok: true, value: [] }
  );
}

// src/core/schemas/builders/literals/stringLiteral.ts
function stringLiteral(literal) {
  const schemaCreator = createIdentitySchemaCreator(
    SchemaType.STRING_LITERAL,
    (value, { breadcrumbsPrefix = [] } = {}) => {
      if (value === literal) {
        return {
          ok: true,
          value: literal
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(value, `"${literal}"`)
            }
          ]
        };
      }
    }
  );
  return schemaCreator();
}

// src/core/schemas/builders/literals/booleanLiteral.ts
function booleanLiteral(literal) {
  const schemaCreator = createIdentitySchemaCreator(
    SchemaType.BOOLEAN_LITERAL,
    (value, { breadcrumbsPrefix = [] } = {}) => {
      if (value === literal) {
        return {
          ok: true,
          value: literal
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: breadcrumbsPrefix,
              message: getErrorMessageForIncorrectType(value, `${literal.toString()}`)
            }
          ]
        };
      }
    }
  );
  return schemaCreator();
}

// src/core/schemas/builders/primitives/any.ts
var any = createIdentitySchemaCreator(SchemaType.ANY, (value) => ({ ok: true, value }));

// src/core/schemas/builders/primitives/boolean.ts
var boolean = createIdentitySchemaCreator(
  SchemaType.BOOLEAN,
  (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "boolean") {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: breadcrumbsPrefix,
            message: getErrorMessageForIncorrectType(value, "boolean")
          }
        ]
      };
    }
  }
);

// src/core/schemas/builders/primitives/number.ts
var number = createIdentitySchemaCreator(
  SchemaType.NUMBER,
  (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "number") {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: breadcrumbsPrefix,
            message: getErrorMessageForIncorrectType(value, "number")
          }
        ]
      };
    }
  }
);

// src/core/schemas/builders/primitives/string.ts
var string = createIdentitySchemaCreator(
  SchemaType.STRING,
  (value, { breadcrumbsPrefix = [] } = {}) => {
    if (typeof value === "string") {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: breadcrumbsPrefix,
            message: getErrorMessageForIncorrectType(value, "string")
          }
        ]
      };
    }
  }
);

// src/core/schemas/builders/primitives/unknown.ts
var unknown = createIdentitySchemaCreator(SchemaType.UNKNOWN, (value) => ({ ok: true, value }));

// src/core/schemas/builders/record/record.ts
function record(keySchema, valueSchema) {
  const baseSchema = {
    parse: (raw, opts) => {
      return validateAndTransformRecord({
        value: raw,
        isKeyNumeric: keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.parse(key, {
          ...opts,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `${key} (key)`]
        }),
        transformValue: (value, key) => valueSchema.parse(value, {
          ...opts,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `${key}`]
        }),
        breadcrumbsPrefix: opts?.breadcrumbsPrefix
      });
    },
    json: (parsed, opts) => {
      return validateAndTransformRecord({
        value: parsed,
        isKeyNumeric: keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.json(key, {
          ...opts,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `${key} (key)`]
        }),
        transformValue: (value, key) => valueSchema.json(value, {
          ...opts,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], `${key}`]
        }),
        breadcrumbsPrefix: opts?.breadcrumbsPrefix
      });
    },
    getType: () => SchemaType.RECORD
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}
function validateAndTransformRecord({
  value,
  isKeyNumeric,
  transformKey,
  transformValue,
  breadcrumbsPrefix = []
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: breadcrumbsPrefix,
          message: getErrorMessageForIncorrectType(value, "object")
        }
      ]
    };
  }
  return entries(value).reduce(
    (accPromise, [stringKey, value2]) => {
      if (value2 === void 0) {
        return accPromise;
      }
      const acc = accPromise;
      let key = stringKey;
      if (isKeyNumeric) {
        const numberKey = stringKey.length > 0 ? Number(stringKey) : NaN;
        if (!isNaN(numberKey)) {
          key = numberKey;
        }
      }
      const transformedKey = transformKey(key);
      const transformedValue = transformValue(value2, key);
      if (acc.ok && transformedKey.ok && transformedValue.ok) {
        return {
          ok: true,
          value: {
            ...acc.value,
            [transformedKey.value]: transformedValue.value
          }
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!transformedKey.ok) {
        errors.push(...transformedKey.errors);
      }
      if (!transformedValue.ok) {
        errors.push(...transformedValue.errors);
      }
      return {
        ok: false,
        errors
      };
    },
    { ok: true, value: {} }
  );
}

// src/core/schemas/builders/set/set.ts
function set(schema) {
  const listSchema = list(schema);
  const baseSchema = {
    parse: (raw, opts) => {
      const parsedList = listSchema.parse(raw, opts);
      if (parsedList.ok) {
        return {
          ok: true,
          value: new Set(parsedList.value)
        };
      } else {
        return parsedList;
      }
    },
    json: (parsed, opts) => {
      if (!(parsed instanceof Set)) {
        return {
          ok: false,
          errors: [
            {
              path: opts?.breadcrumbsPrefix ?? [],
              message: getErrorMessageForIncorrectType(parsed, "Set")
            }
          ]
        };
      }
      const jsonList = listSchema.json([...parsed], opts);
      return jsonList;
    },
    getType: () => SchemaType.SET
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}

// src/core/schemas/builders/undiscriminated-union/undiscriminatedUnion.ts
function undiscriminatedUnion(schemas) {
  const baseSchema = {
    parse: (raw, opts) => {
      return validateAndTransformUndiscriminatedUnion(
        (schema, opts2) => schema.parse(raw, opts2),
        schemas,
        opts
      );
    },
    json: (parsed, opts) => {
      return validateAndTransformUndiscriminatedUnion(
        (schema, opts2) => schema.json(parsed, opts2),
        schemas,
        opts
      );
    },
    getType: () => SchemaType.UNDISCRIMINATED_UNION
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema)
  };
}
function validateAndTransformUndiscriminatedUnion(transform2, schemas, opts) {
  const errors = [];
  for (const [index, schema] of schemas.entries()) {
    const transformed = transform2(schema, { ...opts, skipValidation: false });
    if (transformed.ok) {
      return transformed;
    } else {
      for (const error of transformed.errors) {
        errors.push({
          path: error.path,
          message: `[Variant ${index}] ${error.message}`
        });
      }
    }
  }
  return {
    ok: false,
    errors
  };
}

// src/core/schemas/builders/union/discriminant.ts
function discriminant(parsedDiscriminant, rawDiscriminant) {
  return {
    parsedDiscriminant,
    rawDiscriminant
  };
}

// src/core/schemas/builders/union/union.ts
function union(discriminant2, union2) {
  const rawDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.rawDiscriminant;
  const parsedDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.parsedDiscriminant;
  const discriminantValueSchema = enum_(keys(union2));
  const baseSchema = {
    parse: (raw, opts) => {
      return transformAndValidateUnion({
        value: raw,
        discriminant: rawDiscriminant,
        transformedDiscriminant: parsedDiscriminant,
        transformDiscriminantValue: (discriminantValue) => discriminantValueSchema.parse(discriminantValue, {
          allowUnrecognizedEnumValues: opts?.allowUnrecognizedUnionMembers,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], rawDiscriminant]
        }),
        getAdditionalPropertiesSchema: (discriminantValue) => union2[discriminantValue],
        allowUnrecognizedUnionMembers: opts?.allowUnrecognizedUnionMembers,
        transformAdditionalProperties: (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.parse(additionalProperties, opts),
        breadcrumbsPrefix: opts?.breadcrumbsPrefix
      });
    },
    json: (parsed, opts) => {
      return transformAndValidateUnion({
        value: parsed,
        discriminant: parsedDiscriminant,
        transformedDiscriminant: rawDiscriminant,
        transformDiscriminantValue: (discriminantValue) => discriminantValueSchema.json(discriminantValue, {
          allowUnrecognizedEnumValues: opts?.allowUnrecognizedUnionMembers,
          breadcrumbsPrefix: [...opts?.breadcrumbsPrefix ?? [], parsedDiscriminant]
        }),
        getAdditionalPropertiesSchema: (discriminantValue) => union2[discriminantValue],
        allowUnrecognizedUnionMembers: opts?.allowUnrecognizedUnionMembers,
        transformAdditionalProperties: (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.json(additionalProperties, opts),
        breadcrumbsPrefix: opts?.breadcrumbsPrefix
      });
    },
    getType: () => SchemaType.UNION
  };
  return {
    ...maybeSkipValidation(baseSchema),
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema)
  };
}
function transformAndValidateUnion({
  value,
  discriminant: discriminant2,
  transformedDiscriminant,
  transformDiscriminantValue,
  getAdditionalPropertiesSchema,
  allowUnrecognizedUnionMembers = false,
  transformAdditionalProperties,
  breadcrumbsPrefix = []
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: breadcrumbsPrefix,
          message: getErrorMessageForIncorrectType(value, "object")
        }
      ]
    };
  }
  const { [discriminant2]: discriminantValue, ...additionalProperties } = value;
  if (discriminantValue == null) {
    return {
      ok: false,
      errors: [
        {
          path: breadcrumbsPrefix,
          message: `Missing discriminant ("${discriminant2}")`
        }
      ]
    };
  }
  const transformedDiscriminantValue = transformDiscriminantValue(discriminantValue);
  if (!transformedDiscriminantValue.ok) {
    return {
      ok: false,
      errors: transformedDiscriminantValue.errors
    };
  }
  const additionalPropertiesSchema = getAdditionalPropertiesSchema(transformedDiscriminantValue.value);
  if (additionalPropertiesSchema == null) {
    if (allowUnrecognizedUnionMembers) {
      return {
        ok: true,
        value: {
          [transformedDiscriminant]: transformedDiscriminantValue.value,
          ...additionalProperties
        }
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [...breadcrumbsPrefix, discriminant2],
            message: "Unexpected discriminant value"
          }
        ]
      };
    }
  }
  const transformedAdditionalProperties = transformAdditionalProperties(
    additionalProperties,
    additionalPropertiesSchema
  );
  if (!transformedAdditionalProperties.ok) {
    return transformedAdditionalProperties;
  }
  return {
    ok: true,
    value: {
      [transformedDiscriminant]: discriminantValue,
      ...transformedAdditionalProperties.value
    }
  };
}

// src/serialization/index.ts
var serialization_exports = {};
__export(serialization_exports, {
  AccountNumber: () => AccountNumber,
  Bio: () => Bio,
  DisplayName: () => DisplayName,
  Email: () => Email,
  EmptyObject: () => EmptyObject,
  ErrorBody: () => ErrorBody,
  ErrorMetadata: () => ErrorMetadata,
  GlobalEventNotification: () => GlobalEventNotification2,
  Identifier: () => Identifier,
  Jwt: () => Jwt,
  Pagination: () => Pagination,
  Timestamp: () => Timestamp,
  ValidationError: () => ValidationError5,
  WatchQuery: () => WatchQuery,
  WatchResponse: () => WatchResponse,
  actors: () => actors_exports2,
  auth: () => auth_exports4,
  builds: () => builds_exports4,
  captcha: () => captcha_exports2,
  cloud: () => cloud_exports2,
  common: () => common_exports29,
  coreIntercom: () => coreIntercom_exports2,
  edgeIntercom: () => edgeIntercom_exports2,
  game: () => game_exports2,
  games: () => games_exports5,
  geo: () => geo_exports2,
  group: () => group_exports2,
  identity: () => identity_exports5,
  matchmaker: () => matchmaker_exports6,
  portal: () => portal_exports2,
  provision: () => provision_exports2,
  regions: () => regions_exports3,
  routes: () => routes_exports2,
  servers: () => servers_exports4,
  upload: () => upload_exports2
});

// src/serialization/resources/actors/index.ts
var actors_exports2 = {};
__export(actors_exports2, {
  Actor: () => Actor,
  CreateActorNetworkRequest: () => CreateActorNetworkRequest,
  CreateActorPortRequest: () => CreateActorPortRequest,
  CreateActorRequest: () => CreateActorRequest,
  CreateActorResponse: () => CreateActorResponse,
  CreateActorRuntimeNetworkRequest: () => CreateActorRuntimeNetworkRequest,
  CreateActorRuntimeRequest: () => CreateActorRuntimeRequest,
  DestroyActorResponse: () => DestroyActorResponse,
  EndpointType: () => EndpointType2,
  ExportActorLogsRequest: () => ExportActorLogsRequest,
  ExportActorLogsResponse: () => ExportActorLogsResponse,
  GetActorLogsResponse: () => GetActorLogsResponse,
  GetActorMetricsResponse: () => GetActorMetricsResponse,
  GetActorResponse: () => GetActorResponse,
  GetActorUsageResponse: () => GetActorUsageResponse,
  GuardRouting: () => GuardRouting,
  HostRouting: () => HostRouting,
  Lifecycle: () => Lifecycle,
  ListActorsResponse: () => ListActorsResponse,
  Network: () => Network,
  NetworkMode: () => NetworkMode4,
  Port: () => Port,
  PortProtocol: () => PortProtocol4,
  PortRouting: () => PortRouting,
  QueryActorsResponse: () => QueryActorsResponse,
  Resources: () => Resources,
  Runtime: () => Runtime,
  UpgradeActorRequest: () => UpgradeActorRequest,
  UpgradeActorResponse: () => UpgradeActorResponse,
  UpgradeAllActorsRequest: () => UpgradeAllActorsRequest,
  UpgradeAllActorsResponse: () => UpgradeAllActorsResponse,
  common: () => common_exports18,
  logs: () => logs_exports5,
  metrics: () => metrics_exports2
});

// src/serialization/resources/actors/resources/common/types/Runtime.ts
var Runtime = schemas_exports.object({
  build: schemas_exports.string(),
  arguments: schemas_exports.list(schemas_exports.string()).optional(),
  environment: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional()
});

// src/serialization/resources/actors/resources/common/types/NetworkMode.ts
var NetworkMode4 = schemas_exports.enum_(["bridge", "host"]);

// src/serialization/resources/actors/resources/common/types/PortProtocol.ts
var PortProtocol4 = schemas_exports.enum_(["http", "https", "tcp", "tcp_tls", "udp"]);

// src/serialization/resources/actors/resources/common/types/GuardRouting.ts
var GuardRouting = schemas_exports.object({});

// src/serialization/resources/actors/resources/common/types/HostRouting.ts
var HostRouting = schemas_exports.object({});

// src/serialization/resources/actors/resources/common/types/PortRouting.ts
var PortRouting = schemas_exports.object({
  guard: GuardRouting.optional(),
  host: HostRouting.optional()
});

// src/serialization/resources/actors/resources/common/types/Port.ts
var Port = schemas_exports.object({
  protocol: PortProtocol4,
  internalPort: schemas_exports.property("internal_port", schemas_exports.number().optional()),
  hostname: schemas_exports.string().optional(),
  port: schemas_exports.number().optional(),
  path: schemas_exports.string().optional(),
  url: schemas_exports.string().optional(),
  routing: PortRouting
});

// src/serialization/resources/actors/resources/common/types/Network.ts
var Network = schemas_exports.object({
  mode: NetworkMode4,
  ports: schemas_exports.record(schemas_exports.string(), Port)
});

// src/serialization/resources/actors/resources/common/types/Resources.ts
var Resources = schemas_exports.object({
  cpu: schemas_exports.number(),
  memory: schemas_exports.number()
});

// src/serialization/resources/actors/resources/common/types/Lifecycle.ts
var Lifecycle = schemas_exports.object({
  killTimeout: schemas_exports.property("kill_timeout", schemas_exports.number().optional()),
  durable: schemas_exports.boolean().optional()
});

// src/serialization/resources/common/types/Timestamp.ts
var Timestamp = schemas_exports.date();

// src/serialization/resources/actors/resources/common/types/Actor.ts
var Actor = schemas_exports.object({
  id: schemas_exports.string(),
  region: schemas_exports.string(),
  tags: schemas_exports.unknown(),
  runtime: Runtime,
  network: Network,
  resources: Resources,
  lifecycle: Lifecycle,
  createdAt: schemas_exports.property("created_at", Timestamp),
  startedAt: schemas_exports.property("started_at", Timestamp.optional()),
  destroyedAt: schemas_exports.property("destroyed_at", Timestamp.optional())
});

// src/serialization/resources/actors/types/GetActorResponse.ts
var GetActorResponse = schemas_exports.object({
  actor: Actor
});

// src/serialization/resources/actors/resources/common/types/EndpointType.ts
var EndpointType2 = schemas_exports.enum_(["hostname", "path"]);

// src/serialization/resources/actors/types/CreateActorRuntimeNetworkRequest.ts
var CreateActorRuntimeNetworkRequest = schemas_exports.object({
  endpointType: schemas_exports.property("endpoint_type", EndpointType2)
});

// src/serialization/resources/actors/types/CreateActorRuntimeRequest.ts
var CreateActorRuntimeRequest = schemas_exports.object({
  environment: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional(),
  network: CreateActorRuntimeNetworkRequest.optional()
});

// src/serialization/resources/actors/types/CreateActorPortRequest.ts
var CreateActorPortRequest = schemas_exports.object({
  protocol: PortProtocol4,
  internalPort: schemas_exports.property("internal_port", schemas_exports.number().optional()),
  routing: PortRouting.optional()
});

// src/serialization/resources/actors/types/CreateActorNetworkRequest.ts
var CreateActorNetworkRequest = schemas_exports.object({
  mode: NetworkMode4.optional(),
  ports: schemas_exports.record(schemas_exports.string(), CreateActorPortRequest).optional(),
  waitReady: schemas_exports.property("wait_ready", schemas_exports.boolean().optional())
});

// src/serialization/resources/actors/types/CreateActorRequest.ts
var CreateActorRequest = schemas_exports.object({
  region: schemas_exports.string().optional(),
  tags: schemas_exports.unknown(),
  build: schemas_exports.string().optional(),
  buildTags: schemas_exports.property("build_tags", schemas_exports.unknown().optional()),
  runtime: CreateActorRuntimeRequest.optional(),
  network: CreateActorNetworkRequest.optional(),
  resources: Resources.optional(),
  lifecycle: Lifecycle.optional()
});

// src/serialization/resources/actors/types/CreateActorResponse.ts
var CreateActorResponse = schemas_exports.object({
  actor: Actor
});

// src/serialization/resources/actors/types/DestroyActorResponse.ts
var DestroyActorResponse = schemas_exports.object({});

// src/serialization/resources/actors/types/UpgradeActorRequest.ts
var UpgradeActorRequest = schemas_exports.object({
  build: schemas_exports.string().optional(),
  buildTags: schemas_exports.property("build_tags", schemas_exports.unknown().optional())
});

// src/serialization/resources/actors/types/UpgradeActorResponse.ts
var UpgradeActorResponse = schemas_exports.object({});

// src/serialization/resources/actors/types/UpgradeAllActorsRequest.ts
var UpgradeAllActorsRequest = schemas_exports.object({
  tags: schemas_exports.unknown(),
  build: schemas_exports.string().optional(),
  buildTags: schemas_exports.property("build_tags", schemas_exports.unknown().optional())
});

// src/serialization/resources/actors/types/UpgradeAllActorsResponse.ts
var UpgradeAllActorsResponse = schemas_exports.object({
  count: schemas_exports.number()
});

// src/serialization/resources/common/types/Pagination.ts
var Pagination = schemas_exports.object({
  cursor: schemas_exports.string().optional()
});

// src/serialization/resources/actors/types/ListActorsResponse.ts
var ListActorsResponse = schemas_exports.object({
  actors: schemas_exports.list(Actor),
  pagination: Pagination
});

// src/serialization/resources/actors/types/GetActorUsageResponse.ts
var GetActorUsageResponse = schemas_exports.object({
  metricNames: schemas_exports.property("metric_names", schemas_exports.list(schemas_exports.string())),
  metricAttributes: schemas_exports.property(
    "metric_attributes",
    schemas_exports.list(schemas_exports.record(schemas_exports.string(), schemas_exports.string()))
  ),
  metricTypes: schemas_exports.property("metric_types", schemas_exports.list(schemas_exports.string())),
  metricValues: schemas_exports.property(
    "metric_values",
    schemas_exports.list(schemas_exports.list(schemas_exports.number()))
  )
});

// src/serialization/resources/actors/types/QueryActorsResponse.ts
var QueryActorsResponse = schemas_exports.object({
  actors: schemas_exports.list(Actor),
  pagination: Pagination
});

// src/serialization/resources/actors/resources/common/index.ts
var common_exports18 = {};
__export(common_exports18, {
  Actor: () => Actor,
  EndpointType: () => EndpointType2,
  GuardRouting: () => GuardRouting,
  HostRouting: () => HostRouting,
  Lifecycle: () => Lifecycle,
  Network: () => Network,
  NetworkMode: () => NetworkMode4,
  Port: () => Port,
  PortProtocol: () => PortProtocol4,
  PortRouting: () => PortRouting,
  Resources: () => Resources,
  Runtime: () => Runtime
});

// src/serialization/resources/actors/resources/logs/index.ts
var logs_exports5 = {};
__export(logs_exports5, {
  ExportActorLogsRequest: () => ExportActorLogsRequest,
  ExportActorLogsResponse: () => ExportActorLogsResponse,
  GetActorLogsResponse: () => GetActorLogsResponse
});

// src/serialization/resources/common/types/WatchResponse.ts
var WatchResponse = schemas_exports.object({
  index: schemas_exports.string()
});

// src/serialization/resources/actors/resources/logs/types/GetActorLogsResponse.ts
var GetActorLogsResponse = schemas_exports.object({
  actorIds: schemas_exports.property("actor_ids", schemas_exports.list(schemas_exports.string())),
  lines: schemas_exports.list(schemas_exports.string()),
  timestamps: schemas_exports.list(Timestamp),
  streams: schemas_exports.list(schemas_exports.number()),
  actorIndices: schemas_exports.property("actor_indices", schemas_exports.list(schemas_exports.number())),
  watch: WatchResponse
});

// src/serialization/resources/actors/resources/logs/types/ExportActorLogsResponse.ts
var ExportActorLogsResponse = schemas_exports.object({
  url: schemas_exports.string()
});

// src/serialization/resources/actors/resources/logs/client/requests/ExportActorLogsRequest.ts
var ExportActorLogsRequest = schemas_exports.object({
  project: schemas_exports.string().optional(),
  environment: schemas_exports.string().optional(),
  queryJson: schemas_exports.property("query_json", schemas_exports.string().optional())
});

// src/serialization/resources/actors/resources/metrics/index.ts
var metrics_exports2 = {};
__export(metrics_exports2, {
  GetActorMetricsResponse: () => GetActorMetricsResponse
});

// src/serialization/resources/actors/resources/metrics/types/GetActorMetricsResponse.ts
var GetActorMetricsResponse = schemas_exports.object({
  actorIds: schemas_exports.property("actor_ids", schemas_exports.list(schemas_exports.string())),
  metricNames: schemas_exports.property("metric_names", schemas_exports.list(schemas_exports.string())),
  metricAttributes: schemas_exports.property(
    "metric_attributes",
    schemas_exports.list(schemas_exports.record(schemas_exports.string(), schemas_exports.string()))
  ),
  metricTypes: schemas_exports.property("metric_types", schemas_exports.list(schemas_exports.string())),
  metricValues: schemas_exports.property(
    "metric_values",
    schemas_exports.list(schemas_exports.list(schemas_exports.number()))
  )
});

// src/serialization/resources/builds/index.ts
var builds_exports4 = {};
__export(builds_exports4, {
  Build: () => Build,
  BuildCompression: () => BuildCompression4,
  BuildKind: () => BuildKind4,
  GetBuildResponse: () => GetBuildResponse,
  ListBuildsResponse: () => ListBuildsResponse,
  PatchBuildTagsRequest: () => PatchBuildTagsRequest,
  PatchBuildTagsResponse: () => PatchBuildTagsResponse,
  PrepareBuildRequest: () => PrepareBuildRequest,
  PrepareBuildResponse: () => PrepareBuildResponse,
  common: () => common_exports19
});

// src/serialization/resources/builds/resources/common/types/Build.ts
var Build = schemas_exports.object({
  id: schemas_exports.string(),
  name: schemas_exports.string(),
  createdAt: schemas_exports.property("created_at", Timestamp),
  contentLength: schemas_exports.property("content_length", schemas_exports.number()),
  tags: schemas_exports.record(schemas_exports.string(), schemas_exports.string())
});

// src/serialization/resources/builds/types/GetBuildResponse.ts
var GetBuildResponse = schemas_exports.object({
  build: Build
});

// src/serialization/resources/builds/types/ListBuildsResponse.ts
var ListBuildsResponse = schemas_exports.object({
  builds: schemas_exports.list(Build)
});

// src/serialization/resources/builds/types/PatchBuildTagsRequest.ts
var PatchBuildTagsRequest = schemas_exports.object({
  tags: schemas_exports.unknown(),
  exclusiveTags: schemas_exports.property(
    "exclusive_tags",
    schemas_exports.list(schemas_exports.string()).optional()
  )
});

// src/serialization/resources/builds/types/PatchBuildTagsResponse.ts
var PatchBuildTagsResponse = schemas_exports.object({});

// src/serialization/resources/upload/resources/common/types/PrepareFile.ts
var PrepareFile = schemas_exports.object({
  path: schemas_exports.string(),
  contentType: schemas_exports.property("content_type", schemas_exports.string().optional()),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/builds/types/BuildKind.ts
var BuildKind4 = schemas_exports.enum_(["docker_image", "oci_bundle", "javascript"]);

// src/serialization/resources/builds/types/BuildCompression.ts
var BuildCompression4 = schemas_exports.enum_(["none", "lz4"]);

// src/serialization/resources/builds/types/PrepareBuildRequest.ts
var PrepareBuildRequest = schemas_exports.object({
  imageTag: schemas_exports.property("image_tag", schemas_exports.string().optional()),
  imageFile: schemas_exports.property("image_file", PrepareFile),
  kind: BuildKind4.optional(),
  compression: BuildCompression4.optional()
});

// src/serialization/resources/upload/resources/common/types/PresignedRequest.ts
var PresignedRequest = schemas_exports.object({
  path: schemas_exports.string(),
  url: schemas_exports.string(),
  byteOffset: schemas_exports.property("byte_offset", schemas_exports.number()),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/builds/types/PrepareBuildResponse.ts
var PrepareBuildResponse = schemas_exports.object({
  build: schemas_exports.string(),
  presignedRequests: schemas_exports.property("presigned_requests", schemas_exports.list(PresignedRequest))
});

// src/serialization/resources/builds/resources/common/index.ts
var common_exports19 = {};
__export(common_exports19, {
  Build: () => Build
});

// src/serialization/resources/cloud/index.ts
var cloud_exports2 = {};
__export(cloud_exports2, {
  AuthAgent: () => AuthAgent,
  AuthAgentGameCloud: () => AuthAgentGameCloud,
  AuthAgentIdentity: () => AuthAgentIdentity,
  BootstrapAccess: () => BootstrapAccess2,
  BootstrapCaptcha: () => BootstrapCaptcha,
  BootstrapCaptchaTurnstile: () => BootstrapCaptchaTurnstile,
  BootstrapCluster: () => BootstrapCluster2,
  BootstrapDomains: () => BootstrapDomains,
  BootstrapLoginMethods: () => BootstrapLoginMethods,
  BootstrapOrigins: () => BootstrapOrigins,
  BootstrapResponse: () => BootstrapResponse,
  BuildSummary: () => BuildSummary,
  CdnAuthType: () => CdnAuthType2,
  CdnNamespaceAuthUser: () => CdnNamespaceAuthUser,
  CdnNamespaceConfig: () => CdnNamespaceConfig,
  CdnNamespaceDomain: () => CdnNamespaceDomain,
  CdnNamespaceDomainVerificationMethod: () => CdnNamespaceDomainVerificationMethod,
  CdnNamespaceDomainVerificationMethodHttp: () => CdnNamespaceDomainVerificationMethodHttp,
  CdnNamespaceDomainVerificationStatus: () => CdnNamespaceDomainVerificationStatus2,
  CdnSiteSummary: () => CdnSiteSummary,
  CustomAvatarSummary: () => CustomAvatarSummary,
  GameFull: () => GameFull,
  GameLobbyExpenses: () => GameLobbyExpenses,
  GetRayPerfLogsResponse: () => GetRayPerfLogsResponse,
  GetRegionTiersResponse: () => GetRegionTiersResponse,
  GroupBankSource: () => GroupBankSource,
  IdentityNamespaceConfig: () => IdentityNamespaceConfig,
  InspectResponse: () => InspectResponse2,
  KvNamespaceConfig: () => KvNamespaceConfig,
  LobbySummaryAnalytics: () => LobbySummaryAnalytics,
  LogsLobbyStatus: () => LogsLobbyStatus,
  LogsLobbyStatusStopped: () => LogsLobbyStatusStopped,
  LogsLobbySummary: () => LogsLobbySummary,
  LogsPerfMark: () => LogsPerfMark,
  LogsPerfSpan: () => LogsPerfSpan,
  MatchmakerDevelopmentPort: () => MatchmakerDevelopmentPort,
  MatchmakerNamespaceConfig: () => MatchmakerNamespaceConfig,
  NamespaceConfig: () => NamespaceConfig,
  NamespaceFull: () => NamespaceFull,
  NamespaceSummary: () => NamespaceSummary,
  NamespaceVersion: () => NamespaceVersion,
  RegionSummary: () => RegionSummary,
  RegionTier: () => RegionTier,
  RegionTierExpenses: () => RegionTierExpenses,
  SvcMetrics: () => SvcMetrics,
  SvcPerf: () => SvcPerf,
  UniversalRegion: () => UniversalRegion2,
  ValidateGroupRequest: () => ValidateGroupRequest,
  ValidateGroupResponse: () => ValidateGroupResponse,
  auth: () => auth_exports3,
  common: () => common_exports21,
  devices: () => devices_exports2,
  games: () => games_exports4,
  groups: () => groups_exports2,
  logs: () => logs_exports7,
  tiers: () => tiers_exports2,
  version: () => version_exports2
});

// src/serialization/resources/cloud/types/BootstrapCluster.ts
var BootstrapCluster2 = schemas_exports.enum_(["enterprise", "oss"]);

// src/serialization/resources/cloud/types/BootstrapAccess.ts
var BootstrapAccess2 = schemas_exports.enum_(["public", "private", "development"]);

// src/serialization/resources/cloud/types/BootstrapDomains.ts
var BootstrapDomains = schemas_exports.object({
  cdn: schemas_exports.string().optional(),
  job: schemas_exports.string().optional(),
  main: schemas_exports.string().optional(),
  opengb: schemas_exports.string().optional()
});

// src/serialization/resources/cloud/types/BootstrapOrigins.ts
var BootstrapOrigins = schemas_exports.object({
  hub: schemas_exports.string()
});

// src/serialization/resources/cloud/types/BootstrapCaptchaTurnstile.ts
var BootstrapCaptchaTurnstile = schemas_exports.object({
  siteKey: schemas_exports.property("site_key", schemas_exports.string())
});

// src/serialization/resources/cloud/types/BootstrapCaptcha.ts
var BootstrapCaptcha = schemas_exports.object({
  turnstile: BootstrapCaptchaTurnstile.optional()
});

// src/serialization/resources/cloud/types/BootstrapLoginMethods.ts
var BootstrapLoginMethods = schemas_exports.object({
  email: schemas_exports.boolean(),
  accessToken: schemas_exports.property("access_token", schemas_exports.boolean().optional())
});

// src/serialization/resources/cloud/types/BootstrapResponse.ts
var BootstrapResponse = schemas_exports.object({
  cluster: BootstrapCluster2,
  access: BootstrapAccess2,
  domains: BootstrapDomains,
  origins: BootstrapOrigins,
  captcha: BootstrapCaptcha,
  loginMethods: schemas_exports.property("login_methods", BootstrapLoginMethods),
  deployHash: schemas_exports.property("deploy_hash", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/index.ts
var games_exports4 = {};
__export(games_exports4, {
  BuildCompression: () => BuildCompression5,
  BuildKind: () => BuildKind5,
  CreateCloudTokenResponse: () => CreateCloudTokenResponse,
  CreateGameBuildRequest: () => CreateGameBuildRequest,
  CreateGameBuildResponse: () => CreateGameBuildResponse,
  CreateGameCdnSiteRequest: () => CreateGameCdnSiteRequest,
  CreateGameCdnSiteResponse: () => CreateGameCdnSiteResponse,
  CreateGameRequest: () => CreateGameRequest,
  CreateGameResponse: () => CreateGameResponse,
  CreateGameVersionRequest: () => CreateGameVersionRequest,
  CreateGameVersionResponse: () => CreateGameVersionResponse,
  DeleteMatchmakerLobbyResponse: () => DeleteMatchmakerLobbyResponse,
  ExportLobbyLogsRequest: () => ExportLobbyLogsRequest,
  ExportLobbyLogsResponse: () => ExportLobbyLogsResponse,
  ExportMatchmakerLobbyHistoryRequest: () => ExportMatchmakerLobbyHistoryRequest,
  ExportMatchmakerLobbyHistoryResponse: () => ExportMatchmakerLobbyHistoryResponse,
  GameBannerUploadPrepareRequest: () => GameBannerUploadPrepareRequest,
  GameBannerUploadPrepareResponse: () => GameBannerUploadPrepareResponse,
  GameLogoUploadPrepareRequest: () => GameLogoUploadPrepareRequest,
  GameLogoUploadPrepareResponse: () => GameLogoUploadPrepareResponse,
  GetGameByIdResponse: () => GetGameByIdResponse,
  GetGameVersionByIdResponse: () => GetGameVersionByIdResponse,
  GetGamesResponse: () => GetGamesResponse,
  GetLobbyLogsResponse: () => GetLobbyLogsResponse,
  ListGameBuildsResponse: () => ListGameBuildsResponse,
  ListGameCdnSitesResponse: () => ListGameCdnSitesResponse,
  ListGameCustomAvatarsResponse: () => ListGameCustomAvatarsResponse,
  LogStream: () => LogStream3,
  PrepareCustomAvatarUploadRequest: () => PrepareCustomAvatarUploadRequest,
  PrepareCustomAvatarUploadResponse: () => PrepareCustomAvatarUploadResponse,
  ReserveVersionNameResponse: () => ReserveVersionNameResponse,
  ValidateGameRequest: () => ValidateGameRequest,
  ValidateGameResponse: () => ValidateGameResponse,
  ValidateGameVersionRequest: () => ValidateGameVersionRequest,
  ValidateGameVersionResponse: () => ValidateGameVersionResponse,
  avatars: () => avatars_exports2,
  builds: () => builds_exports5,
  cdn: () => cdn_exports3,
  matchmaker: () => matchmaker_exports4,
  namespaces: () => namespaces_exports2,
  tokens: () => tokens_exports4,
  versions: () => versions_exports2
});

// src/serialization/resources/common/types/Identifier.ts
var Identifier = schemas_exports.string();

// src/serialization/resources/common/types/DisplayName.ts
var DisplayName = schemas_exports.string();

// src/serialization/resources/group/resources/common/types/ExternalLinks.ts
var ExternalLinks = schemas_exports.object({
  profile: schemas_exports.string()
});

// src/serialization/resources/group/resources/common/types/Handle.ts
var Handle = schemas_exports.object({
  groupId: schemas_exports.property("group_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string().optional()),
  external: ExternalLinks,
  isDeveloper: schemas_exports.property("is_developer", schemas_exports.boolean().optional())
});

// src/serialization/resources/game/resources/common/types/GameSummary.ts
var GameSummary = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", Identifier),
  displayName: schemas_exports.property("display_name", DisplayName),
  logoUrl: schemas_exports.property("logo_url", schemas_exports.string().optional()),
  bannerUrl: schemas_exports.property("banner_url", schemas_exports.string().optional()),
  url: schemas_exports.string(),
  developer: Handle,
  totalPlayerCount: schemas_exports.property("total_player_count", schemas_exports.number())
});

// src/serialization/resources/common/types/Bio.ts
var Bio = schemas_exports.string();

// src/serialization/resources/group/resources/common/types/Publicity.ts
var Publicity2 = schemas_exports.enum_(["open", "closed"]);

// src/serialization/resources/group/resources/common/types/GroupSummary.ts
var GroupSummary = schemas_exports.object({
  groupId: schemas_exports.property("group_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string().optional()),
  external: ExternalLinks,
  isDeveloper: schemas_exports.property("is_developer", schemas_exports.boolean()),
  bio: Bio,
  isCurrentIdentityMember: schemas_exports.property("is_current_identity_member", schemas_exports.boolean()),
  publicity: Publicity2,
  memberCount: schemas_exports.property("member_count", schemas_exports.number()),
  ownerIdentityId: schemas_exports.property("owner_identity_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/types/GetGamesResponse.ts
var GetGamesResponse = schemas_exports.object({
  games: schemas_exports.list(GameSummary),
  groups: schemas_exports.list(GroupSummary),
  watch: WatchResponse
});

// src/serialization/resources/cloud/resources/games/types/CreateGameRequest.ts
var CreateGameRequest = schemas_exports.object({
  nameId: schemas_exports.property("name_id", Identifier.optional()),
  displayName: schemas_exports.property("display_name", DisplayName),
  developerGroupId: schemas_exports.property("developer_group_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/types/CreateGameResponse.ts
var CreateGameResponse = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/types/ValidateGameRequest.ts
var ValidateGameRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  nameId: schemas_exports.property("name_id", Identifier.optional())
});

// src/serialization/resources/common/types/ValidationError.ts
var ValidationError5 = schemas_exports.object({
  path: schemas_exports.list(schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/types/ValidateGameResponse.ts
var ValidateGameResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/common/types/NamespaceSummary.ts
var NamespaceSummary = schemas_exports.object({
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  displayName: schemas_exports.property("display_name", DisplayName),
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/version/types/Summary.ts
var Summary = schemas_exports.object({
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/cloud/resources/common/types/UniversalRegion.ts
var UniversalRegion2 = schemas_exports.enum_([
  "unknown",
  "local",
  "amsterdam",
  "atlanta",
  "bangalore",
  "dallas",
  "frankfurt",
  "london",
  "mumbai",
  "newark",
  "new_york_city",
  "san_francisco",
  "singapore",
  "sydney",
  "tokyo",
  "toronto",
  "washington_dc",
  "chicago",
  "paris",
  "seattle",
  "sao_paulo",
  "stockholm",
  "chennai",
  "osaka",
  "milan",
  "miami",
  "jakarta",
  "los_angeles"
]);

// src/serialization/resources/cloud/resources/common/types/RegionSummary.ts
var RegionSummary = schemas_exports.object({
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  regionNameId: schemas_exports.property("region_name_id", schemas_exports.string()),
  provider: schemas_exports.string(),
  universalRegion: schemas_exports.property("universal_region", UniversalRegion2),
  providerDisplayName: schemas_exports.property("provider_display_name", DisplayName),
  regionDisplayName: schemas_exports.property("region_display_name", DisplayName)
});

// src/serialization/resources/cloud/resources/common/types/GameFull.ts
var GameFull = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  nameId: schemas_exports.property("name_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  developerGroupId: schemas_exports.property("developer_group_id", schemas_exports.string()),
  totalPlayerCount: schemas_exports.property("total_player_count", schemas_exports.number()),
  logoUrl: schemas_exports.property("logo_url", schemas_exports.string().optional()),
  bannerUrl: schemas_exports.property("banner_url", schemas_exports.string().optional()),
  namespaces: schemas_exports.list(NamespaceSummary),
  versions: schemas_exports.list(Summary),
  availableRegions: schemas_exports.property("available_regions", schemas_exports.list(RegionSummary))
});

// src/serialization/resources/cloud/resources/games/types/GetGameByIdResponse.ts
var GetGameByIdResponse = schemas_exports.object({
  game: GameFull,
  watch: WatchResponse
});

// src/serialization/resources/cloud/resources/games/types/GameBannerUploadPrepareRequest.ts
var GameBannerUploadPrepareRequest = schemas_exports.object({
  path: schemas_exports.string(),
  mime: schemas_exports.string().optional(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/types/GameBannerUploadPrepareResponse.ts
var GameBannerUploadPrepareResponse = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequest: schemas_exports.property("presigned_request", PresignedRequest)
});

// src/serialization/resources/cloud/resources/games/types/GameLogoUploadPrepareRequest.ts
var GameLogoUploadPrepareRequest = schemas_exports.object({
  path: schemas_exports.string(),
  mime: schemas_exports.string().optional(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/types/GameLogoUploadPrepareResponse.ts
var GameLogoUploadPrepareResponse = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequest: schemas_exports.property("presigned_request", PresignedRequest)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/index.ts
var namespaces_exports2 = {};
__export(namespaces_exports2, {
  AddNamespaceDomainRequest: () => AddNamespaceDomainRequest,
  CreateGameNamespaceRequest: () => CreateGameNamespaceRequest,
  CreateGameNamespaceResponse: () => CreateGameNamespaceResponse,
  CreateGameNamespaceTokenDevelopmentRequest: () => CreateGameNamespaceTokenDevelopmentRequest,
  CreateGameNamespaceTokenDevelopmentResponse: () => CreateGameNamespaceTokenDevelopmentResponse,
  CreateGameNamespaceTokenPublicResponse: () => CreateGameNamespaceTokenPublicResponse,
  GetAnalyticsMatchmakerLiveResponse: () => GetAnalyticsMatchmakerLiveResponse,
  GetGameNamespaceByIdResponse: () => GetGameNamespaceByIdResponse,
  GetGameNamespaceVersionHistoryResponse: () => GetGameNamespaceVersionHistoryResponse,
  GetNamespaceLobbyResponse: () => GetNamespaceLobbyResponse,
  InspectResponse: () => InspectResponse,
  ListNamespaceLobbiesResponse: () => ListNamespaceLobbiesResponse,
  SetNamespaceCdnAuthTypeRequest: () => SetNamespaceCdnAuthTypeRequest,
  ToggleNamespaceDomainPublicAuthRequest: () => ToggleNamespaceDomainPublicAuthRequest,
  UpdateGameNamespaceMatchmakerConfigRequest: () => UpdateGameNamespaceMatchmakerConfigRequest,
  UpdateGameNamespaceVersionRequest: () => UpdateGameNamespaceVersionRequest,
  UpdateNamespaceCdnAuthUserRequest: () => UpdateNamespaceCdnAuthUserRequest,
  ValidateGameNamespaceMatchmakerConfigRequest: () => ValidateGameNamespaceMatchmakerConfigRequest,
  ValidateGameNamespaceMatchmakerConfigResponse: () => ValidateGameNamespaceMatchmakerConfigResponse,
  ValidateGameNamespaceRequest: () => ValidateGameNamespaceRequest,
  ValidateGameNamespaceResponse: () => ValidateGameNamespaceResponse,
  ValidateGameNamespaceTokenDevelopmentRequest: () => ValidateGameNamespaceTokenDevelopmentRequest,
  ValidateGameNamespaceTokenDevelopmentResponse: () => ValidateGameNamespaceTokenDevelopmentResponse,
  analytics: () => analytics_exports2,
  logs: () => logs_exports6
});

// src/serialization/resources/cloud/resources/common/types/AuthAgentIdentity.ts
var AuthAgentIdentity = schemas_exports.object({
  identityId: schemas_exports.property("identity_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/common/types/AuthAgentGameCloud.ts
var AuthAgentGameCloud = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/common/types/AuthAgent.ts
var AuthAgent = schemas_exports.object({
  identity: AuthAgentIdentity.optional(),
  gameCloud: schemas_exports.property("game_cloud", AuthAgentGameCloud.optional())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/InspectResponse.ts
var InspectResponse = schemas_exports.object({
  agent: AuthAgent
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/CreateGameNamespaceRequest.ts
var CreateGameNamespaceRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/CreateGameNamespaceResponse.ts
var CreateGameNamespaceResponse = schemas_exports.object({
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceRequest.ts
var ValidateGameNamespaceRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  nameId: schemas_exports.property("name_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceResponse.ts
var ValidateGameNamespaceResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceDomainVerificationStatus.ts
var CdnNamespaceDomainVerificationStatus2 = schemas_exports.enum_(["active", "pending", "failed"]);

// src/serialization/resources/common/types/EmptyObject.ts
var EmptyObject = schemas_exports.object({});

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceDomainVerificationMethodHttp.ts
var CdnNamespaceDomainVerificationMethodHttp = schemas_exports.object({
  cnameRecord: schemas_exports.property("cname_record", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceDomainVerificationMethod.ts
var CdnNamespaceDomainVerificationMethod = schemas_exports.object({
  invalid: EmptyObject.optional(),
  http: CdnNamespaceDomainVerificationMethodHttp.optional()
});

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceDomain.ts
var CdnNamespaceDomain = schemas_exports.object({
  domain: schemas_exports.string(),
  createTs: schemas_exports.property("create_ts", Timestamp),
  verificationStatus: schemas_exports.property("verification_status", CdnNamespaceDomainVerificationStatus2),
  verificationMethod: schemas_exports.property("verification_method", CdnNamespaceDomainVerificationMethod),
  verificationErrors: schemas_exports.property(
    "verification_errors",
    schemas_exports.list(schemas_exports.string())
  )
});

// src/serialization/resources/cloud/resources/common/types/CdnAuthType.ts
var CdnAuthType2 = schemas_exports.enum_(["none", "basic"]);

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceAuthUser.ts
var CdnNamespaceAuthUser = schemas_exports.object({
  user: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/common/types/CdnNamespaceConfig.ts
var CdnNamespaceConfig = schemas_exports.object({
  enableDomainPublicAuth: schemas_exports.property("enable_domain_public_auth", schemas_exports.boolean()),
  domains: schemas_exports.list(CdnNamespaceDomain),
  authType: schemas_exports.property("auth_type", CdnAuthType2),
  authUserList: schemas_exports.property("auth_user_list", schemas_exports.list(CdnNamespaceAuthUser))
});

// src/serialization/resources/cloud/resources/common/types/MatchmakerNamespaceConfig.ts
var MatchmakerNamespaceConfig = schemas_exports.object({
  lobbyCountMax: schemas_exports.property("lobby_count_max", schemas_exports.number()),
  maxPlayersPerClient: schemas_exports.property("max_players_per_client", schemas_exports.number()),
  maxPlayersPerClientVpn: schemas_exports.property("max_players_per_client_vpn", schemas_exports.number()),
  maxPlayersPerClientProxy: schemas_exports.property("max_players_per_client_proxy", schemas_exports.number()),
  maxPlayersPerClientTor: schemas_exports.property("max_players_per_client_tor", schemas_exports.number()),
  maxPlayersPerClientHosting: schemas_exports.property(
    "max_players_per_client_hosting",
    schemas_exports.number()
  )
});

// src/serialization/resources/cloud/resources/common/types/KvNamespaceConfig.ts
var KvNamespaceConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/common/types/IdentityNamespaceConfig.ts
var IdentityNamespaceConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/common/types/NamespaceConfig.ts
var NamespaceConfig = schemas_exports.object({
  cdn: CdnNamespaceConfig,
  matchmaker: MatchmakerNamespaceConfig,
  kv: KvNamespaceConfig,
  identity: IdentityNamespaceConfig
});

// src/serialization/resources/cloud/resources/common/types/NamespaceFull.ts
var NamespaceFull = schemas_exports.object({
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  displayName: schemas_exports.property("display_name", DisplayName),
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", schemas_exports.string()),
  config: NamespaceConfig
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/GetGameNamespaceByIdResponse.ts
var GetGameNamespaceByIdResponse = schemas_exports.object({
  namespace: NamespaceFull
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/UpdateNamespaceCdnAuthUserRequest.ts
var UpdateNamespaceCdnAuthUserRequest = schemas_exports.object({
  user: schemas_exports.string(),
  password: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/SetNamespaceCdnAuthTypeRequest.ts
var SetNamespaceCdnAuthTypeRequest = schemas_exports.object({
  authType: schemas_exports.property("auth_type", CdnAuthType2)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ToggleNamespaceDomainPublicAuthRequest.ts
var ToggleNamespaceDomainPublicAuthRequest = schemas_exports.object({
  enabled: schemas_exports.boolean()
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/AddNamespaceDomainRequest.ts
var AddNamespaceDomainRequest = schemas_exports.object({
  domain: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/UpdateGameNamespaceMatchmakerConfigRequest.ts
var UpdateGameNamespaceMatchmakerConfigRequest = schemas_exports.object({
  lobbyCountMax: schemas_exports.property("lobby_count_max", schemas_exports.number()),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/common/types/NamespaceVersion.ts
var NamespaceVersion = schemas_exports.object({
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string()),
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  deployTs: schemas_exports.property("deploy_ts", Timestamp)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/GetGameNamespaceVersionHistoryResponse.ts
var GetGameNamespaceVersionHistoryResponse = schemas_exports.object({
  versions: schemas_exports.list(NamespaceVersion)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceMatchmakerConfigRequest.ts
var ValidateGameNamespaceMatchmakerConfigRequest = schemas_exports.object({
  lobbyCountMax: schemas_exports.property("lobby_count_max", schemas_exports.number()),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceMatchmakerConfigResponse.ts
var ValidateGameNamespaceMatchmakerConfigResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/PortRange.ts
var PortRange = schemas_exports.object({
  min: schemas_exports.number(),
  max: schemas_exports.number()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/PortProtocol.ts
var PortProtocol5 = schemas_exports.enum_(["http", "https", "tcp", "tcp_tls", "udp"]);

// src/serialization/resources/cloud/resources/common/types/MatchmakerDevelopmentPort.ts
var MatchmakerDevelopmentPort = schemas_exports.object({
  port: schemas_exports.number().optional(),
  portRange: schemas_exports.property("port_range", PortRange.optional()),
  protocol: PortProtocol5
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupRuntimeDockerPort.ts
var LobbyGroupRuntimeDockerPort = schemas_exports.object({
  label: schemas_exports.string(),
  targetPort: schemas_exports.property("target_port", schemas_exports.number().optional()),
  portRange: schemas_exports.property("port_range", PortRange.optional()),
  proxyProtocol: schemas_exports.property("proxy_protocol", PortProtocol5)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/CreateGameNamespaceTokenDevelopmentRequest.ts
var CreateGameNamespaceTokenDevelopmentRequest = schemas_exports.object({
  hostname: schemas_exports.string(),
  ports: schemas_exports.record(schemas_exports.string(), MatchmakerDevelopmentPort).optional(),
  lobbyPorts: schemas_exports.property(
    "lobby_ports",
    schemas_exports.list(LobbyGroupRuntimeDockerPort).optional()
  )
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/CreateGameNamespaceTokenDevelopmentResponse.ts
var CreateGameNamespaceTokenDevelopmentResponse = schemas_exports.object({
  token: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceTokenDevelopmentRequest.ts
var ValidateGameNamespaceTokenDevelopmentRequest = schemas_exports.object({
  hostname: schemas_exports.string(),
  lobbyPorts: schemas_exports.property("lobby_ports", schemas_exports.list(LobbyGroupRuntimeDockerPort))
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/ValidateGameNamespaceTokenDevelopmentResponse.ts
var ValidateGameNamespaceTokenDevelopmentResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/CreateGameNamespaceTokenPublicResponse.ts
var CreateGameNamespaceTokenPublicResponse = schemas_exports.object({
  token: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/types/UpdateGameNamespaceVersionRequest.ts
var UpdateGameNamespaceVersionRequest = schemas_exports.object({
  versionId: schemas_exports.property("version_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/resources/analytics/index.ts
var analytics_exports2 = {};
__export(analytics_exports2, {
  GetAnalyticsMatchmakerLiveResponse: () => GetAnalyticsMatchmakerLiveResponse
});

// src/serialization/resources/cloud/resources/common/types/LobbySummaryAnalytics.ts
var LobbySummaryAnalytics = schemas_exports.object({
  lobbyId: schemas_exports.property("lobby_id", schemas_exports.string()),
  lobbyGroupId: schemas_exports.property("lobby_group_id", schemas_exports.string()),
  lobbyGroupNameId: schemas_exports.property("lobby_group_name_id", schemas_exports.string()),
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  isReady: schemas_exports.property("is_ready", schemas_exports.boolean()),
  isIdle: schemas_exports.property("is_idle", schemas_exports.boolean()),
  isClosed: schemas_exports.property("is_closed", schemas_exports.boolean()),
  isOutdated: schemas_exports.property("is_outdated", schemas_exports.boolean()),
  maxPlayersNormal: schemas_exports.property("max_players_normal", schemas_exports.number()),
  maxPlayersDirect: schemas_exports.property("max_players_direct", schemas_exports.number()),
  maxPlayersParty: schemas_exports.property("max_players_party", schemas_exports.number()),
  totalPlayerCount: schemas_exports.property("total_player_count", schemas_exports.number()),
  registeredPlayerCount: schemas_exports.property("registered_player_count", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/resources/analytics/types/GetAnalyticsMatchmakerLiveResponse.ts
var GetAnalyticsMatchmakerLiveResponse = schemas_exports.object({
  lobbies: schemas_exports.list(LobbySummaryAnalytics)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/resources/logs/index.ts
var logs_exports6 = {};
__export(logs_exports6, {
  GetNamespaceLobbyResponse: () => GetNamespaceLobbyResponse,
  ListNamespaceLobbiesResponse: () => ListNamespaceLobbiesResponse
});

// src/serialization/resources/cloud/resources/common/types/LogsLobbyStatusStopped.ts
var LogsLobbyStatusStopped = schemas_exports.object({
  stopTs: schemas_exports.property("stop_ts", Timestamp),
  failed: schemas_exports.boolean(),
  exitCode: schemas_exports.property("exit_code", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/common/types/LogsLobbyStatus.ts
var LogsLobbyStatus = schemas_exports.object({
  running: EmptyObject,
  stopped: LogsLobbyStatusStopped.optional()
});

// src/serialization/resources/cloud/resources/common/types/LogsLobbySummary.ts
var LogsLobbySummary = schemas_exports.object({
  lobbyId: schemas_exports.property("lobby_id", schemas_exports.string()),
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string()),
  lobbyGroupNameId: schemas_exports.property("lobby_group_name_id", schemas_exports.string()),
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  startTs: schemas_exports.property("start_ts", Timestamp.optional()),
  readyTs: schemas_exports.property("ready_ts", Timestamp.optional()),
  status: LogsLobbyStatus
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/resources/logs/types/ListNamespaceLobbiesResponse.ts
var ListNamespaceLobbiesResponse = schemas_exports.object({
  lobbies: schemas_exports.list(LogsLobbySummary)
});

// src/serialization/resources/cloud/resources/common/types/SvcMetrics.ts
var SvcMetrics = schemas_exports.object({
  job: schemas_exports.string(),
  cpu: schemas_exports.list(schemas_exports.number()),
  memory: schemas_exports.list(schemas_exports.number()),
  allocatedMemory: schemas_exports.property("allocated_memory", schemas_exports.number().optional())
});

// src/serialization/resources/cloud/resources/common/types/LogsPerfSpan.ts
var LogsPerfSpan = schemas_exports.object({
  label: schemas_exports.string(),
  startTs: schemas_exports.property("start_ts", Timestamp),
  finishTs: schemas_exports.property("finish_ts", Timestamp.optional()),
  reqId: schemas_exports.property("req_id", schemas_exports.string().optional())
});

// src/serialization/resources/cloud/resources/common/types/LogsPerfMark.ts
var LogsPerfMark = schemas_exports.object({
  label: schemas_exports.string(),
  ts: Timestamp,
  rayId: schemas_exports.property("ray_id", schemas_exports.string().optional()),
  reqId: schemas_exports.property("req_id", schemas_exports.string().optional())
});

// src/serialization/resources/cloud/resources/common/types/SvcPerf.ts
var SvcPerf = schemas_exports.object({
  svcName: schemas_exports.property("svc_name", schemas_exports.string()),
  ts: Timestamp,
  duration: schemas_exports.number(),
  reqId: schemas_exports.property("req_id", schemas_exports.string().optional()),
  spans: schemas_exports.list(LogsPerfSpan),
  marks: schemas_exports.list(LogsPerfMark)
});

// src/serialization/resources/cloud/resources/games/resources/namespaces/resources/logs/types/GetNamespaceLobbyResponse.ts
var GetNamespaceLobbyResponse = schemas_exports.object({
  lobby: LogsLobbySummary,
  metrics: SvcMetrics.optional(),
  stdoutPresignedUrls: schemas_exports.property(
    "stdout_presigned_urls",
    schemas_exports.list(schemas_exports.string())
  ),
  stderrPresignedUrls: schemas_exports.property(
    "stderr_presigned_urls",
    schemas_exports.list(schemas_exports.string())
  ),
  perfLists: schemas_exports.property("perf_lists", schemas_exports.list(SvcPerf))
});

// src/serialization/resources/cloud/resources/games/resources/avatars/index.ts
var avatars_exports2 = {};
__export(avatars_exports2, {
  ListGameCustomAvatarsResponse: () => ListGameCustomAvatarsResponse,
  PrepareCustomAvatarUploadRequest: () => PrepareCustomAvatarUploadRequest,
  PrepareCustomAvatarUploadResponse: () => PrepareCustomAvatarUploadResponse
});

// src/serialization/resources/cloud/resources/common/types/CustomAvatarSummary.ts
var CustomAvatarSummary = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  createTs: schemas_exports.property("create_ts", Timestamp),
  url: schemas_exports.string().optional(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number()),
  complete: schemas_exports.boolean()
});

// src/serialization/resources/cloud/resources/games/resources/avatars/types/ListGameCustomAvatarsResponse.ts
var ListGameCustomAvatarsResponse = schemas_exports.object({
  customAvatars: schemas_exports.property("custom_avatars", schemas_exports.list(CustomAvatarSummary))
});

// src/serialization/resources/cloud/resources/games/resources/avatars/types/PrepareCustomAvatarUploadRequest.ts
var PrepareCustomAvatarUploadRequest = schemas_exports.object({
  path: schemas_exports.string(),
  mime: schemas_exports.string().optional(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/resources/avatars/types/PrepareCustomAvatarUploadResponse.ts
var PrepareCustomAvatarUploadResponse = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequest: schemas_exports.property("presigned_request", PresignedRequest)
});

// src/serialization/resources/cloud/resources/games/resources/builds/index.ts
var builds_exports5 = {};
__export(builds_exports5, {
  BuildCompression: () => BuildCompression5,
  BuildKind: () => BuildKind5,
  CreateGameBuildRequest: () => CreateGameBuildRequest,
  CreateGameBuildResponse: () => CreateGameBuildResponse,
  ListGameBuildsResponse: () => ListGameBuildsResponse
});

// src/serialization/resources/cloud/resources/common/types/BuildSummary.ts
var BuildSummary = schemas_exports.object({
  buildId: schemas_exports.property("build_id", schemas_exports.string()),
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  createTs: schemas_exports.property("create_ts", Timestamp),
  contentLength: schemas_exports.property("content_length", schemas_exports.number()),
  complete: schemas_exports.boolean(),
  tags: schemas_exports.record(schemas_exports.string(), schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/builds/types/ListGameBuildsResponse.ts
var ListGameBuildsResponse = schemas_exports.object({
  builds: schemas_exports.list(BuildSummary)
});

// src/serialization/resources/cloud/resources/games/resources/builds/types/BuildKind.ts
var BuildKind5 = schemas_exports.enum_(["docker_image", "oci_bundle"]);

// src/serialization/resources/cloud/resources/games/resources/builds/types/BuildCompression.ts
var BuildCompression5 = schemas_exports.enum_(["none", "lz4"]);

// src/serialization/resources/cloud/resources/games/resources/builds/types/CreateGameBuildRequest.ts
var CreateGameBuildRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  imageTag: schemas_exports.property("image_tag", schemas_exports.string()),
  imageFile: schemas_exports.property("image_file", PrepareFile),
  multipartUpload: schemas_exports.property("multipart_upload", schemas_exports.boolean().optional()),
  kind: BuildKind5.optional(),
  compression: BuildCompression5.optional()
});

// src/serialization/resources/cloud/resources/games/resources/builds/types/CreateGameBuildResponse.ts
var CreateGameBuildResponse = schemas_exports.object({
  buildId: schemas_exports.property("build_id", schemas_exports.string()),
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  imagePresignedRequest: schemas_exports.property("image_presigned_request", PresignedRequest.optional()),
  imagePresignedRequests: schemas_exports.property(
    "image_presigned_requests",
    schemas_exports.list(PresignedRequest).optional()
  )
});

// src/serialization/resources/cloud/resources/games/resources/cdn/index.ts
var cdn_exports3 = {};
__export(cdn_exports3, {
  CreateGameCdnSiteRequest: () => CreateGameCdnSiteRequest,
  CreateGameCdnSiteResponse: () => CreateGameCdnSiteResponse,
  ListGameCdnSitesResponse: () => ListGameCdnSitesResponse
});

// src/serialization/resources/cloud/resources/common/types/CdnSiteSummary.ts
var CdnSiteSummary = schemas_exports.object({
  siteId: schemas_exports.property("site_id", schemas_exports.string()),
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  createTs: schemas_exports.property("create_ts", Timestamp),
  contentLength: schemas_exports.property("content_length", schemas_exports.number()),
  complete: schemas_exports.boolean()
});

// src/serialization/resources/cloud/resources/games/resources/cdn/types/ListGameCdnSitesResponse.ts
var ListGameCdnSitesResponse = schemas_exports.object({
  sites: schemas_exports.list(CdnSiteSummary)
});

// src/serialization/resources/cloud/resources/games/resources/cdn/types/CreateGameCdnSiteRequest.ts
var CreateGameCdnSiteRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  files: schemas_exports.list(PrepareFile)
});

// src/serialization/resources/cloud/resources/games/resources/cdn/types/CreateGameCdnSiteResponse.ts
var CreateGameCdnSiteResponse = schemas_exports.object({
  siteId: schemas_exports.property("site_id", schemas_exports.string()),
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequests: schemas_exports.property("presigned_requests", schemas_exports.list(PresignedRequest))
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/index.ts
var matchmaker_exports4 = {};
__export(matchmaker_exports4, {
  DeleteMatchmakerLobbyResponse: () => DeleteMatchmakerLobbyResponse,
  ExportLobbyLogsRequest: () => ExportLobbyLogsRequest,
  ExportLobbyLogsResponse: () => ExportLobbyLogsResponse,
  ExportMatchmakerLobbyHistoryRequest: () => ExportMatchmakerLobbyHistoryRequest,
  ExportMatchmakerLobbyHistoryResponse: () => ExportMatchmakerLobbyHistoryResponse,
  GetLobbyLogsResponse: () => GetLobbyLogsResponse,
  LogStream: () => LogStream3
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/ExportMatchmakerLobbyHistoryRequest.ts
var ExportMatchmakerLobbyHistoryRequest = schemas_exports.object({
  queryStart: schemas_exports.property("query_start", schemas_exports.number()),
  queryEnd: schemas_exports.property("query_end", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/ExportMatchmakerLobbyHistoryResponse.ts
var ExportMatchmakerLobbyHistoryResponse = schemas_exports.object({
  url: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/DeleteMatchmakerLobbyResponse.ts
var DeleteMatchmakerLobbyResponse = schemas_exports.object({
  didRemove: schemas_exports.property("did_remove", schemas_exports.boolean())
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/GetLobbyLogsResponse.ts
var GetLobbyLogsResponse = schemas_exports.object({
  lines: schemas_exports.list(schemas_exports.string()),
  timestamps: schemas_exports.list(schemas_exports.string()),
  watch: WatchResponse
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/LogStream.ts
var LogStream3 = schemas_exports.enum_(["std_out", "std_err"]);

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/ExportLobbyLogsRequest.ts
var ExportLobbyLogsRequest = schemas_exports.object({
  stream: LogStream3
});

// src/serialization/resources/cloud/resources/games/resources/matchmaker/types/ExportLobbyLogsResponse.ts
var ExportLobbyLogsResponse = schemas_exports.object({
  url: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/tokens/index.ts
var tokens_exports4 = {};
__export(tokens_exports4, {
  CreateCloudTokenResponse: () => CreateCloudTokenResponse
});

// src/serialization/resources/cloud/resources/games/resources/tokens/types/CreateCloudTokenResponse.ts
var CreateCloudTokenResponse = schemas_exports.object({
  token: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/games/resources/versions/index.ts
var versions_exports2 = {};
__export(versions_exports2, {
  CreateGameVersionRequest: () => CreateGameVersionRequest,
  CreateGameVersionResponse: () => CreateGameVersionResponse,
  GetGameVersionByIdResponse: () => GetGameVersionByIdResponse,
  ReserveVersionNameResponse: () => ReserveVersionNameResponse,
  ValidateGameVersionRequest: () => ValidateGameVersionRequest,
  ValidateGameVersionResponse: () => ValidateGameVersionResponse
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/unity/types/UnityConfig.ts
var UnityConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/unreal/types/UnrealConfig.ts
var UnrealConfig = schemas_exports.object({
  gameModule: schemas_exports.property("game_module", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/godot/types/GodotConfig.ts
var GodotConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/html5/types/Html5Config.ts
var Html5Config = schemas_exports.object({});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/custom/types/CustomConfig.ts
var CustomConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/version/resources/engine/types/EngineConfig.ts
var EngineConfig = schemas_exports.object({
  unity: UnityConfig.optional(),
  unreal: UnrealConfig.optional(),
  godot: GodotConfig.optional(),
  html5: Html5Config.optional(),
  custom: CustomConfig.optional()
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/Header.ts
var Header = schemas_exports.object({
  name: schemas_exports.string(),
  value: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/CustomHeadersMiddleware.ts
var CustomHeadersMiddleware = schemas_exports.object({
  headers: schemas_exports.list(Header)
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/MiddlewareKind.ts
var MiddlewareKind = schemas_exports.object({
  customHeaders: schemas_exports.property("custom_headers", CustomHeadersMiddleware.optional())
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/Middleware.ts
var Middleware = schemas_exports.object({
  kind: MiddlewareKind
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/Route.ts
var Route = schemas_exports.object({
  glob: schemas_exports.string(),
  priority: schemas_exports.number(),
  middlewares: schemas_exports.list(Middleware)
});

// src/serialization/resources/cloud/resources/version/resources/cdn/types/CdnConfig.ts
var CdnConfig = schemas_exports.object({
  buildCommand: schemas_exports.property("build_command", schemas_exports.string().optional()),
  buildOutput: schemas_exports.property("build_output", schemas_exports.string().optional()),
  buildEnv: schemas_exports.property(
    "build_env",
    schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional()
  ),
  siteId: schemas_exports.property("site_id", schemas_exports.string().optional()),
  routes: schemas_exports.list(Route).optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeIdleLobbiesConfig.ts
var GameModeIdleLobbiesConfig = schemas_exports.object({
  min: schemas_exports.number(),
  max: schemas_exports.number()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeRegion.ts
var GameModeRegion = schemas_exports.object({
  tier: schemas_exports.string().optional(),
  idleLobbies: schemas_exports.property("idle_lobbies", GameModeIdleLobbiesConfig.optional())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/NetworkMode.ts
var NetworkMode5 = schemas_exports.enum_(["bridge", "host"]);

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/ProxyKind.ts
var ProxyKind2 = schemas_exports.enum_(["none", "game_guard"]);

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeRuntimeDockerPort.ts
var GameModeRuntimeDockerPort = schemas_exports.object({
  port: schemas_exports.number().optional(),
  portRange: schemas_exports.property("port_range", PortRange.optional()),
  protocol: PortProtocol5.optional(),
  proxy: ProxyKind2.optional(),
  devPort: schemas_exports.property("dev_port", schemas_exports.number().optional()),
  devPortRange: schemas_exports.property("dev_port_range", PortRange.optional()),
  devProtocol: schemas_exports.property("dev_protocol", PortProtocol5.optional())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeRuntimeDocker.ts
var GameModeRuntimeDocker = schemas_exports.object({
  dockerfile: schemas_exports.string().optional(),
  buildArgs: schemas_exports.property(
    "build_args",
    schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional()
  ),
  image: schemas_exports.string().optional(),
  imageId: schemas_exports.property("image_id", schemas_exports.string().optional()),
  args: schemas_exports.list(schemas_exports.string()).optional(),
  env: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional(),
  networkMode: schemas_exports.property("network_mode", NetworkMode5.optional()),
  ports: schemas_exports.record(schemas_exports.string(), GameModeRuntimeDockerPort).optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeIdentityRequirement.ts
var GameModeIdentityRequirement2 = schemas_exports.enum_(["none", "guest", "registered"]);

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeVerificationConfig.ts
var GameModeVerificationConfig = schemas_exports.object({
  url: schemas_exports.string(),
  headers: schemas_exports.record(schemas_exports.string(), schemas_exports.string())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeFindConfig.ts
var GameModeFindConfig = schemas_exports.object({
  enabled: schemas_exports.boolean(),
  identityRequirement: schemas_exports.property("identity_requirement", GameModeIdentityRequirement2.optional()),
  verification: GameModeVerificationConfig.optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeJoinConfig.ts
var GameModeJoinConfig = schemas_exports.object({
  enabled: schemas_exports.boolean(),
  identityRequirement: schemas_exports.property("identity_requirement", GameModeIdentityRequirement2.optional()),
  verification: GameModeVerificationConfig.optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeCreateConfig.ts
var GameModeCreateConfig = schemas_exports.object({
  enabled: schemas_exports.boolean(),
  identityRequirement: schemas_exports.property("identity_requirement", GameModeIdentityRequirement2.optional()),
  verification: GameModeVerificationConfig.optional(),
  enablePublic: schemas_exports.property("enable_public", schemas_exports.boolean().optional()),
  enablePrivate: schemas_exports.property("enable_private", schemas_exports.boolean().optional()),
  maxLobbiesPerIdentity: schemas_exports.property(
    "max_lobbies_per_identity",
    schemas_exports.number().optional()
  )
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameModeActions.ts
var GameModeActions = schemas_exports.object({
  find: GameModeFindConfig.optional(),
  join: GameModeJoinConfig.optional(),
  create: GameModeCreateConfig.optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/types/GameMode.ts
var GameMode = schemas_exports.object({
  regions: schemas_exports.record(schemas_exports.string(), GameModeRegion).optional(),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number().optional()),
  maxPlayersDirect: schemas_exports.property("max_players_direct", schemas_exports.number().optional()),
  maxPlayersParty: schemas_exports.property("max_players_party", schemas_exports.number().optional()),
  docker: GameModeRuntimeDocker.optional(),
  listable: schemas_exports.boolean().optional(),
  taggable: schemas_exports.boolean().optional(),
  allowDynamicMaxPlayers: schemas_exports.property(
    "allow_dynamic_max_players",
    schemas_exports.boolean().optional()
  ),
  actions: GameModeActions.optional(),
  tier: schemas_exports.string().optional(),
  idleLobbies: schemas_exports.property("idle_lobbies", GameModeIdleLobbiesConfig.optional())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/CaptchaHcaptchaLevel.ts
var CaptchaHcaptchaLevel2 = schemas_exports.enum_(["easy", "moderate", "difficult", "always_on"]);

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/CaptchaHcaptcha.ts
var CaptchaHcaptcha = schemas_exports.object({
  level: CaptchaHcaptchaLevel2.optional(),
  siteKey: schemas_exports.property("site_key", schemas_exports.string().optional()),
  secretKey: schemas_exports.property("secret_key", schemas_exports.string().optional())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/CaptchaTurnstile.ts
var CaptchaTurnstile = schemas_exports.object({
  siteKey: schemas_exports.property("site_key", schemas_exports.string()),
  secretKey: schemas_exports.property("secret_key", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/types/Captcha.ts
var Captcha = schemas_exports.object({
  requestsBeforeReverify: schemas_exports.property("requests_before_reverify", schemas_exports.number()),
  verificationTtl: schemas_exports.property("verification_ttl", schemas_exports.number()),
  hcaptcha: CaptchaHcaptcha.optional(),
  turnstile: CaptchaTurnstile.optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupIdleLobbiesConfig.ts
var LobbyGroupIdleLobbiesConfig = schemas_exports.object({
  minIdleLobbies: schemas_exports.property("min_idle_lobbies", schemas_exports.number()),
  maxIdleLobbies: schemas_exports.property("max_idle_lobbies", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupRegion.ts
var LobbyGroupRegion = schemas_exports.object({
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  tierNameId: schemas_exports.property("tier_name_id", schemas_exports.string()),
  idleLobbies: schemas_exports.property("idle_lobbies", LobbyGroupIdleLobbiesConfig.optional())
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupRuntimeDockerEnvVar.ts
var LobbyGroupRuntimeDockerEnvVar = schemas_exports.object({
  key: schemas_exports.string(),
  value: schemas_exports.string()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupRuntimeDocker.ts
var LobbyGroupRuntimeDocker = schemas_exports.object({
  buildId: schemas_exports.property("build_id", schemas_exports.string().optional()),
  args: schemas_exports.list(schemas_exports.string()),
  envVars: schemas_exports.property("env_vars", schemas_exports.list(LobbyGroupRuntimeDockerEnvVar)),
  networkMode: schemas_exports.property("network_mode", NetworkMode5.optional()),
  ports: schemas_exports.list(LobbyGroupRuntimeDockerPort)
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroupRuntime.ts
var LobbyGroupRuntime = schemas_exports.object({
  docker: LobbyGroupRuntimeDocker.optional()
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/types/LobbyGroup.ts
var LobbyGroup = schemas_exports.object({
  nameId: schemas_exports.property("name_id", schemas_exports.string()),
  regions: schemas_exports.list(LobbyGroupRegion),
  maxPlayersNormal: schemas_exports.property("max_players_normal", schemas_exports.number()),
  maxPlayersDirect: schemas_exports.property("max_players_direct", schemas_exports.number()),
  maxPlayersParty: schemas_exports.property("max_players_party", schemas_exports.number()),
  runtime: LobbyGroupRuntime
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/types/MatchmakerConfig.ts
var MatchmakerConfig = schemas_exports.object({
  gameModes: schemas_exports.property(
    "game_modes",
    schemas_exports.record(schemas_exports.string(), GameMode).optional()
  ),
  captcha: Captcha.optional(),
  devHostname: schemas_exports.property("dev_hostname", schemas_exports.string().optional()),
  regions: schemas_exports.record(schemas_exports.string(), GameModeRegion).optional(),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number().optional()),
  maxPlayersDirect: schemas_exports.property("max_players_direct", schemas_exports.number().optional()),
  maxPlayersParty: schemas_exports.property("max_players_party", schemas_exports.number().optional()),
  docker: GameModeRuntimeDocker.optional(),
  tier: schemas_exports.string().optional(),
  idleLobbies: schemas_exports.property("idle_lobbies", GameModeIdleLobbiesConfig.optional()),
  lobbyGroups: schemas_exports.property("lobby_groups", schemas_exports.list(LobbyGroup).optional())
});

// src/serialization/resources/cloud/resources/version/resources/kv/types/KvConfig.ts
var KvConfig = schemas_exports.object({});

// src/serialization/resources/cloud/resources/version/resources/identity/types/CustomDisplayName.ts
var CustomDisplayName = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/cloud/resources/version/resources/identity/types/CustomAvatar.ts
var CustomAvatar = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/version/resources/identity/types/IdentityConfig.ts
var IdentityConfig = schemas_exports.object({
  displayNames: schemas_exports.property(
    "display_names",
    schemas_exports.list(schemas_exports.string()).optional()
  ),
  avatars: schemas_exports.list(schemas_exports.string()).optional(),
  customDisplayNames: schemas_exports.property(
    "custom_display_names",
    schemas_exports.list(CustomDisplayName).optional()
  ),
  customAvatars: schemas_exports.property("custom_avatars", schemas_exports.list(CustomAvatar).optional())
});

// src/serialization/resources/cloud/resources/version/types/Config.ts
var Config = schemas_exports.object({
  scripts: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional(),
  engine: EngineConfig.optional(),
  cdn: CdnConfig.optional(),
  matchmaker: MatchmakerConfig.optional(),
  kv: KvConfig.optional(),
  identity: IdentityConfig.optional()
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/CreateGameVersionRequest.ts
var CreateGameVersionRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  config: Config
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/CreateGameVersionResponse.ts
var CreateGameVersionResponse = schemas_exports.object({
  versionId: schemas_exports.property("version_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/ReserveVersionNameResponse.ts
var ReserveVersionNameResponse = schemas_exports.object({
  versionDisplayName: schemas_exports.property("version_display_name", DisplayName)
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/ValidateGameVersionRequest.ts
var ValidateGameVersionRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  config: Config
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/ValidateGameVersionResponse.ts
var ValidateGameVersionResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/version/types/Full.ts
var Full = schemas_exports.object({
  versionId: schemas_exports.property("version_id", schemas_exports.string()),
  createTs: schemas_exports.property("create_ts", Timestamp),
  displayName: schemas_exports.property("display_name", DisplayName),
  config: Config
});

// src/serialization/resources/cloud/resources/games/resources/versions/types/GetGameVersionByIdResponse.ts
var GetGameVersionByIdResponse = schemas_exports.object({
  version: Full
});

// src/serialization/resources/cloud/resources/version/index.ts
var version_exports2 = {};
__export(version_exports2, {
  Config: () => Config,
  Full: () => Full,
  Summary: () => Summary,
  cdn: () => cdn_exports4,
  engine: () => engine_exports2,
  identity: () => identity_exports4,
  kv: () => kv_exports2,
  matchmaker: () => matchmaker_exports5
});

// src/serialization/resources/cloud/resources/version/resources/cdn/index.ts
var cdn_exports4 = {};
__export(cdn_exports4, {
  CdnConfig: () => CdnConfig,
  CustomHeadersMiddleware: () => CustomHeadersMiddleware,
  Header: () => Header,
  Middleware: () => Middleware,
  MiddlewareKind: () => MiddlewareKind,
  Route: () => Route
});

// src/serialization/resources/cloud/resources/version/resources/engine/index.ts
var engine_exports2 = {};
__export(engine_exports2, {
  CustomConfig: () => CustomConfig,
  EngineConfig: () => EngineConfig,
  GodotConfig: () => GodotConfig,
  Html5Config: () => Html5Config,
  UnityConfig: () => UnityConfig,
  UnrealConfig: () => UnrealConfig,
  custom: () => custom_exports2,
  godot: () => godot_exports2,
  html5: () => html5_exports2,
  unity: () => unity_exports2,
  unreal: () => unreal_exports2
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/custom/index.ts
var custom_exports2 = {};
__export(custom_exports2, {
  CustomConfig: () => CustomConfig
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/godot/index.ts
var godot_exports2 = {};
__export(godot_exports2, {
  GodotConfig: () => GodotConfig
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/html5/index.ts
var html5_exports2 = {};
__export(html5_exports2, {
  Html5Config: () => Html5Config
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/unity/index.ts
var unity_exports2 = {};
__export(unity_exports2, {
  UnityConfig: () => UnityConfig
});

// src/serialization/resources/cloud/resources/version/resources/engine/resources/unreal/index.ts
var unreal_exports2 = {};
__export(unreal_exports2, {
  UnrealConfig: () => UnrealConfig
});

// src/serialization/resources/cloud/resources/version/resources/identity/index.ts
var identity_exports4 = {};
__export(identity_exports4, {
  CustomAvatar: () => CustomAvatar,
  CustomDisplayName: () => CustomDisplayName,
  IdentityConfig: () => IdentityConfig
});

// src/serialization/resources/cloud/resources/version/resources/kv/index.ts
var kv_exports2 = {};
__export(kv_exports2, {
  KvConfig: () => KvConfig
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/index.ts
var matchmaker_exports5 = {};
__export(matchmaker_exports5, {
  Captcha: () => Captcha,
  CaptchaHcaptcha: () => CaptchaHcaptcha,
  CaptchaHcaptchaLevel: () => CaptchaHcaptchaLevel2,
  CaptchaTurnstile: () => CaptchaTurnstile,
  GameMode: () => GameMode,
  GameModeActions: () => GameModeActions,
  GameModeCreateConfig: () => GameModeCreateConfig,
  GameModeFindConfig: () => GameModeFindConfig,
  GameModeIdentityRequirement: () => GameModeIdentityRequirement2,
  GameModeIdleLobbiesConfig: () => GameModeIdleLobbiesConfig,
  GameModeJoinConfig: () => GameModeJoinConfig,
  GameModeRegion: () => GameModeRegion,
  GameModeRuntimeDocker: () => GameModeRuntimeDocker,
  GameModeRuntimeDockerPort: () => GameModeRuntimeDockerPort,
  GameModeVerificationConfig: () => GameModeVerificationConfig,
  LobbyGroup: () => LobbyGroup,
  LobbyGroupIdleLobbiesConfig: () => LobbyGroupIdleLobbiesConfig,
  LobbyGroupRegion: () => LobbyGroupRegion,
  LobbyGroupRuntime: () => LobbyGroupRuntime,
  LobbyGroupRuntimeDocker: () => LobbyGroupRuntimeDocker,
  LobbyGroupRuntimeDockerEnvVar: () => LobbyGroupRuntimeDockerEnvVar,
  LobbyGroupRuntimeDockerPort: () => LobbyGroupRuntimeDockerPort,
  MatchmakerConfig: () => MatchmakerConfig,
  NetworkMode: () => NetworkMode5,
  PortProtocol: () => PortProtocol5,
  PortRange: () => PortRange,
  ProxyKind: () => ProxyKind2,
  common: () => common_exports20,
  gameMode: () => gameMode_exports2,
  lobbyGroup: () => lobbyGroup_exports2
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/common/index.ts
var common_exports20 = {};
__export(common_exports20, {
  Captcha: () => Captcha,
  CaptchaHcaptcha: () => CaptchaHcaptcha,
  CaptchaHcaptchaLevel: () => CaptchaHcaptchaLevel2,
  CaptchaTurnstile: () => CaptchaTurnstile,
  NetworkMode: () => NetworkMode5,
  PortProtocol: () => PortProtocol5,
  PortRange: () => PortRange,
  ProxyKind: () => ProxyKind2
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/gameMode/index.ts
var gameMode_exports2 = {};
__export(gameMode_exports2, {
  GameMode: () => GameMode,
  GameModeActions: () => GameModeActions,
  GameModeCreateConfig: () => GameModeCreateConfig,
  GameModeFindConfig: () => GameModeFindConfig,
  GameModeIdentityRequirement: () => GameModeIdentityRequirement2,
  GameModeIdleLobbiesConfig: () => GameModeIdleLobbiesConfig,
  GameModeJoinConfig: () => GameModeJoinConfig,
  GameModeRegion: () => GameModeRegion,
  GameModeRuntimeDocker: () => GameModeRuntimeDocker,
  GameModeRuntimeDockerPort: () => GameModeRuntimeDockerPort,
  GameModeVerificationConfig: () => GameModeVerificationConfig
});

// src/serialization/resources/cloud/resources/version/resources/matchmaker/resources/lobbyGroup/index.ts
var lobbyGroup_exports2 = {};
__export(lobbyGroup_exports2, {
  LobbyGroup: () => LobbyGroup,
  LobbyGroupIdleLobbiesConfig: () => LobbyGroupIdleLobbiesConfig,
  LobbyGroupRegion: () => LobbyGroupRegion,
  LobbyGroupRuntime: () => LobbyGroupRuntime,
  LobbyGroupRuntimeDocker: () => LobbyGroupRuntimeDocker,
  LobbyGroupRuntimeDockerEnvVar: () => LobbyGroupRuntimeDockerEnvVar,
  LobbyGroupRuntimeDockerPort: () => LobbyGroupRuntimeDockerPort
});

// src/serialization/resources/cloud/resources/auth/index.ts
var auth_exports3 = {};
__export(auth_exports3, {
  InspectResponse: () => InspectResponse2
});

// src/serialization/resources/cloud/resources/auth/types/InspectResponse.ts
var InspectResponse2 = schemas_exports.object({
  agent: AuthAgent
});

// src/serialization/resources/cloud/resources/common/index.ts
var common_exports21 = {};
__export(common_exports21, {
  AuthAgent: () => AuthAgent,
  AuthAgentGameCloud: () => AuthAgentGameCloud,
  AuthAgentIdentity: () => AuthAgentIdentity,
  BuildSummary: () => BuildSummary,
  CdnAuthType: () => CdnAuthType2,
  CdnNamespaceAuthUser: () => CdnNamespaceAuthUser,
  CdnNamespaceConfig: () => CdnNamespaceConfig,
  CdnNamespaceDomain: () => CdnNamespaceDomain,
  CdnNamespaceDomainVerificationMethod: () => CdnNamespaceDomainVerificationMethod,
  CdnNamespaceDomainVerificationMethodHttp: () => CdnNamespaceDomainVerificationMethodHttp,
  CdnNamespaceDomainVerificationStatus: () => CdnNamespaceDomainVerificationStatus2,
  CdnSiteSummary: () => CdnSiteSummary,
  CustomAvatarSummary: () => CustomAvatarSummary,
  GameFull: () => GameFull,
  GameLobbyExpenses: () => GameLobbyExpenses,
  GroupBankSource: () => GroupBankSource,
  IdentityNamespaceConfig: () => IdentityNamespaceConfig,
  KvNamespaceConfig: () => KvNamespaceConfig,
  LobbySummaryAnalytics: () => LobbySummaryAnalytics,
  LogsLobbyStatus: () => LogsLobbyStatus,
  LogsLobbyStatusStopped: () => LogsLobbyStatusStopped,
  LogsLobbySummary: () => LogsLobbySummary,
  LogsPerfMark: () => LogsPerfMark,
  LogsPerfSpan: () => LogsPerfSpan,
  MatchmakerDevelopmentPort: () => MatchmakerDevelopmentPort,
  MatchmakerNamespaceConfig: () => MatchmakerNamespaceConfig,
  NamespaceConfig: () => NamespaceConfig,
  NamespaceFull: () => NamespaceFull,
  NamespaceSummary: () => NamespaceSummary,
  NamespaceVersion: () => NamespaceVersion,
  RegionSummary: () => RegionSummary,
  RegionTier: () => RegionTier,
  RegionTierExpenses: () => RegionTierExpenses,
  SvcMetrics: () => SvcMetrics,
  SvcPerf: () => SvcPerf,
  UniversalRegion: () => UniversalRegion2
});

// src/serialization/resources/game/resources/common/types/Handle.ts
var Handle2 = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", Identifier),
  displayName: schemas_exports.property("display_name", DisplayName),
  logoUrl: schemas_exports.property("logo_url", schemas_exports.string().optional()),
  bannerUrl: schemas_exports.property("banner_url", schemas_exports.string().optional())
});

// src/serialization/resources/cloud/resources/common/types/RegionTierExpenses.ts
var RegionTierExpenses = schemas_exports.object({
  namespaceId: schemas_exports.property("namespace_id", schemas_exports.string()),
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  tierNameId: schemas_exports.property("tier_name_id", schemas_exports.string()),
  lobbyGroupNameId: schemas_exports.property("lobby_group_name_id", schemas_exports.string()),
  uptime: schemas_exports.number(),
  expenses: schemas_exports.number()
});

// src/serialization/resources/cloud/resources/common/types/GameLobbyExpenses.ts
var GameLobbyExpenses = schemas_exports.object({
  game: Handle2,
  namespaces: schemas_exports.list(NamespaceSummary),
  expenses: schemas_exports.list(RegionTierExpenses)
});

// src/serialization/resources/cloud/resources/common/types/GroupBankSource.ts
var GroupBankSource = schemas_exports.object({
  accountNumber: schemas_exports.property("account_number", schemas_exports.string()),
  routingNumber: schemas_exports.property("routing_number", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/common/types/RegionTier.ts
var RegionTier = schemas_exports.object({
  tierNameId: schemas_exports.property("tier_name_id", schemas_exports.string()),
  rivetCoresNumerator: schemas_exports.property("rivet_cores_numerator", schemas_exports.number()),
  rivetCoresDenominator: schemas_exports.property("rivet_cores_denominator", schemas_exports.number()),
  cpu: schemas_exports.number(),
  memory: schemas_exports.number(),
  disk: schemas_exports.number(),
  bandwidth: schemas_exports.number(),
  pricePerSecond: schemas_exports.property("price_per_second", schemas_exports.number())
});

// src/serialization/resources/cloud/resources/devices/index.ts
var devices_exports2 = {};
__export(devices_exports2, {
  CompleteDeviceLinkRequest: () => CompleteDeviceLinkRequest,
  GetDeviceLinkResponse: () => GetDeviceLinkResponse,
  PrepareDeviceLinkResponse: () => PrepareDeviceLinkResponse,
  links: () => links_exports2
});

// src/serialization/resources/cloud/resources/devices/resources/links/index.ts
var links_exports2 = {};
__export(links_exports2, {
  CompleteDeviceLinkRequest: () => CompleteDeviceLinkRequest,
  GetDeviceLinkResponse: () => GetDeviceLinkResponse,
  PrepareDeviceLinkResponse: () => PrepareDeviceLinkResponse
});

// src/serialization/resources/cloud/resources/devices/resources/links/types/PrepareDeviceLinkResponse.ts
var PrepareDeviceLinkResponse = schemas_exports.object({
  deviceLinkId: schemas_exports.property("device_link_id", schemas_exports.string()),
  deviceLinkToken: schemas_exports.property("device_link_token", schemas_exports.string()),
  deviceLinkUrl: schemas_exports.property("device_link_url", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/devices/resources/links/types/GetDeviceLinkResponse.ts
var GetDeviceLinkResponse = schemas_exports.object({
  cloudToken: schemas_exports.property("cloud_token", schemas_exports.string().optional()),
  watch: WatchResponse
});

// src/serialization/resources/common/types/Jwt.ts
var Jwt = schemas_exports.string();

// src/serialization/resources/cloud/resources/devices/resources/links/types/CompleteDeviceLinkRequest.ts
var CompleteDeviceLinkRequest = schemas_exports.object({
  deviceLinkToken: schemas_exports.property("device_link_token", Jwt),
  gameId: schemas_exports.property("game_id", schemas_exports.string())
});

// src/serialization/resources/cloud/resources/groups/index.ts
var groups_exports2 = {};
__export(groups_exports2, {
  ValidateGroupRequest: () => ValidateGroupRequest,
  ValidateGroupResponse: () => ValidateGroupResponse
});

// src/serialization/resources/cloud/resources/groups/types/ValidateGroupRequest.ts
var ValidateGroupRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/cloud/resources/groups/types/ValidateGroupResponse.ts
var ValidateGroupResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/cloud/resources/logs/index.ts
var logs_exports7 = {};
__export(logs_exports7, {
  GetRayPerfLogsResponse: () => GetRayPerfLogsResponse
});

// src/serialization/resources/cloud/resources/logs/types/GetRayPerfLogsResponse.ts
var GetRayPerfLogsResponse = schemas_exports.object({
  perfLists: schemas_exports.property("perf_lists", schemas_exports.list(SvcPerf))
});

// src/serialization/resources/cloud/resources/tiers/index.ts
var tiers_exports2 = {};
__export(tiers_exports2, {
  GetRegionTiersResponse: () => GetRegionTiersResponse
});

// src/serialization/resources/cloud/resources/tiers/types/GetRegionTiersResponse.ts
var GetRegionTiersResponse = schemas_exports.object({
  tiers: schemas_exports.list(RegionTier)
});

// src/serialization/resources/coreIntercom/index.ts
var coreIntercom_exports2 = {};
__export(coreIntercom_exports2, {
  pegboard: () => pegboard_exports3
});

// src/serialization/resources/coreIntercom/resources/pegboard/index.ts
var pegboard_exports3 = {};
__export(pegboard_exports3, {
  MarkClientRegisteredRequest: () => MarkClientRegisteredRequest
});

// src/serialization/resources/coreIntercom/resources/pegboard/types/MarkClientRegisteredRequest.ts
var MarkClientRegisteredRequest = schemas_exports.object({
  serverId: schemas_exports.property("server_id", schemas_exports.string())
});

// src/serialization/resources/edgeIntercom/index.ts
var edgeIntercom_exports2 = {};
__export(edgeIntercom_exports2, {
  pegboard: () => pegboard_exports4
});

// src/serialization/resources/edgeIntercom/resources/pegboard/index.ts
var pegboard_exports4 = {};
__export(pegboard_exports4, {
  PrewarmImageRequest: () => PrewarmImageRequest,
  ToggleClientDrainRequest: () => ToggleClientDrainRequest
});

// src/serialization/resources/edgeIntercom/resources/pegboard/types/PrewarmImageRequest.ts
var PrewarmImageRequest = schemas_exports.object({});

// src/serialization/resources/edgeIntercom/resources/pegboard/types/ToggleClientDrainRequest.ts
var ToggleClientDrainRequest = schemas_exports.object({
  draining: schemas_exports.boolean(),
  drainCompleteTs: schemas_exports.property("drain_complete_ts", Timestamp.optional())
});

// src/serialization/resources/group/index.ts
var group_exports2 = {};
__export(group_exports2, {
  BannedIdentity: () => BannedIdentity,
  ConsumeInviteResponse: () => ConsumeInviteResponse,
  CreateInviteRequest: () => CreateInviteRequest,
  CreateInviteResponse: () => CreateInviteResponse,
  CreateRequest: () => CreateRequest,
  CreateResponse: () => CreateResponse,
  ExternalLinks: () => ExternalLinks,
  GetBansResponse: () => GetBansResponse,
  GetInviteResponse: () => GetInviteResponse,
  GetJoinRequestsResponse: () => GetJoinRequestsResponse,
  GetMembersResponse: () => GetMembersResponse,
  GetProfileResponse: () => GetProfileResponse,
  GetSummaryResponse: () => GetSummaryResponse,
  GroupSummary: () => GroupSummary,
  Handle: () => Handle,
  JoinRequest: () => JoinRequest,
  ListSuggestedResponse: () => ListSuggestedResponse,
  Member: () => Member,
  PrepareAvatarUploadRequest: () => PrepareAvatarUploadRequest,
  PrepareAvatarUploadResponse: () => PrepareAvatarUploadResponse,
  Profile: () => Profile,
  Publicity: () => Publicity2,
  ResolveJoinRequestRequest: () => ResolveJoinRequestRequest,
  TransferOwnershipRequest: () => TransferOwnershipRequest,
  UpdateProfileRequest: () => UpdateProfileRequest,
  ValidateProfileRequest: () => ValidateProfileRequest,
  ValidateProfileResponse: () => ValidateProfileResponse,
  common: () => common_exports22,
  invites: () => invites_exports2,
  joinRequests: () => joinRequests_exports2
});

// src/serialization/resources/group/types/ListSuggestedResponse.ts
var ListSuggestedResponse = schemas_exports.object({
  groups: schemas_exports.list(GroupSummary),
  watch: WatchResponse
});

// src/serialization/resources/group/types/CreateRequest.ts
var CreateRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/group/types/CreateResponse.ts
var CreateResponse = schemas_exports.object({
  groupId: schemas_exports.property("group_id", schemas_exports.string())
});

// src/serialization/resources/group/types/PrepareAvatarUploadRequest.ts
var PrepareAvatarUploadRequest = schemas_exports.object({
  path: schemas_exports.string(),
  mime: schemas_exports.string().optional(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/group/types/PrepareAvatarUploadResponse.ts
var PrepareAvatarUploadResponse = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequest: schemas_exports.property("presigned_request", PresignedRequest)
});

// src/serialization/resources/group/types/ValidateProfileRequest.ts
var ValidateProfileRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName.optional()),
  bio: DisplayName.optional(),
  publicity: Publicity2.optional()
});

// src/serialization/resources/group/types/ValidateProfileResponse.ts
var ValidateProfileResponse = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/common/types/AccountNumber.ts
var AccountNumber = schemas_exports.number();

// src/serialization/resources/identity/resources/common/types/ExternalLinks.ts
var ExternalLinks2 = schemas_exports.object({
  profile: schemas_exports.string(),
  settings: schemas_exports.string().optional()
});

// src/serialization/resources/identity/resources/common/types/Handle.ts
var Handle3 = schemas_exports.object({
  identityId: schemas_exports.property("identity_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  accountNumber: schemas_exports.property("account_number", AccountNumber),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string()),
  isRegistered: schemas_exports.property("is_registered", schemas_exports.boolean()),
  external: ExternalLinks2
});

// src/serialization/resources/group/resources/common/types/BannedIdentity.ts
var BannedIdentity = schemas_exports.object({
  identity: Handle3,
  banTs: schemas_exports.property("ban_ts", Timestamp)
});

// src/serialization/resources/group/types/GetBansResponse.ts
var GetBansResponse = schemas_exports.object({
  bannedIdentities: schemas_exports.property("banned_identities", schemas_exports.list(BannedIdentity)),
  anchor: schemas_exports.string().optional(),
  watch: WatchResponse
});

// src/serialization/resources/group/resources/common/types/JoinRequest.ts
var JoinRequest = schemas_exports.object({
  identity: Handle3,
  ts: Timestamp
});

// src/serialization/resources/group/types/GetJoinRequestsResponse.ts
var GetJoinRequestsResponse = schemas_exports.object({
  joinRequests: schemas_exports.property("join_requests", schemas_exports.list(JoinRequest)),
  anchor: schemas_exports.string().optional(),
  watch: WatchResponse
});

// src/serialization/resources/group/resources/common/types/Member.ts
var Member = schemas_exports.object({
  identity: Handle3
});

// src/serialization/resources/group/types/GetMembersResponse.ts
var GetMembersResponse = schemas_exports.object({
  members: schemas_exports.list(Member),
  anchor: schemas_exports.string().optional(),
  watch: WatchResponse
});

// src/serialization/resources/group/resources/common/types/Profile.ts
var Profile = schemas_exports.object({
  groupId: schemas_exports.property("group_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string().optional()),
  external: ExternalLinks,
  isDeveloper: schemas_exports.property("is_developer", schemas_exports.boolean().optional()),
  bio: schemas_exports.string(),
  isCurrentIdentityMember: schemas_exports.property(
    "is_current_identity_member",
    schemas_exports.boolean().optional()
  ),
  publicity: Publicity2,
  memberCount: schemas_exports.property("member_count", schemas_exports.number().optional()),
  members: schemas_exports.list(Member),
  joinRequests: schemas_exports.property("join_requests", schemas_exports.list(JoinRequest)),
  isCurrentIdentityRequestingJoin: schemas_exports.property(
    "is_current_identity_requesting_join",
    schemas_exports.boolean().optional()
  ),
  ownerIdentityId: schemas_exports.property("owner_identity_id", schemas_exports.string())
});

// src/serialization/resources/group/types/GetProfileResponse.ts
var GetProfileResponse = schemas_exports.object({
  group: Profile,
  watch: WatchResponse
});

// src/serialization/resources/group/types/UpdateProfileRequest.ts
var UpdateProfileRequest = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName.optional()),
  bio: schemas_exports.string().optional(),
  publicity: Publicity2.optional()
});

// src/serialization/resources/group/types/GetSummaryResponse.ts
var GetSummaryResponse = schemas_exports.object({
  group: GroupSummary
});

// src/serialization/resources/group/types/TransferOwnershipRequest.ts
var TransferOwnershipRequest = schemas_exports.object({
  newOwnerIdentityId: schemas_exports.property("new_owner_identity_id", schemas_exports.string())
});

// src/serialization/resources/group/resources/common/index.ts
var common_exports22 = {};
__export(common_exports22, {
  BannedIdentity: () => BannedIdentity,
  ExternalLinks: () => ExternalLinks,
  GroupSummary: () => GroupSummary,
  Handle: () => Handle,
  JoinRequest: () => JoinRequest,
  Member: () => Member,
  Profile: () => Profile,
  Publicity: () => Publicity2
});

// src/serialization/resources/group/resources/invites/index.ts
var invites_exports2 = {};
__export(invites_exports2, {
  ConsumeInviteResponse: () => ConsumeInviteResponse,
  CreateInviteRequest: () => CreateInviteRequest,
  CreateInviteResponse: () => CreateInviteResponse,
  GetInviteResponse: () => GetInviteResponse
});

// src/serialization/resources/group/resources/invites/types/GetInviteResponse.ts
var GetInviteResponse = schemas_exports.object({
  group: Handle
});

// src/serialization/resources/group/resources/invites/types/ConsumeInviteResponse.ts
var ConsumeInviteResponse = schemas_exports.object({
  groupId: schemas_exports.property("group_id", schemas_exports.string().optional())
});

// src/serialization/resources/group/resources/invites/types/CreateInviteRequest.ts
var CreateInviteRequest = schemas_exports.object({
  ttl: schemas_exports.number().optional(),
  useCount: schemas_exports.property("use_count", schemas_exports.number().optional())
});

// src/serialization/resources/group/resources/invites/types/CreateInviteResponse.ts
var CreateInviteResponse = schemas_exports.object({
  code: schemas_exports.string()
});

// src/serialization/resources/group/resources/joinRequests/index.ts
var joinRequests_exports2 = {};
__export(joinRequests_exports2, {
  ResolveJoinRequestRequest: () => ResolveJoinRequestRequest
});

// src/serialization/resources/group/resources/joinRequests/types/ResolveJoinRequestRequest.ts
var ResolveJoinRequestRequest = schemas_exports.object({
  resolution: schemas_exports.boolean().optional()
});

// src/serialization/resources/identity/index.ts
var identity_exports5 = {};
__export(identity_exports5, {
  DevState: () => DevState2,
  EmailLinkedAccount: () => EmailLinkedAccount,
  ExternalLinks: () => ExternalLinks2,
  GameActivity: () => GameActivity,
  GameLinkStatus: () => GameLinkStatus2,
  GetHandlesResponse: () => GetHandlesResponse,
  GetProfileResponse: () => GetProfileResponse2,
  GetSummariesResponse: () => GetSummariesResponse,
  GlobalEvent: () => GlobalEvent,
  GlobalEventIdentityUpdate: () => GlobalEventIdentityUpdate,
  GlobalEventKind: () => GlobalEventKind,
  GlobalEventNotification: () => GlobalEventNotification,
  Group: () => Group,
  Handle: () => Handle3,
  LinkedAccount: () => LinkedAccount,
  ListActivitiesResponse: () => ListActivitiesResponse,
  PrepareAvatarUploadRequest: () => PrepareAvatarUploadRequest2,
  PrepareAvatarUploadResponse: () => PrepareAvatarUploadResponse2,
  Profile: () => Profile2,
  SetGameActivityRequest: () => SetGameActivityRequest,
  SetupRequest: () => SetupRequest,
  SetupResponse: () => SetupResponse,
  SignupForBetaRequest: () => SignupForBetaRequest,
  Status: () => Status2,
  Summary: () => Summary2,
  UpdateGameActivity: () => UpdateGameActivity,
  UpdateProfileRequest: () => UpdateProfileRequest2,
  UpdateStatusRequest: () => UpdateStatusRequest,
  ValidateProfileRequest: () => ValidateProfileRequest2,
  ValidateProfileResponse: () => ValidateProfileResponse2,
  WatchEventsResponse: () => WatchEventsResponse,
  activities: () => activities_exports2,
  common: () => common_exports23,
  events: () => events_exports2
});

// src/serialization/resources/identity/resources/common/types/DevState.ts
var DevState2 = schemas_exports.enum_(["inactive", "pending", "accepted"]);

// src/serialization/resources/common/types/Email.ts
var Email = schemas_exports.string();

// src/serialization/resources/identity/resources/common/types/EmailLinkedAccount.ts
var EmailLinkedAccount = schemas_exports.object({
  email: Email
});

// src/serialization/resources/identity/resources/common/types/LinkedAccount.ts
var LinkedAccount = schemas_exports.object({
  email: EmailLinkedAccount.optional(),
  defaultUser: schemas_exports.property("default_user", schemas_exports.boolean().optional())
});

// src/serialization/resources/identity/resources/common/types/Group.ts
var Group = schemas_exports.object({
  group: Handle
});

// src/serialization/resources/game/resources/common/types/StatFormatMethod.ts
var StatFormatMethod2 = schemas_exports.enum_([
  "integer",
  "float_1",
  "float_2",
  "float_3",
  "duration_minute",
  "duration_second",
  "duration_hundredth_second"
]);

// src/serialization/resources/game/resources/common/types/StatAggregationMethod.ts
var StatAggregationMethod2 = schemas_exports.enum_(["sum", "average", "min", "max"]);

// src/serialization/resources/game/resources/common/types/StatSortingMethod.ts
var StatSortingMethod2 = schemas_exports.enum_(["desc", "asc"]);

// src/serialization/resources/game/resources/common/types/StatConfig.ts
var StatConfig = schemas_exports.object({
  recordId: schemas_exports.property("record_id", schemas_exports.string()),
  iconId: schemas_exports.property("icon_id", schemas_exports.string()),
  format: StatFormatMethod2,
  aggregation: StatAggregationMethod2,
  sorting: StatSortingMethod2,
  priority: schemas_exports.number(),
  displayName: schemas_exports.property("display_name", DisplayName),
  postfixSingular: schemas_exports.property("postfix_singular", schemas_exports.string().optional()),
  postfixPlural: schemas_exports.property("postfix_plural", schemas_exports.string().optional()),
  prefixSingular: schemas_exports.property("prefix_singular", schemas_exports.string().optional()),
  prefixPlural: schemas_exports.property("prefix_plural", schemas_exports.string().optional())
});

// src/serialization/resources/game/resources/common/types/Stat.ts
var Stat = schemas_exports.object({
  config: StatConfig,
  overallValue: schemas_exports.property("overall_value", schemas_exports.number())
});

// src/serialization/resources/game/resources/common/types/StatSummary.ts
var StatSummary = schemas_exports.object({
  game: Handle2,
  stats: schemas_exports.list(Stat)
});

// src/serialization/resources/identity/resources/common/types/Profile.ts
var Profile2 = schemas_exports.object({
  identityId: schemas_exports.property("identity_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  accountNumber: schemas_exports.property("account_number", AccountNumber),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string()),
  isRegistered: schemas_exports.property("is_registered", schemas_exports.boolean()),
  external: ExternalLinks2,
  isAdmin: schemas_exports.property("is_admin", schemas_exports.boolean()),
  isGameLinked: schemas_exports.property("is_game_linked", schemas_exports.boolean().optional()),
  devState: schemas_exports.property("dev_state", DevState2.optional()),
  followerCount: schemas_exports.property("follower_count", schemas_exports.number()),
  followingCount: schemas_exports.property("following_count", schemas_exports.number()),
  following: schemas_exports.boolean(),
  isFollowingMe: schemas_exports.property("is_following_me", schemas_exports.boolean()),
  isMutualFollowing: schemas_exports.property("is_mutual_following", schemas_exports.boolean()),
  joinTs: schemas_exports.property("join_ts", Timestamp),
  bio: Bio,
  linkedAccounts: schemas_exports.property("linked_accounts", schemas_exports.list(LinkedAccount)),
  groups: schemas_exports.list(Group),
  games: schemas_exports.list(StatSummary),
  awaitingDeletion: schemas_exports.property("awaiting_deletion", schemas_exports.boolean().optional())
});

// src/serialization/resources/identity/types/SetupResponse.ts
var SetupResponse = schemas_exports.object({
  identityToken: schemas_exports.property("identity_token", Jwt),
  identityTokenExpireTs: schemas_exports.property("identity_token_expire_ts", Timestamp),
  identity: Profile2,
  gameId: schemas_exports.property("game_id", schemas_exports.string())
});

// src/serialization/resources/identity/types/GetProfileResponse.ts
var GetProfileResponse2 = schemas_exports.object({
  identity: Profile2,
  watch: WatchResponse
});

// src/serialization/resources/identity/types/GetHandlesResponse.ts
var GetHandlesResponse = schemas_exports.object({
  identities: schemas_exports.list(Handle3),
  watch: WatchResponse
});

// src/serialization/resources/identity/resources/common/types/Summary.ts
var Summary2 = schemas_exports.object({
  identityId: schemas_exports.property("identity_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  accountNumber: schemas_exports.property("account_number", AccountNumber),
  avatarUrl: schemas_exports.property("avatar_url", schemas_exports.string()),
  isRegistered: schemas_exports.property("is_registered", schemas_exports.boolean()),
  external: ExternalLinks2,
  following: schemas_exports.boolean(),
  isFollowingMe: schemas_exports.property("is_following_me", schemas_exports.boolean()),
  isMutualFollowing: schemas_exports.property("is_mutual_following", schemas_exports.boolean())
});

// src/serialization/resources/identity/types/GetSummariesResponse.ts
var GetSummariesResponse = schemas_exports.object({
  identities: schemas_exports.list(Summary2),
  watch: WatchResponse
});

// src/serialization/resources/identity/types/ValidateProfileResponse.ts
var ValidateProfileResponse2 = schemas_exports.object({
  errors: schemas_exports.list(ValidationError5)
});

// src/serialization/resources/identity/types/PrepareAvatarUploadResponse.ts
var PrepareAvatarUploadResponse2 = schemas_exports.object({
  uploadId: schemas_exports.property("upload_id", schemas_exports.string()),
  presignedRequest: schemas_exports.property("presigned_request", PresignedRequest)
});

// src/serialization/resources/identity/resources/activities/index.ts
var activities_exports2 = {};
__export(activities_exports2, {
  ListActivitiesResponse: () => ListActivitiesResponse
});

// src/serialization/resources/identity/resources/activities/types/ListActivitiesResponse.ts
var ListActivitiesResponse = schemas_exports.object({
  identities: schemas_exports.list(Handle3),
  games: schemas_exports.list(GameSummary),
  suggestedGroups: schemas_exports.property("suggested_groups", schemas_exports.list(GroupSummary)),
  suggestedPlayers: schemas_exports.property("suggested_players", schemas_exports.list(Handle3)),
  watch: WatchResponse
});

// src/serialization/resources/identity/resources/common/index.ts
var common_exports23 = {};
__export(common_exports23, {
  DevState: () => DevState2,
  EmailLinkedAccount: () => EmailLinkedAccount,
  ExternalLinks: () => ExternalLinks2,
  GameActivity: () => GameActivity,
  GameLinkStatus: () => GameLinkStatus2,
  GlobalEvent: () => GlobalEvent,
  GlobalEventIdentityUpdate: () => GlobalEventIdentityUpdate,
  GlobalEventKind: () => GlobalEventKind,
  GlobalEventNotification: () => GlobalEventNotification,
  Group: () => Group,
  Handle: () => Handle3,
  LinkedAccount: () => LinkedAccount,
  Profile: () => Profile2,
  Status: () => Status2,
  Summary: () => Summary2,
  UpdateGameActivity: () => UpdateGameActivity
});

// src/serialization/resources/identity/resources/common/types/GlobalEventIdentityUpdate.ts
var GlobalEventIdentityUpdate = schemas_exports.object({
  identity: Profile2
});

// src/serialization/resources/identity/resources/common/types/GlobalEventKind.ts
var GlobalEventKind = schemas_exports.object({
  identityUpdate: schemas_exports.property("identity_update", GlobalEventIdentityUpdate.optional())
});

// src/serialization/resources/identity/resources/common/types/GlobalEventNotification.ts
var GlobalEventNotification = schemas_exports.object({
  title: schemas_exports.string(),
  description: schemas_exports.string(),
  thumbnailUrl: schemas_exports.property("thumbnail_url", schemas_exports.string()),
  url: schemas_exports.string()
});

// src/serialization/resources/identity/resources/common/types/GlobalEvent.ts
var GlobalEvent = schemas_exports.object({
  ts: Timestamp,
  kind: GlobalEventKind,
  notification: GlobalEventNotification.optional()
});

// src/serialization/resources/identity/resources/common/types/UpdateGameActivity.ts
var UpdateGameActivity = schemas_exports.object({
  message: schemas_exports.string().optional(),
  publicMetadata: schemas_exports.property("public_metadata", schemas_exports.unknown().optional()),
  mutualMetadata: schemas_exports.property("mutual_metadata", schemas_exports.unknown().optional())
});

// src/serialization/resources/identity/resources/common/types/Status.ts
var Status2 = schemas_exports.enum_(["online", "away", "offline"]);

// src/serialization/resources/identity/resources/common/types/GameActivity.ts
var GameActivity = schemas_exports.object({
  game: Handle2,
  message: schemas_exports.string(),
  publicMetadata: schemas_exports.property("public_metadata", schemas_exports.unknown().optional()),
  mutualMetadata: schemas_exports.property("mutual_metadata", schemas_exports.unknown().optional())
});

// src/serialization/resources/identity/resources/common/types/GameLinkStatus.ts
var GameLinkStatus2 = schemas_exports.enum_(["incomplete", "complete", "cancelled"]);

// src/serialization/resources/identity/resources/events/index.ts
var events_exports2 = {};
__export(events_exports2, {
  WatchEventsResponse: () => WatchEventsResponse
});

// src/serialization/resources/identity/resources/events/types/WatchEventsResponse.ts
var WatchEventsResponse = schemas_exports.object({
  events: schemas_exports.list(GlobalEvent),
  watch: WatchResponse
});

// src/serialization/resources/identity/client/requests/SetupRequest.ts
var SetupRequest = schemas_exports.object({
  existingIdentityToken: schemas_exports.property("existing_identity_token", Jwt.optional())
});

// src/serialization/resources/identity/client/requests/UpdateProfileRequest.ts
var UpdateProfileRequest2 = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName.optional()),
  accountNumber: schemas_exports.property("account_number", AccountNumber.optional()),
  bio: Bio.optional()
});

// src/serialization/resources/identity/client/requests/ValidateProfileRequest.ts
var ValidateProfileRequest2 = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName.optional()),
  accountNumber: schemas_exports.property("account_number", AccountNumber.optional()),
  bio: Bio.optional()
});

// src/serialization/resources/identity/client/requests/SetGameActivityRequest.ts
var SetGameActivityRequest = schemas_exports.object({
  gameActivity: schemas_exports.property("game_activity", UpdateGameActivity)
});

// src/serialization/resources/identity/client/requests/UpdateStatusRequest.ts
var UpdateStatusRequest = schemas_exports.object({
  status: Status2
});

// src/serialization/resources/identity/client/requests/PrepareAvatarUploadRequest.ts
var PrepareAvatarUploadRequest2 = schemas_exports.object({
  path: schemas_exports.string(),
  mime: schemas_exports.string(),
  contentLength: schemas_exports.property("content_length", schemas_exports.number())
});

// src/serialization/resources/identity/client/requests/SignupForBetaRequest.ts
var SignupForBetaRequest = schemas_exports.object({
  name: schemas_exports.string(),
  companyName: schemas_exports.property("company_name", schemas_exports.string().optional()),
  companySize: schemas_exports.property("company_size", schemas_exports.string()),
  preferredTools: schemas_exports.property("preferred_tools", schemas_exports.string()),
  goals: schemas_exports.string()
});

// src/serialization/resources/provision/index.ts
var provision_exports2 = {};
__export(provision_exports2, {
  PoolType: () => PoolType2,
  Server: () => Server,
  common: () => common_exports24,
  datacenters: () => datacenters_exports3,
  servers: () => servers_exports3,
  tunnel: () => tunnel_exports2
});

// src/serialization/resources/provision/resources/datacenters/index.ts
var datacenters_exports3 = {};
__export(datacenters_exports3, {
  GetServersResponse: () => GetServersResponse,
  GetTlsResponse: () => GetTlsResponse
});

// src/serialization/resources/provision/resources/datacenters/types/GetTlsResponse.ts
var GetTlsResponse = schemas_exports.object({
  jobCertPem: schemas_exports.property("job_cert_pem", schemas_exports.string()),
  jobPrivateKeyPem: schemas_exports.property("job_private_key_pem", schemas_exports.string()),
  apiCertPem: schemas_exports.property("api_cert_pem", schemas_exports.string()),
  apiPrivateKeyPem: schemas_exports.property("api_private_key_pem", schemas_exports.string())
});

// src/serialization/resources/provision/resources/common/types/PoolType.ts
var PoolType2 = schemas_exports.enum_(["job", "gg", "ats", "pegboard", "pegboard_isolate", "fdb", "worker", "nats", "guard"]);

// src/serialization/resources/provision/resources/common/types/Server.ts
var Server = schemas_exports.object({
  serverId: schemas_exports.property("server_id", schemas_exports.string()),
  datacenterId: schemas_exports.property("datacenter_id", schemas_exports.string()),
  poolType: schemas_exports.property("pool_type", PoolType2),
  lanIp: schemas_exports.property("lan_ip", schemas_exports.string().optional()),
  wanIp: schemas_exports.property("wan_ip", schemas_exports.string().optional())
});

// src/serialization/resources/provision/resources/datacenters/types/GetServersResponse.ts
var GetServersResponse = schemas_exports.object({
  servers: schemas_exports.list(Server)
});

// src/serialization/resources/provision/resources/servers/index.ts
var servers_exports3 = {};
__export(servers_exports3, {
  GetInfoResponse: () => GetInfoResponse
});

// src/serialization/resources/provision/resources/servers/types/GetInfoResponse.ts
var GetInfoResponse = schemas_exports.object({
  name: schemas_exports.string(),
  serverId: schemas_exports.property("server_id", schemas_exports.string()),
  datacenterId: schemas_exports.property("datacenter_id", schemas_exports.string()),
  datacenterNameId: schemas_exports.property("datacenter_name_id", schemas_exports.string()),
  clusterId: schemas_exports.property("cluster_id", schemas_exports.string()),
  lanIp: schemas_exports.property("lan_ip", schemas_exports.string()),
  wanIp: schemas_exports.property("wan_ip", schemas_exports.string()),
  vlanIp: schemas_exports.property("vlan_ip", schemas_exports.string()),
  publicIp: schemas_exports.property("public_ip", schemas_exports.string())
});

// src/serialization/resources/provision/resources/tunnel/index.ts
var tunnel_exports2 = {};
__export(tunnel_exports2, {
  GetTlsResponse: () => GetTlsResponse2
});

// src/serialization/resources/provision/resources/tunnel/types/GetTlsResponse.ts
var GetTlsResponse2 = schemas_exports.object({
  certPem: schemas_exports.property("cert_pem", schemas_exports.string()),
  rootCaCertPem: schemas_exports.property("root_ca_cert_pem", schemas_exports.string()),
  privateKeyPem: schemas_exports.property("private_key_pem", schemas_exports.string())
});

// src/serialization/resources/provision/resources/common/index.ts
var common_exports24 = {};
__export(common_exports24, {
  PoolType: () => PoolType2,
  Server: () => Server
});

// src/serialization/resources/regions/index.ts
var regions_exports3 = {};
__export(regions_exports3, {
  ListRegionsResponse: () => ListRegionsResponse,
  RecommendRegionResponse: () => RecommendRegionResponse,
  Region: () => Region,
  common: () => common_exports25
});

// src/serialization/resources/regions/resources/common/types/Region.ts
var Region = schemas_exports.object({
  id: schemas_exports.string(),
  name: schemas_exports.string()
});

// src/serialization/resources/regions/types/ListRegionsResponse.ts
var ListRegionsResponse = schemas_exports.object({
  regions: schemas_exports.list(Region)
});

// src/serialization/resources/regions/types/RecommendRegionResponse.ts
var RecommendRegionResponse = schemas_exports.object({
  region: Region
});

// src/serialization/resources/regions/resources/common/index.ts
var common_exports25 = {};
__export(common_exports25, {
  Region: () => Region
});

// src/serialization/resources/routes/index.ts
var routes_exports2 = {};
__export(routes_exports2, {
  DeleteRouteResponse: () => DeleteRouteResponse,
  HistoryResponse: () => HistoryResponse,
  ListRoutesResponse: () => ListRoutesResponse,
  Route: () => Route2,
  RouteTarget: () => RouteTarget,
  RouteTargetActors: () => RouteTargetActors,
  UpdateRouteBody: () => UpdateRouteBody,
  UpdateRouteResponse: () => UpdateRouteResponse,
  common: () => common_exports26
});

// src/serialization/resources/routes/resources/common/types/RouteTargetActors.ts
var RouteTargetActors = schemas_exports.object({
  selectorTags: schemas_exports.property(
    "selector_tags",
    schemas_exports.record(schemas_exports.string(), schemas_exports.string())
  )
});

// src/serialization/resources/routes/resources/common/types/RouteTarget.ts
var RouteTarget = schemas_exports.object({
  actors: RouteTargetActors.optional()
});

// src/serialization/resources/routes/resources/common/types/Route.ts
var Route2 = schemas_exports.object({
  id: schemas_exports.string(),
  createdAt: schemas_exports.property("created_at", Timestamp),
  updatedAt: schemas_exports.property("updated_at", Timestamp),
  hostname: schemas_exports.string(),
  path: schemas_exports.string(),
  routeSubpaths: schemas_exports.property("route_subpaths", schemas_exports.boolean()),
  stripPrefix: schemas_exports.property("strip_prefix", schemas_exports.boolean()),
  target: RouteTarget
});

// src/serialization/resources/routes/types/ListRoutesResponse.ts
var ListRoutesResponse = schemas_exports.object({
  routes: schemas_exports.list(Route2)
});

// src/serialization/resources/routes/types/UpdateRouteBody.ts
var UpdateRouteBody = schemas_exports.object({
  hostname: schemas_exports.string(),
  path: schemas_exports.string(),
  stripPrefix: schemas_exports.property("strip_prefix", schemas_exports.boolean()),
  routeSubpaths: schemas_exports.property("route_subpaths", schemas_exports.boolean()),
  target: RouteTarget
});

// src/serialization/resources/routes/types/UpdateRouteResponse.ts
var UpdateRouteResponse = schemas_exports.object({});

// src/serialization/resources/routes/types/DeleteRouteResponse.ts
var DeleteRouteResponse = schemas_exports.object({});

// src/serialization/resources/routes/types/HistoryResponse.ts
var HistoryResponse = schemas_exports.object({
  metricNames: schemas_exports.property("metric_names", schemas_exports.list(schemas_exports.string())),
  metricAttributes: schemas_exports.property(
    "metric_attributes",
    schemas_exports.list(schemas_exports.record(schemas_exports.string(), schemas_exports.string()))
  ),
  metricTypes: schemas_exports.property("metric_types", schemas_exports.list(schemas_exports.string())),
  metricValues: schemas_exports.property(
    "metric_values",
    schemas_exports.list(schemas_exports.list(schemas_exports.number()))
  )
});

// src/serialization/resources/routes/resources/common/index.ts
var common_exports26 = {};
__export(common_exports26, {
  Route: () => Route2,
  RouteTarget: () => RouteTarget,
  RouteTargetActors: () => RouteTargetActors
});

// src/serialization/resources/servers/index.ts
var servers_exports4 = {};
__export(servers_exports4, {
  Build: () => Build2,
  BuildCompression: () => BuildCompression6,
  BuildKind: () => BuildKind6,
  CreateBuildRequest: () => CreateBuildRequest,
  CreateBuildResponse: () => CreateBuildResponse,
  CreateServerNetworkRequest: () => CreateServerNetworkRequest,
  CreateServerPortRequest: () => CreateServerPortRequest,
  CreateServerRequest: () => CreateServerRequest,
  CreateServerResponse: () => CreateServerResponse,
  CreateServerRuntimeRequest: () => CreateServerRuntimeRequest,
  Datacenter: () => Datacenter,
  DestroyServerResponse: () => DestroyServerResponse,
  GameGuardRouting: () => GameGuardRouting,
  GetBuildResponse: () => GetBuildResponse2,
  GetServerLogsResponse: () => GetServerLogsResponse,
  GetServerResponse: () => GetServerResponse,
  HostRouting: () => HostRouting2,
  Lifecycle: () => Lifecycle2,
  ListBuildsResponse: () => ListBuildsResponse2,
  ListDatacentersResponse: () => ListDatacentersResponse,
  ListServersResponse: () => ListServersResponse,
  LogStream: () => LogStream4,
  Network: () => Network2,
  NetworkMode: () => NetworkMode6,
  PatchBuildTagsRequest: () => PatchBuildTagsRequest2,
  PatchBuildTagsResponse: () => PatchBuildTagsResponse2,
  Port: () => Port2,
  PortProtocol: () => PortProtocol6,
  PortRouting: () => PortRouting2,
  Resources: () => Resources2,
  Runtime: () => Runtime2,
  Server: () => Server2,
  builds: () => builds_exports6,
  common: () => common_exports27,
  datacenters: () => datacenters_exports4,
  logs: () => logs_exports8
});

// src/serialization/resources/servers/resources/common/types/Runtime.ts
var Runtime2 = schemas_exports.object({
  build: schemas_exports.string(),
  arguments: schemas_exports.list(schemas_exports.string()).optional(),
  environment: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional()
});

// src/serialization/resources/servers/resources/common/types/NetworkMode.ts
var NetworkMode6 = schemas_exports.enum_(["bridge", "host"]);

// src/serialization/resources/servers/resources/common/types/PortProtocol.ts
var PortProtocol6 = schemas_exports.enum_(["http", "https", "tcp", "tcp_tls", "udp"]);

// src/serialization/resources/servers/resources/common/types/GameGuardRouting.ts
var GameGuardRouting = schemas_exports.object({});

// src/serialization/resources/servers/resources/common/types/HostRouting.ts
var HostRouting2 = schemas_exports.object({});

// src/serialization/resources/servers/resources/common/types/PortRouting.ts
var PortRouting2 = schemas_exports.object({
  gameGuard: schemas_exports.property("game_guard", GameGuardRouting.optional()),
  host: HostRouting2.optional()
});

// src/serialization/resources/servers/resources/common/types/Port.ts
var Port2 = schemas_exports.object({
  protocol: PortProtocol6,
  internalPort: schemas_exports.property("internal_port", schemas_exports.number().optional()),
  publicHostname: schemas_exports.property("public_hostname", schemas_exports.string().optional()),
  publicPort: schemas_exports.property("public_port", schemas_exports.number().optional()),
  routing: PortRouting2
});

// src/serialization/resources/servers/resources/common/types/Network.ts
var Network2 = schemas_exports.object({
  mode: NetworkMode6.optional(),
  ports: schemas_exports.record(schemas_exports.string(), Port2)
});

// src/serialization/resources/servers/resources/common/types/Resources.ts
var Resources2 = schemas_exports.object({
  cpu: schemas_exports.number(),
  memory: schemas_exports.number()
});

// src/serialization/resources/servers/resources/common/types/Lifecycle.ts
var Lifecycle2 = schemas_exports.object({
  killTimeout: schemas_exports.property("kill_timeout", schemas_exports.number().optional())
});

// src/serialization/resources/servers/resources/common/types/Server.ts
var Server2 = schemas_exports.object({
  id: schemas_exports.string(),
  environment: schemas_exports.string(),
  datacenter: schemas_exports.string(),
  tags: schemas_exports.unknown(),
  runtime: Runtime2,
  network: Network2,
  resources: Resources2,
  lifecycle: Lifecycle2,
  createdAt: schemas_exports.property("created_at", schemas_exports.number()),
  startedAt: schemas_exports.property("started_at", schemas_exports.number().optional()),
  destroyedAt: schemas_exports.property("destroyed_at", schemas_exports.number().optional())
});

// src/serialization/resources/servers/types/GetServerResponse.ts
var GetServerResponse = schemas_exports.object({
  server: Server2
});

// src/serialization/resources/servers/types/CreateServerRuntimeRequest.ts
var CreateServerRuntimeRequest = schemas_exports.object({
  build: schemas_exports.string(),
  arguments: schemas_exports.list(schemas_exports.string()).optional(),
  environment: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional()
});

// src/serialization/resources/servers/types/CreateServerPortRequest.ts
var CreateServerPortRequest = schemas_exports.object({
  protocol: PortProtocol6,
  internalPort: schemas_exports.property("internal_port", schemas_exports.number().optional()),
  routing: PortRouting2.optional()
});

// src/serialization/resources/servers/types/CreateServerNetworkRequest.ts
var CreateServerNetworkRequest = schemas_exports.object({
  mode: NetworkMode6.optional(),
  ports: schemas_exports.record(schemas_exports.string(), CreateServerPortRequest)
});

// src/serialization/resources/servers/types/CreateServerRequest.ts
var CreateServerRequest = schemas_exports.object({
  datacenter: schemas_exports.string(),
  tags: schemas_exports.unknown(),
  runtime: CreateServerRuntimeRequest,
  network: CreateServerNetworkRequest,
  resources: Resources2,
  lifecycle: Lifecycle2.optional()
});

// src/serialization/resources/servers/types/CreateServerResponse.ts
var CreateServerResponse = schemas_exports.object({
  server: Server2
});

// src/serialization/resources/servers/types/DestroyServerResponse.ts
var DestroyServerResponse = schemas_exports.object({});

// src/serialization/resources/servers/types/ListServersResponse.ts
var ListServersResponse = schemas_exports.object({
  servers: schemas_exports.list(Server2)
});

// src/serialization/resources/servers/resources/builds/index.ts
var builds_exports6 = {};
__export(builds_exports6, {
  BuildCompression: () => BuildCompression6,
  BuildKind: () => BuildKind6,
  CreateBuildRequest: () => CreateBuildRequest,
  CreateBuildResponse: () => CreateBuildResponse,
  GetBuildResponse: () => GetBuildResponse2,
  ListBuildsResponse: () => ListBuildsResponse2,
  PatchBuildTagsRequest: () => PatchBuildTagsRequest2,
  PatchBuildTagsResponse: () => PatchBuildTagsResponse2
});

// src/serialization/resources/servers/resources/common/types/Build.ts
var Build2 = schemas_exports.object({
  id: schemas_exports.string(),
  name: schemas_exports.string(),
  createdAt: schemas_exports.property("created_at", Timestamp),
  contentLength: schemas_exports.property("content_length", schemas_exports.number()),
  tags: schemas_exports.record(schemas_exports.string(), schemas_exports.string())
});

// src/serialization/resources/servers/resources/builds/types/GetBuildResponse.ts
var GetBuildResponse2 = schemas_exports.object({
  build: Build2
});

// src/serialization/resources/servers/resources/builds/types/ListBuildsResponse.ts
var ListBuildsResponse2 = schemas_exports.object({
  builds: schemas_exports.list(Build2)
});

// src/serialization/resources/servers/resources/builds/types/PatchBuildTagsRequest.ts
var PatchBuildTagsRequest2 = schemas_exports.object({
  tags: schemas_exports.unknown(),
  exclusiveTags: schemas_exports.property(
    "exclusive_tags",
    schemas_exports.list(schemas_exports.string()).optional()
  )
});

// src/serialization/resources/servers/resources/builds/types/PatchBuildTagsResponse.ts
var PatchBuildTagsResponse2 = schemas_exports.object({});

// src/serialization/resources/servers/resources/builds/types/BuildKind.ts
var BuildKind6 = schemas_exports.enum_(["docker_image", "oci_bundle"]);

// src/serialization/resources/servers/resources/builds/types/BuildCompression.ts
var BuildCompression6 = schemas_exports.enum_(["none", "lz4"]);

// src/serialization/resources/servers/resources/builds/types/CreateBuildRequest.ts
var CreateBuildRequest = schemas_exports.object({
  name: schemas_exports.string(),
  imageTag: schemas_exports.property("image_tag", schemas_exports.string()),
  imageFile: schemas_exports.property("image_file", PrepareFile),
  multipartUpload: schemas_exports.property("multipart_upload", schemas_exports.boolean().optional()),
  kind: BuildKind6.optional(),
  compression: BuildCompression6.optional(),
  prewarmDatacenters: schemas_exports.property(
    "prewarm_datacenters",
    schemas_exports.list(schemas_exports.string()).optional()
  )
});

// src/serialization/resources/servers/resources/builds/types/CreateBuildResponse.ts
var CreateBuildResponse = schemas_exports.object({
  build: schemas_exports.string(),
  imagePresignedRequest: schemas_exports.property("image_presigned_request", PresignedRequest.optional()),
  imagePresignedRequests: schemas_exports.property(
    "image_presigned_requests",
    schemas_exports.list(PresignedRequest).optional()
  )
});

// src/serialization/resources/servers/resources/common/index.ts
var common_exports27 = {};
__export(common_exports27, {
  Build: () => Build2,
  Datacenter: () => Datacenter,
  GameGuardRouting: () => GameGuardRouting,
  HostRouting: () => HostRouting2,
  Lifecycle: () => Lifecycle2,
  Network: () => Network2,
  NetworkMode: () => NetworkMode6,
  Port: () => Port2,
  PortProtocol: () => PortProtocol6,
  PortRouting: () => PortRouting2,
  Resources: () => Resources2,
  Runtime: () => Runtime2,
  Server: () => Server2
});

// src/serialization/resources/servers/resources/common/types/Datacenter.ts
var Datacenter = schemas_exports.object({
  id: schemas_exports.string(),
  slug: schemas_exports.string(),
  name: schemas_exports.string()
});

// src/serialization/resources/servers/resources/datacenters/index.ts
var datacenters_exports4 = {};
__export(datacenters_exports4, {
  ListDatacentersResponse: () => ListDatacentersResponse
});

// src/serialization/resources/servers/resources/datacenters/types/ListDatacentersResponse.ts
var ListDatacentersResponse = schemas_exports.object({
  datacenters: schemas_exports.list(Datacenter)
});

// src/serialization/resources/servers/resources/logs/index.ts
var logs_exports8 = {};
__export(logs_exports8, {
  GetServerLogsResponse: () => GetServerLogsResponse,
  LogStream: () => LogStream4
});

// src/serialization/resources/servers/resources/logs/types/GetServerLogsResponse.ts
var GetServerLogsResponse = schemas_exports.object({
  lines: schemas_exports.list(schemas_exports.string()),
  timestamps: schemas_exports.list(schemas_exports.string()),
  watch: WatchResponse
});

// src/serialization/resources/servers/resources/logs/types/LogStream.ts
var LogStream4 = schemas_exports.enum_(["std_out", "std_err"]);

// src/serialization/resources/auth/index.ts
var auth_exports4 = {};
__export(auth_exports4, {
  CompleteStatus: () => CompleteStatus2,
  RefreshIdentityTokenRequest: () => RefreshIdentityTokenRequest,
  RefreshIdentityTokenResponse: () => RefreshIdentityTokenResponse,
  common: () => common_exports28,
  identity: () => identity_exports6,
  tokens: () => tokens_exports5
});

// src/serialization/resources/auth/resources/common/index.ts
var common_exports28 = {};
__export(common_exports28, {
  CompleteStatus: () => CompleteStatus2
});

// src/serialization/resources/auth/resources/common/types/CompleteStatus.ts
var CompleteStatus2 = schemas_exports.enum_([
  "switch_identity",
  "linked_account_added",
  "already_complete",
  "expired",
  "too_many_attempts",
  "incorrect"
]);

// src/serialization/resources/auth/resources/identity/index.ts
var identity_exports6 = {};
__export(identity_exports6, {
  CompleteEmailVerificationRequest: () => CompleteEmailVerificationRequest,
  CompleteEmailVerificationResponse: () => CompleteEmailVerificationResponse,
  StartEmailVerificationRequest: () => StartEmailVerificationRequest,
  StartEmailVerificationResponse: () => StartEmailVerificationResponse,
  email: () => email_exports2
});

// src/serialization/resources/auth/resources/identity/resources/email/index.ts
var email_exports2 = {};
__export(email_exports2, {
  CompleteEmailVerificationRequest: () => CompleteEmailVerificationRequest,
  CompleteEmailVerificationResponse: () => CompleteEmailVerificationResponse,
  StartEmailVerificationRequest: () => StartEmailVerificationRequest,
  StartEmailVerificationResponse: () => StartEmailVerificationResponse
});

// src/serialization/resources/captcha/resources/config/types/ConfigHcaptcha.ts
var ConfigHcaptcha = schemas_exports.object({
  clientResponse: schemas_exports.property("client_response", schemas_exports.string())
});

// src/serialization/resources/captcha/resources/config/types/ConfigTurnstile.ts
var ConfigTurnstile = schemas_exports.object({
  clientResponse: schemas_exports.property("client_response", schemas_exports.string())
});

// src/serialization/resources/captcha/resources/config/types/Config.ts
var Config2 = schemas_exports.object({
  hcaptcha: ConfigHcaptcha.optional(),
  turnstile: ConfigTurnstile.optional()
});

// src/serialization/resources/auth/resources/identity/resources/email/types/StartEmailVerificationRequest.ts
var StartEmailVerificationRequest = schemas_exports.object({
  email: schemas_exports.string(),
  captcha: Config2.optional(),
  gameId: schemas_exports.property("game_id", schemas_exports.string().optional())
});

// src/serialization/resources/auth/resources/identity/resources/email/types/StartEmailVerificationResponse.ts
var StartEmailVerificationResponse = schemas_exports.object({
  verificationId: schemas_exports.property("verification_id", schemas_exports.string())
});

// src/serialization/resources/auth/resources/identity/resources/email/types/CompleteEmailVerificationRequest.ts
var CompleteEmailVerificationRequest = schemas_exports.object({
  verificationId: schemas_exports.property("verification_id", schemas_exports.string()),
  code: schemas_exports.string()
});

// src/serialization/resources/auth/resources/identity/resources/email/types/CompleteEmailVerificationResponse.ts
var CompleteEmailVerificationResponse = schemas_exports.object({
  status: CompleteStatus2
});

// src/serialization/resources/auth/resources/tokens/index.ts
var tokens_exports5 = {};
__export(tokens_exports5, {
  RefreshIdentityTokenRequest: () => RefreshIdentityTokenRequest,
  RefreshIdentityTokenResponse: () => RefreshIdentityTokenResponse
});

// src/serialization/resources/auth/resources/tokens/types/RefreshIdentityTokenRequest.ts
var RefreshIdentityTokenRequest = schemas_exports.object({
  logout: schemas_exports.boolean().optional()
});

// src/serialization/resources/auth/resources/tokens/types/RefreshIdentityTokenResponse.ts
var RefreshIdentityTokenResponse = schemas_exports.object({
  token: schemas_exports.string(),
  exp: schemas_exports.string(),
  identityId: schemas_exports.property("identity_id", schemas_exports.string())
});

// src/serialization/resources/captcha/index.ts
var captcha_exports2 = {};
__export(captcha_exports2, {
  Config: () => Config2,
  ConfigHcaptcha: () => ConfigHcaptcha,
  ConfigTurnstile: () => ConfigTurnstile,
  config: () => config_exports2
});

// src/serialization/resources/captcha/resources/config/index.ts
var config_exports2 = {};
__export(config_exports2, {
  Config: () => Config2,
  ConfigHcaptcha: () => ConfigHcaptcha,
  ConfigTurnstile: () => ConfigTurnstile
});

// src/serialization/resources/common/index.ts
var common_exports29 = {};
__export(common_exports29, {
  AccountNumber: () => AccountNumber,
  Bio: () => Bio,
  DisplayName: () => DisplayName,
  Email: () => Email,
  EmptyObject: () => EmptyObject,
  ErrorBody: () => ErrorBody,
  ErrorMetadata: () => ErrorMetadata,
  GlobalEventNotification: () => GlobalEventNotification2,
  Identifier: () => Identifier,
  Jwt: () => Jwt,
  Pagination: () => Pagination,
  Timestamp: () => Timestamp,
  ValidationError: () => ValidationError5,
  WatchQuery: () => WatchQuery,
  WatchResponse: () => WatchResponse
});

// src/serialization/resources/common/types/WatchQuery.ts
var WatchQuery = schemas_exports.string().optional();

// src/serialization/resources/common/types/GlobalEventNotification.ts
var GlobalEventNotification2 = schemas_exports.object({
  title: schemas_exports.string(),
  description: schemas_exports.string(),
  thumbnailUrl: schemas_exports.property("thumbnail_url", schemas_exports.string()),
  url: schemas_exports.string()
});

// src/serialization/resources/common/types/ErrorMetadata.ts
var ErrorMetadata = schemas_exports.unknown();

// src/serialization/resources/common/types/ErrorBody.ts
var ErrorBody = schemas_exports.object({
  code: schemas_exports.string(),
  message: schemas_exports.string(),
  rayId: schemas_exports.property("ray_id", schemas_exports.string()),
  documentation: schemas_exports.string().optional(),
  metadata: ErrorMetadata.optional()
});

// src/serialization/resources/game/index.ts
var game_exports2 = {};
__export(game_exports2, {
  GameSummary: () => GameSummary,
  Handle: () => Handle2,
  LeaderboardCategory: () => LeaderboardCategory,
  PlatformLink: () => PlatformLink,
  Profile: () => Profile3,
  Stat: () => Stat,
  StatAggregationMethod: () => StatAggregationMethod2,
  StatConfig: () => StatConfig,
  StatFormatMethod: () => StatFormatMethod2,
  StatSortingMethod: () => StatSortingMethod2,
  StatSummary: () => StatSummary,
  common: () => common_exports30
});

// src/serialization/resources/game/resources/common/index.ts
var common_exports30 = {};
__export(common_exports30, {
  GameSummary: () => GameSummary,
  Handle: () => Handle2,
  LeaderboardCategory: () => LeaderboardCategory,
  PlatformLink: () => PlatformLink,
  Profile: () => Profile3,
  Stat: () => Stat,
  StatAggregationMethod: () => StatAggregationMethod2,
  StatConfig: () => StatConfig,
  StatFormatMethod: () => StatFormatMethod2,
  StatSortingMethod: () => StatSortingMethod2,
  StatSummary: () => StatSummary
});

// src/serialization/resources/game/resources/common/types/PlatformLink.ts
var PlatformLink = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName),
  url: schemas_exports.string()
});

// src/serialization/resources/game/resources/common/types/LeaderboardCategory.ts
var LeaderboardCategory = schemas_exports.object({
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/game/resources/common/types/Profile.ts
var Profile3 = schemas_exports.object({
  gameId: schemas_exports.property("game_id", schemas_exports.string()),
  nameId: schemas_exports.property("name_id", schemas_exports.string()),
  displayName: schemas_exports.property("display_name", DisplayName),
  logoUrl: schemas_exports.property("logo_url", schemas_exports.string().optional()),
  bannerUrl: schemas_exports.property("banner_url", schemas_exports.string().optional()),
  url: schemas_exports.string(),
  developer: GroupSummary,
  tags: schemas_exports.list(schemas_exports.string()),
  description: schemas_exports.string(),
  platforms: schemas_exports.list(PlatformLink),
  recommendedGroups: schemas_exports.property("recommended_groups", schemas_exports.list(GroupSummary)),
  identityLeaderboardCategories: schemas_exports.property(
    "identity_leaderboard_categories",
    schemas_exports.list(LeaderboardCategory)
  ),
  groupLeaderboardCategories: schemas_exports.property(
    "group_leaderboard_categories",
    schemas_exports.list(LeaderboardCategory)
  )
});

// src/serialization/resources/games/index.ts
var games_exports5 = {};
__export(games_exports5, {
  environments: () => environments_exports2
});

// src/serialization/resources/games/resources/environments/index.ts
var environments_exports2 = {};
__export(environments_exports2, {
  CreateServiceTokenResponse: () => CreateServiceTokenResponse,
  tokens: () => tokens_exports6
});

// src/serialization/resources/games/resources/environments/resources/tokens/index.ts
var tokens_exports6 = {};
__export(tokens_exports6, {
  CreateServiceTokenResponse: () => CreateServiceTokenResponse
});

// src/serialization/resources/games/resources/environments/resources/tokens/types/CreateServiceTokenResponse.ts
var CreateServiceTokenResponse = schemas_exports.object({
  token: schemas_exports.string()
});

// src/serialization/resources/geo/index.ts
var geo_exports2 = {};
__export(geo_exports2, {
  Coord: () => Coord,
  Distance: () => Distance,
  common: () => common_exports31
});

// src/serialization/resources/geo/resources/common/index.ts
var common_exports31 = {};
__export(common_exports31, {
  Coord: () => Coord,
  Distance: () => Distance
});

// src/serialization/resources/geo/resources/common/types/Coord.ts
var Coord = schemas_exports.object({
  latitude: schemas_exports.number(),
  longitude: schemas_exports.number()
});

// src/serialization/resources/geo/resources/common/types/Distance.ts
var Distance = schemas_exports.object({
  kilometers: schemas_exports.number(),
  miles: schemas_exports.number()
});

// src/serialization/resources/matchmaker/index.ts
var matchmaker_exports6 = {};
__export(matchmaker_exports6, {
  CreateLobbyRequest: () => CreateLobbyRequest,
  CreateLobbyResponse: () => CreateLobbyResponse,
  CustomLobbyPublicity: () => CustomLobbyPublicity2,
  FindLobbyRequest: () => FindLobbyRequest,
  FindLobbyResponse: () => FindLobbyResponse,
  GameModeInfo: () => GameModeInfo,
  GameModeStatistics: () => GameModeStatistics,
  GetStatisticsResponse: () => GetStatisticsResponse,
  JoinLobby: () => JoinLobby,
  JoinLobbyRequest: () => JoinLobbyRequest,
  JoinLobbyResponse: () => JoinLobbyResponse,
  JoinPlayer: () => JoinPlayer,
  JoinPort: () => JoinPort,
  JoinPortRange: () => JoinPortRange,
  JoinRegion: () => JoinRegion,
  ListLobbiesResponse: () => ListLobbiesResponse,
  ListRegionsResponse: () => ListRegionsResponse2,
  LobbyInfo: () => LobbyInfo,
  PlayerConnectedRequest: () => PlayerConnectedRequest,
  PlayerDisconnectedRequest: () => PlayerDisconnectedRequest,
  RegionInfo: () => RegionInfo,
  RegionStatistics: () => RegionStatistics,
  SetLobbyClosedRequest: () => SetLobbyClosedRequest,
  common: () => common_exports32,
  lobbies: () => lobbies_exports2,
  players: () => players_exports2,
  regions: () => regions_exports4
});

// src/serialization/resources/matchmaker/resources/common/index.ts
var common_exports32 = {};
__export(common_exports32, {
  CustomLobbyPublicity: () => CustomLobbyPublicity2,
  GameModeInfo: () => GameModeInfo,
  JoinLobby: () => JoinLobby,
  JoinPlayer: () => JoinPlayer,
  JoinPort: () => JoinPort,
  JoinPortRange: () => JoinPortRange,
  JoinRegion: () => JoinRegion,
  LobbyInfo: () => LobbyInfo,
  RegionInfo: () => RegionInfo
});

// src/serialization/resources/matchmaker/resources/common/types/LobbyInfo.ts
var LobbyInfo = schemas_exports.object({
  regionId: schemas_exports.property("region_id", schemas_exports.string()),
  gameModeId: schemas_exports.property("game_mode_id", schemas_exports.string()),
  lobbyId: schemas_exports.property("lobby_id", schemas_exports.string()),
  maxPlayersNormal: schemas_exports.property("max_players_normal", schemas_exports.number()),
  maxPlayersDirect: schemas_exports.property("max_players_direct", schemas_exports.number()),
  maxPlayersParty: schemas_exports.property("max_players_party", schemas_exports.number()),
  totalPlayerCount: schemas_exports.property("total_player_count", schemas_exports.number()),
  state: schemas_exports.unknown().optional()
});

// src/serialization/resources/matchmaker/resources/common/types/GameModeInfo.ts
var GameModeInfo = schemas_exports.object({
  gameModeId: schemas_exports.property("game_mode_id", Identifier)
});

// src/serialization/resources/matchmaker/resources/common/types/RegionInfo.ts
var RegionInfo = schemas_exports.object({
  regionId: schemas_exports.property("region_id", Identifier),
  providerDisplayName: schemas_exports.property("provider_display_name", DisplayName),
  regionDisplayName: schemas_exports.property("region_display_name", DisplayName),
  datacenterCoord: schemas_exports.property("datacenter_coord", Coord),
  datacenterDistanceFromClient: schemas_exports.property("datacenter_distance_from_client", Distance)
});

// src/serialization/resources/matchmaker/resources/common/types/JoinRegion.ts
var JoinRegion = schemas_exports.object({
  regionId: schemas_exports.property("region_id", Identifier),
  displayName: schemas_exports.property("display_name", DisplayName)
});

// src/serialization/resources/matchmaker/resources/common/types/JoinPortRange.ts
var JoinPortRange = schemas_exports.object({
  min: schemas_exports.number(),
  max: schemas_exports.number()
});

// src/serialization/resources/matchmaker/resources/common/types/JoinPort.ts
var JoinPort = schemas_exports.object({
  host: schemas_exports.string().optional(),
  hostname: schemas_exports.string(),
  port: schemas_exports.number().optional(),
  portRange: schemas_exports.property("port_range", JoinPortRange.optional()),
  isTls: schemas_exports.property("is_tls", schemas_exports.boolean())
});

// src/serialization/resources/matchmaker/resources/common/types/JoinPlayer.ts
var JoinPlayer = schemas_exports.object({
  token: Jwt
});

// src/serialization/resources/matchmaker/resources/common/types/JoinLobby.ts
var JoinLobby = schemas_exports.object({
  lobbyId: schemas_exports.property("lobby_id", schemas_exports.string()),
  region: JoinRegion,
  ports: schemas_exports.record(schemas_exports.string(), JoinPort),
  player: JoinPlayer
});

// src/serialization/resources/matchmaker/resources/common/types/CustomLobbyPublicity.ts
var CustomLobbyPublicity2 = schemas_exports.enum_(["public", "private"]);

// src/serialization/resources/matchmaker/resources/lobbies/index.ts
var lobbies_exports2 = {};
__export(lobbies_exports2, {
  CreateLobbyRequest: () => CreateLobbyRequest,
  CreateLobbyResponse: () => CreateLobbyResponse,
  FindLobbyRequest: () => FindLobbyRequest,
  FindLobbyResponse: () => FindLobbyResponse,
  JoinLobbyRequest: () => JoinLobbyRequest,
  JoinLobbyResponse: () => JoinLobbyResponse,
  ListLobbiesResponse: () => ListLobbiesResponse,
  SetLobbyClosedRequest: () => SetLobbyClosedRequest,
  getState: () => getState_exports,
  setState: () => setState_exports
});

// src/serialization/resources/matchmaker/resources/lobbies/types/FindLobbyResponse.ts
var FindLobbyResponse = schemas_exports.object({
  lobby: JoinLobby,
  ports: schemas_exports.record(schemas_exports.string(), JoinPort),
  player: JoinPlayer
});

// src/serialization/resources/matchmaker/resources/lobbies/types/JoinLobbyResponse.ts
var JoinLobbyResponse = schemas_exports.object({
  lobby: JoinLobby,
  ports: schemas_exports.record(schemas_exports.string(), JoinPort),
  player: JoinPlayer
});

// src/serialization/resources/matchmaker/resources/lobbies/types/CreateLobbyResponse.ts
var CreateLobbyResponse = schemas_exports.object({
  lobby: JoinLobby,
  ports: schemas_exports.record(schemas_exports.string(), JoinPort),
  player: JoinPlayer
});

// src/serialization/resources/matchmaker/resources/lobbies/types/ListLobbiesResponse.ts
var ListLobbiesResponse = schemas_exports.object({
  gameModes: schemas_exports.property("game_modes", schemas_exports.list(GameModeInfo)),
  regions: schemas_exports.list(RegionInfo),
  lobbies: schemas_exports.list(LobbyInfo)
});

// src/serialization/resources/matchmaker/resources/lobbies/client/setState.ts
var setState_exports = {};
__export(setState_exports, {
  Request: () => Request
});
var Request = schemas_exports.unknown().optional();

// src/serialization/resources/matchmaker/resources/lobbies/client/getState.ts
var getState_exports = {};
__export(getState_exports, {
  Response: () => Response
});
var Response = schemas_exports.unknown().optional();

// src/serialization/resources/matchmaker/resources/lobbies/client/requests/SetLobbyClosedRequest.ts
var SetLobbyClosedRequest = schemas_exports.object({
  isClosed: schemas_exports.property("is_closed", schemas_exports.boolean())
});

// src/serialization/resources/matchmaker/resources/lobbies/client/requests/FindLobbyRequest.ts
var FindLobbyRequest = schemas_exports.object({
  gameModes: schemas_exports.property("game_modes", schemas_exports.list(schemas_exports.string())),
  regions: schemas_exports.list(schemas_exports.string()).optional(),
  preventAutoCreateLobby: schemas_exports.property(
    "prevent_auto_create_lobby",
    schemas_exports.boolean().optional()
  ),
  tags: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional(),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number().optional()),
  captcha: Config2.optional(),
  verificationData: schemas_exports.property("verification_data", schemas_exports.unknown().optional())
});

// src/serialization/resources/matchmaker/resources/lobbies/client/requests/JoinLobbyRequest.ts
var JoinLobbyRequest = schemas_exports.object({
  lobbyId: schemas_exports.property("lobby_id", schemas_exports.string()),
  captcha: Config2.optional(),
  verificationData: schemas_exports.property("verification_data", schemas_exports.unknown().optional())
});

// src/serialization/resources/matchmaker/resources/lobbies/client/requests/CreateLobbyRequest.ts
var CreateLobbyRequest = schemas_exports.object({
  gameMode: schemas_exports.property("game_mode", schemas_exports.string()),
  region: schemas_exports.string().optional(),
  publicity: CustomLobbyPublicity2.optional(),
  tags: schemas_exports.record(schemas_exports.string(), schemas_exports.string()).optional(),
  maxPlayers: schemas_exports.property("max_players", schemas_exports.number().optional()),
  lobbyConfig: schemas_exports.property("lobby_config", schemas_exports.unknown().optional()),
  captcha: Config2.optional(),
  verificationData: schemas_exports.property("verification_data", schemas_exports.unknown().optional())
});

// src/serialization/resources/matchmaker/resources/players/index.ts
var players_exports2 = {};
__export(players_exports2, {
  GameModeStatistics: () => GameModeStatistics,
  GetStatisticsResponse: () => GetStatisticsResponse,
  PlayerConnectedRequest: () => PlayerConnectedRequest,
  PlayerDisconnectedRequest: () => PlayerDisconnectedRequest,
  RegionStatistics: () => RegionStatistics
});

// src/serialization/resources/matchmaker/resources/players/types/RegionStatistics.ts
var RegionStatistics = schemas_exports.object({
  playerCount: schemas_exports.property("player_count", schemas_exports.number())
});

// src/serialization/resources/matchmaker/resources/players/types/GameModeStatistics.ts
var GameModeStatistics = schemas_exports.object({
  playerCount: schemas_exports.property("player_count", schemas_exports.number()),
  regions: schemas_exports.record(Identifier, RegionStatistics)
});

// src/serialization/resources/matchmaker/resources/players/types/GetStatisticsResponse.ts
var GetStatisticsResponse = schemas_exports.object({
  playerCount: schemas_exports.property("player_count", schemas_exports.number()),
  gameModes: schemas_exports.property("game_modes", schemas_exports.record(Identifier, GameModeStatistics))
});

// src/serialization/resources/matchmaker/resources/players/client/requests/PlayerConnectedRequest.ts
var PlayerConnectedRequest = schemas_exports.object({
  playerToken: schemas_exports.property("player_token", schemas_exports.string())
});

// src/serialization/resources/matchmaker/resources/players/client/requests/PlayerDisconnectedRequest.ts
var PlayerDisconnectedRequest = schemas_exports.object({
  playerToken: schemas_exports.property("player_token", schemas_exports.string())
});

// src/serialization/resources/matchmaker/resources/regions/index.ts
var regions_exports4 = {};
__export(regions_exports4, {
  ListRegionsResponse: () => ListRegionsResponse2
});

// src/serialization/resources/matchmaker/resources/regions/types/ListRegionsResponse.ts
var ListRegionsResponse2 = schemas_exports.object({
  regions: schemas_exports.list(RegionInfo)
});

// src/serialization/resources/portal/index.ts
var portal_exports2 = {};
__export(portal_exports2, {
  GetGameProfileResponse: () => GetGameProfileResponse,
  GetSuggestedGamesResponse: () => GetSuggestedGamesResponse,
  NotificationRegisterFirebaseService: () => NotificationRegisterFirebaseService,
  NotificationRegisterService: () => NotificationRegisterService,
  NotificationUnregisterService: () => NotificationUnregisterService2,
  common: () => common_exports33,
  games: () => games_exports6
});

// src/serialization/resources/portal/resources/common/index.ts
var common_exports33 = {};
__export(common_exports33, {
  NotificationRegisterFirebaseService: () => NotificationRegisterFirebaseService,
  NotificationRegisterService: () => NotificationRegisterService,
  NotificationUnregisterService: () => NotificationUnregisterService2
});

// src/serialization/resources/portal/resources/common/types/NotificationRegisterFirebaseService.ts
var NotificationRegisterFirebaseService = schemas_exports.object({
  accessKey: schemas_exports.property("access_key", schemas_exports.string())
});

// src/serialization/resources/portal/resources/common/types/NotificationRegisterService.ts
var NotificationRegisterService = schemas_exports.object({
  firebase: NotificationRegisterFirebaseService.optional()
});

// src/serialization/resources/portal/resources/common/types/NotificationUnregisterService.ts
var NotificationUnregisterService2 = schemas_exports.enum_(["firebase"]);

// src/serialization/resources/portal/resources/games/index.ts
var games_exports6 = {};
__export(games_exports6, {
  GetGameProfileResponse: () => GetGameProfileResponse,
  GetSuggestedGamesResponse: () => GetSuggestedGamesResponse
});

// src/serialization/resources/portal/resources/games/types/GetSuggestedGamesResponse.ts
var GetSuggestedGamesResponse = schemas_exports.object({
  games: schemas_exports.list(GameSummary),
  watch: WatchResponse
});

// src/serialization/resources/portal/resources/games/types/GetGameProfileResponse.ts
var GetGameProfileResponse = schemas_exports.object({
  game: Profile3,
  watch: WatchResponse
});

// src/serialization/resources/upload/index.ts
var upload_exports2 = {};
__export(upload_exports2, {
  PrepareFile: () => PrepareFile,
  PresignedRequest: () => PresignedRequest,
  common: () => common_exports34
});

// src/serialization/resources/upload/resources/common/index.ts
var common_exports34 = {};
__export(common_exports34, {
  PrepareFile: () => PrepareFile,
  PresignedRequest: () => PresignedRequest
});

// src/api/resources/actors/client/Client.ts
import urlJoin3 from "url-join";

// src/api/resources/actors/resources/logs/client/Client.ts
import urlJoin from "url-join";
var Logs = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns the logs for a given actor.
   *
   * @param {Rivet.actors.GetActorLogsRequestQuery} request
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.logs.get({
   *         project: "string",
   *         environment: "string",
   *         queryJson: "string",
   *         watchIndex: "string"
   *     })
   */
  async get(request = {}, requestOptions) {
    const { project, environment, queryJson, watchIndex } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (queryJson != null) {
      _queryParams["query_json"] = queryJson;
    }
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors/logs"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.GetActorLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /actors/logs.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Exports logs for the given actors to an S3 bucket and returns a presigned URL to download.
   *
   * @param {Rivet.actors.ExportActorLogsRequest} request
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.logs.export({
   *         project: "string",
   *         environment: "string",
   *         queryJson: "string"
   *     })
   */
  async export(request = {}, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors/logs/export"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: actors_exports2.ExportActorLogsRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.ExportActorLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /actors/logs/export.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/actors/resources/metrics/client/Client.ts
import urlJoin2 from "url-join";
var Metrics = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns the metrics for a given actor.
   *
   * @param {string} actor - The id of the actor to destroy
   * @param {Rivet.actors.GetActorMetricsRequestQuery} request
   * @param {Metrics.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.metrics.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string",
   *         start: 1,
   *         end: 1,
   *         interval: 1
   *     })
   */
  async get(actor, request, requestOptions) {
    const { project, environment, start, end, interval } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    _queryParams["start"] = start.toString();
    _queryParams["end"] = end.toString();
    _queryParams["interval"] = interval.toString();
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin2(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/actors/${encodeURIComponent(actor)}/metrics/history`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.GetActorMetricsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /actors/{actor}/metrics/history."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/actors/client/Client.ts
var Actors = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _logs;
  _metrics;
  get logs() {
    return this._logs ??= new Logs(this._options);
  }
  get metrics() {
    return this._metrics ??= new Metrics(this._options);
  }
  /**
   * Gets a dynamic actor.
   *
   * @param {string} actor - The id of the actor to destroy
   * @param {Rivet.actors.ListActorsRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string",
   *         endpointType: "hostname"
   *     })
   */
  async get(actor, request = {}, requestOptions) {
    const { project, environment, endpointType } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (endpointType != null) {
      _queryParams["endpoint_type"] = actors_exports2.EndpointType.jsonOrThrow(endpointType, {
        unrecognizedObjectKeys: "strip"
      });
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/actors/${encodeURIComponent(actor)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.GetActorResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /actors/{actor}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Lists all actors associated with the token used. Can be filtered by tags in the query string.
   *
   * @param {Rivet.actors.GetActorsRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.list({
   *         project: "string",
   *         environment: "string",
   *         endpointType: "hostname",
   *         tagsJson: "string",
   *         includeDestroyed: true,
   *         cursor: "string"
   *     })
   */
  async list(request = {}, requestOptions) {
    const { project, environment, endpointType, tagsJson, includeDestroyed, cursor } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (endpointType != null) {
      _queryParams["endpoint_type"] = actors_exports2.EndpointType.jsonOrThrow(endpointType, {
        unrecognizedObjectKeys: "strip"
      });
    }
    if (tagsJson != null) {
      _queryParams["tags_json"] = tagsJson;
    }
    if (includeDestroyed != null) {
      _queryParams["include_destroyed"] = includeDestroyed.toString();
    }
    if (cursor != null) {
      _queryParams["cursor"] = cursor;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.ListActorsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /actors.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Create a new dynamic actor.
   *
   * @param {Rivet.actors.CreateActorRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.create({
   *         project: "string",
   *         environment: "string",
   *         endpointType: "hostname",
   *         body: {
   *             region: "string",
   *             tags: {
   *                 "key": "value"
   *             },
   *             build: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *             buildTags: {
   *                 "key": "value"
   *             },
   *             runtime: {
   *                 environment: {},
   *                 network: {
   *                     endpointType: "hostname"
   *                 }
   *             },
   *             network: {
   *                 mode: "bridge",
   *                 ports: {},
   *                 waitReady: true
   *             },
   *             resources: {
   *                 cpu: 1,
   *                 memory: 1
   *             },
   *             lifecycle: {
   *                 killTimeout: 1000000,
   *                 durable: true
   *             }
   *         }
   *     })
   */
  async create(request, requestOptions) {
    const { project, environment, endpointType, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (endpointType != null) {
      _queryParams["endpoint_type"] = actors_exports2.EndpointType.jsonOrThrow(endpointType, {
        unrecognizedObjectKeys: "strip"
      });
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: actors_exports2.CreateActorRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.CreateActorResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /actors.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Destroy a dynamic actor.
   *
   * @param {string} actor - The id of the actor to destroy
   * @param {Rivet.actors.DestroyActorRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.destroy("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string",
   *         overrideKillTimeout: 1000000
   *     })
   */
  async destroy(actor, request = {}, requestOptions) {
    const { project, environment, overrideKillTimeout } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (overrideKillTimeout != null) {
      _queryParams["override_kill_timeout"] = overrideKillTimeout.toString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/actors/${encodeURIComponent(actor)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.DestroyActorResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling DELETE /actors/{actor}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Upgrades a dynamic actor.
   *
   * @param {string} actor - The id of the actor to upgrade
   * @param {Rivet.actors.UpgradeActorRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.upgrade("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string",
   *         body: {
   *             build: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *             buildTags: {
   *                 "key": "value"
   *             }
   *         }
   *     })
   */
  async upgrade(actor, request, requestOptions) {
    const { project, environment, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/actors/${encodeURIComponent(actor)}/upgrade`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: actors_exports2.UpgradeActorRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.UpgradeActorResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /actors/{actor}/upgrade.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Upgrades a dynamic actor.
   *
   * @param {Rivet.actors.UpgradeAllActorsRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.upgradeAll({
   *         project: "string",
   *         environment: "string",
   *         body: {
   *             tags: {
   *                 "key": "value"
   *             },
   *             build: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *             buildTags: {
   *                 "key": "value"
   *             }
   *         }
   *     })
   */
  async upgradeAll(request, requestOptions) {
    const { project, environment, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors/upgrade"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: actors_exports2.UpgradeAllActorsRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.UpgradeAllActorsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /actors/upgrade.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns time series data for actor usage metrics. Allows filtering and grouping by various actor properties.
   *
   * @param {Rivet.actors.GetActorUsageRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.usage({
   *         project: "string",
   *         environment: "string",
   *         start: 1,
   *         end: 1,
   *         interval: 1,
   *         groupBy: "string",
   *         queryJson: "string"
   *     })
   */
  async usage(request, requestOptions) {
    const { project, environment, start, end, interval, groupBy, queryJson } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    _queryParams["start"] = start.toString();
    _queryParams["end"] = end.toString();
    _queryParams["interval"] = interval.toString();
    if (groupBy != null) {
      _queryParams["group_by"] = groupBy;
    }
    if (queryJson != null) {
      _queryParams["query_json"] = queryJson;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors/usage"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.GetActorUsageResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /actors/usage.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Queries actors using a JSON-encoded query expression. Supports pagination with cursor-based navigation.
   *
   * @param {Rivet.actors.QueryActorsRequestQuery} request
   * @param {Actors.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.actors.query({
   *         project: "string",
   *         environment: "string",
   *         queryJson: "string",
   *         cursor: "string"
   *     })
   */
  async query(request = {}, requestOptions) {
    const { project, environment, queryJson, cursor } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (queryJson != null) {
      _queryParams["query_json"] = queryJson;
    }
    if (cursor != null) {
      _queryParams["cursor"] = cursor;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin3(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/actors/query"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return actors_exports2.QueryActorsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /actors/query.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/builds/client/Client.ts
import urlJoin4 from "url-join";
var Builds = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Get a build.
   *
   * @param {string} build
   * @param {Rivet.builds.GetBuildRequestQuery} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.builds.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string"
   *     })
   */
  async get(build, request = {}, requestOptions) {
    const { project, environment } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin4(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/builds/${encodeURIComponent(build)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return builds_exports4.GetBuildResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /builds/{build}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Lists all builds of the project associated with the token used. Can be filtered by tags in the query string.
   *
   * @param {Rivet.builds.ListBuildsRequestQuery} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.builds.list({
   *         project: "string",
   *         environment: "string",
   *         tagsJson: "string"
   *     })
   */
  async list(request = {}, requestOptions) {
    const { project, environment, tagsJson } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (tagsJson != null) {
      _queryParams["tags_json"] = tagsJson;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin4(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/builds"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return builds_exports4.ListBuildsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /builds.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} build
   * @param {Rivet.builds.PatchBuildTagsRequestQuery} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.builds.patchTags("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string",
   *         body: {
   *             tags: {
   *                 "key": "value"
   *             },
   *             exclusiveTags: ["string"]
   *         }
   *     })
   */
  async patchTags(build, request, requestOptions) {
    const { project, environment, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin4(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/builds/${encodeURIComponent(build)}/tags`
      ),
      method: "PATCH",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: builds_exports4.PatchBuildTagsRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return builds_exports4.PatchBuildTagsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling PATCH /builds/{build}/tags.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new project build for the given project.
   *
   * @param {Rivet.builds.PrepareBuildRequestQuery} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.builds.prepare({
   *         project: "string",
   *         environment: "string",
   *         body: {
   *             imageTag: "string",
   *             imageFile: {
   *                 path: "string",
   *                 contentType: "string",
   *                 contentLength: 1000000
   *             },
   *             kind: "docker_image",
   *             compression: "none"
   *         }
   *     })
   */
  async prepare(request, requestOptions) {
    const { project, environment, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin4(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/builds/prepare"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: builds_exports4.PrepareBuildRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return builds_exports4.PrepareBuildResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /builds/prepare.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Marks an upload as complete.
   *
   * @param {string} build
   * @param {Rivet.builds.CompleteBuildRequestQuery} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.builds.complete("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         project: "string",
   *         environment: "string"
   *     })
   */
  async complete(build, request = {}, requestOptions) {
    const { project, environment } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin4(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/builds/${encodeURIComponent(build)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /builds/{build}/complete.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/client/Client.ts
import urlJoin21 from "url-join";

// src/api/resources/cloud/resources/games/client/Client.ts
import urlJoin14 from "url-join";

// src/api/resources/cloud/resources/games/resources/namespaces/client/Client.ts
import urlJoin7 from "url-join";

// src/api/resources/cloud/resources/games/resources/namespaces/resources/analytics/client/Client.ts
import urlJoin5 from "url-join";
var Analytics = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns live information about all active lobbies for a given namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Analytics.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.analytics.getAnalyticsMatchmakerLive("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getAnalyticsMatchmakerLive(gameId, namespaceId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin5(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/analytics/matchmaker/live`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.GetAnalyticsMatchmakerLiveResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/namespaces/{namespace_id}/analytics/matchmaker/live."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/namespaces/resources/logs/client/Client.ts
import urlJoin6 from "url-join";
var Logs2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns a list of lobbies for the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.ListNamespaceLobbiesRequest} request
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.logs.listNamespaceLobbies("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         beforeCreateTs: "2024-01-15T09:30:00Z"
   *     })
   */
  async listNamespaceLobbies(gameId, namespaceId, request = {}, requestOptions) {
    const { beforeCreateTs } = request;
    const _queryParams = {};
    if (beforeCreateTs != null) {
      _queryParams["before_create_ts"] = beforeCreateTs.toISOString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin6(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/logs/lobbies`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.ListNamespaceLobbiesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/namespaces/{namespace_id}/logs/lobbies."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a lobby from the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {string} lobbyId
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.logs.getNamespaceLobby("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getNamespaceLobby(gameId, namespaceId, lobbyId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin6(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/logs/lobbies/${encodeURIComponent(lobbyId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.GetNamespaceLobbyResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/namespaces/{namespace_id}/logs/lobbies/{lobby_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/namespaces/client/Client.ts
var Namespaces = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _analytics;
  _logs;
  get analytics() {
    return this._analytics ??= new Analytics(this._options);
  }
  get logs() {
    return this._logs ??= new Logs2(this._options);
  }
  /**
   * Creates a new namespace for the given game.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.namespaces.CreateGameNamespaceRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.createGameNamespace("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         versionId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *         nameId: "string"
   *     })
   */
  async createGameNamespace(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.CreateGameNamespaceRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.CreateGameNamespaceResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validates information used to create a new game namespace.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.namespaces.ValidateGameNamespaceRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.validateGameNamespace("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         nameId: "string"
   *     })
   */
  async validateGameNamespace(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/validate`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.ValidateGameNamespaceRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.ValidateGameNamespaceResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Gets a game namespace by namespace ID.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.getGameNamespaceById("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getGameNamespaceById(gameId, namespaceId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.GetGameNamespaceByIdResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/namespaces/{namespace_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Adds an authenticated user to the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.UpdateNamespaceCdnAuthUserRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.updateNamespaceCdnAuthUser("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         user: "string",
   *         password: "string"
   *     })
   */
  async updateNamespaceCdnAuthUser(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/auth-user`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.UpdateNamespaceCdnAuthUserRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/auth-user."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Removes an authenticated user from the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {string} user - A user name.
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.removeNamespaceCdnAuthUser("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "string")
   */
  async removeNamespaceCdnAuthUser(gameId, namespaceId, user, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/auth-user/${encodeURIComponent(user)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /cloud/games/{game_id}/namespaces/{namespace_id}/auth-user/{user}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Updates the CDN authentication type of the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.SetNamespaceCdnAuthTypeRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.setNamespaceCdnAuthType("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         authType: "none"
   *     })
   */
  async setNamespaceCdnAuthType(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/cdn-auth`
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.SetNamespaceCdnAuthTypeRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling PUT /cloud/games/{game_id}/namespaces/{namespace_id}/cdn-auth."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Toggles whether or not to allow authentication based on domain for the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.ToggleNamespaceDomainPublicAuthRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.toggleNamespaceDomainPublicAuth("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         enabled: true
   *     })
   */
  async toggleNamespaceDomainPublicAuth(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/domain-public-auth`
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.ToggleNamespaceDomainPublicAuthRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling PUT /cloud/games/{game_id}/namespaces/{namespace_id}/domain-public-auth."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Adds a domain to the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.AddNamespaceDomainRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.addNamespaceDomain("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         domain: "string"
   *     })
   */
  async addNamespaceDomain(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/domains`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.AddNamespaceDomainRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/domains."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Removes a domain from the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {string} domain - A valid domain name (no protocol).
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.removeNamespaceDomain("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "string")
   */
  async removeNamespaceDomain(gameId, namespaceId, domain, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/domains/${encodeURIComponent(domain)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /cloud/games/{game_id}/namespaces/{namespace_id}/domains/{domain}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Updates matchmaker config for the given game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.UpdateGameNamespaceMatchmakerConfigRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.updateGameNamespaceMatchmakerConfig("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         lobbyCountMax: 1,
   *         maxPlayers: 1
   *     })
   */
  async updateGameNamespaceMatchmakerConfig(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/mm-config`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.UpdateGameNamespaceMatchmakerConfigRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/mm-config."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Gets the version history for a given namespace.
   *
   * @param {string} gameId - A universally unique identifier.
   * @param {string} namespaceId - A universally unique identifier.
   * @param {Rivet.cloud.games.namespaces.GetGameNamespaceVersionHistoryRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.getGameNamespaceVersionHistoryList("string", "string", {
   *         anchor: "string",
   *         limit: 1
   *     })
   */
  async getGameNamespaceVersionHistoryList(gameId, namespaceId, request = {}, requestOptions) {
    const { anchor, limit } = request;
    const _queryParams = {};
    if (anchor != null) {
      _queryParams["anchor"] = anchor;
    }
    if (limit != null) {
      _queryParams["limit"] = limit.toString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/version-history`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.GetGameNamespaceVersionHistoryResponse.parseOrThrow(
        _response.body,
        {
          unrecognizedObjectKeys: "passthrough",
          allowUnrecognizedUnionMembers: true,
          allowUnrecognizedEnumValues: true,
          skipValidation: true,
          breadcrumbsPrefix: ["response"]
        }
      );
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/namespaces/{namespace_id}/version-history."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validates information used to update a game namespace's matchmaker config.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.ValidateGameNamespaceMatchmakerConfigRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.validateGameNamespaceMatchmakerConfig("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         lobbyCountMax: 1,
   *         maxPlayers: 1
   *     })
   */
  async validateGameNamespaceMatchmakerConfig(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/mm-config/validate`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.ValidateGameNamespaceMatchmakerConfigRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.ValidateGameNamespaceMatchmakerConfigResponse.parseOrThrow(
        _response.body,
        {
          unrecognizedObjectKeys: "passthrough",
          allowUnrecognizedUnionMembers: true,
          allowUnrecognizedEnumValues: true,
          skipValidation: true,
          breadcrumbsPrefix: ["response"]
        }
      );
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/mm-config/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a development token for the given namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.CreateGameNamespaceTokenDevelopmentRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.createGameNamespaceTokenDevelopment("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         hostname: "string",
   *         ports: {
   *             "string": {
   *                 port: undefined,
   *                 portRange: undefined,
   *                 protocol: "http"
   *             }
   *         },
   *         lobbyPorts: [{
   *                 label: "string",
   *                 targetPort: undefined,
   *                 portRange: undefined,
   *                 proxyProtocol: "http"
   *             }]
   *     })
   */
  async createGameNamespaceTokenDevelopment(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/tokens/development`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.CreateGameNamespaceTokenDevelopmentRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.CreateGameNamespaceTokenDevelopmentResponse.parseOrThrow(
        _response.body,
        {
          unrecognizedObjectKeys: "passthrough",
          allowUnrecognizedUnionMembers: true,
          allowUnrecognizedEnumValues: true,
          skipValidation: true,
          breadcrumbsPrefix: ["response"]
        }
      );
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/tokens/development."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validates information used to create a new game namespace development token.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.ValidateGameNamespaceTokenDevelopmentRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.validateGameNamespaceTokenDevelopment("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         hostname: "string",
   *         lobbyPorts: [{
   *                 label: "string",
   *                 targetPort: undefined,
   *                 portRange: undefined,
   *                 proxyProtocol: "http"
   *             }]
   *     })
   */
  async validateGameNamespaceTokenDevelopment(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/tokens/development/validate`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.ValidateGameNamespaceTokenDevelopmentRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.ValidateGameNamespaceTokenDevelopmentResponse.parseOrThrow(
        _response.body,
        {
          unrecognizedObjectKeys: "passthrough",
          allowUnrecognizedUnionMembers: true,
          allowUnrecognizedEnumValues: true,
          skipValidation: true,
          breadcrumbsPrefix: ["response"]
        }
      );
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/tokens/development/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a public token for the given namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.createGameNamespaceTokenPublic("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async createGameNamespaceTokenPublic(gameId, namespaceId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/tokens/public`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.namespaces.CreateGameNamespaceTokenPublicResponse.parseOrThrow(
        _response.body,
        {
          unrecognizedObjectKeys: "passthrough",
          allowUnrecognizedUnionMembers: true,
          allowUnrecognizedEnumValues: true,
          skipValidation: true,
          breadcrumbsPrefix: ["response"]
        }
      );
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/namespaces/{namespace_id}/tokens/public."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Updates the version of a game namespace.
   *
   * @param {string} gameId
   * @param {string} namespaceId
   * @param {Rivet.cloud.games.namespaces.UpdateGameNamespaceVersionRequest} request
   * @param {Namespaces.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.namespaces.updateGameNamespaceVersion("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         versionId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async updateGameNamespaceVersion(gameId, namespaceId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin7(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/namespaces/${encodeURIComponent(namespaceId)}/version`
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.namespaces.UpdateGameNamespaceVersionRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling PUT /cloud/games/{game_id}/namespaces/{namespace_id}/version."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/avatars/client/Client.ts
import urlJoin8 from "url-join";
var Avatars = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Lists custom avatars for the given game.
   *
   * @param {string} gameId
   * @param {Avatars.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.avatars.listGameCustomAvatars("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async listGameCustomAvatars(gameId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin8(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/avatars`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ListGameCustomAvatarsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/games/{game_id}/avatars.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Prepares a custom avatar image upload.
   * Complete upload with `rivet.api.cloud#CompleteCustomAvatarUpload`.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.PrepareCustomAvatarUploadRequest} request
   * @param {Avatars.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.avatars.prepareCustomAvatarUpload("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         path: "string",
   *         mime: "string",
   *         contentLength: 1000000
   *     })
   */
  async prepareCustomAvatarUpload(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin8(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/prepare`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.PrepareCustomAvatarUploadRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.PrepareCustomAvatarUploadResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes a custom avatar image upload. Must be called after the file upload process completes.
   *
   * @param {string} gameId
   * @param {string} uploadId
   * @param {Avatars.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.avatars.completeCustomAvatarUpload("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async completeCustomAvatarUpload(gameId, uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin8(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/avatar-upload/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/avatar-upload/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/builds/client/Client.ts
import urlJoin9 from "url-join";
var Builds2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Lists game builds for the given game.
   *
   * @param {string} gameId
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.builds.listGameBuilds("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async listGameBuilds(gameId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin9(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/builds`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ListGameBuildsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/games/{game_id}/builds.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new game build for the given game.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.CreateGameBuildRequest} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.builds.createGameBuild("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         imageTag: "string",
   *         imageFile: {
   *             path: "string",
   *             contentType: "string",
   *             contentLength: 1000000
   *         },
   *         multipartUpload: true,
   *         kind: "docker_image",
   *         compression: "none"
   *     })
   */
  async createGameBuild(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin9(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/builds`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.CreateGameBuildRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.CreateGameBuildResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/games/{game_id}/builds.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/cdn/client/Client.ts
import urlJoin10 from "url-join";
var Cdn = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Lists CDN sites for a game.
   *
   * @param {string} gameId
   * @param {Cdn.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.cdn.listGameCdnSites("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async listGameCdnSites(gameId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin10(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/cdn/sites`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ListGameCdnSitesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/cdn/sites."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new CDN site for the given game.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.CreateGameCdnSiteRequest} request
   * @param {Cdn.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.cdn.createGameCdnSite("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         files: [{
   *                 path: "string",
   *                 contentType: "string",
   *                 contentLength: 1000000
   *             }]
   *     })
   */
  async createGameCdnSite(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin10(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/cdn/sites`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.CreateGameCdnSiteRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.CreateGameCdnSiteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/cdn/sites."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/matchmaker/client/Client.ts
import urlJoin11 from "url-join";
var Matchmaker = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Exports lobby history over a given query time span.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.ExportMatchmakerLobbyHistoryRequest} request
   * @param {Matchmaker.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.matchmaker.exportMatchmakerLobbyHistory("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         queryStart: 1000000,
   *         queryEnd: 1000000
   *     })
   */
  async exportMatchmakerLobbyHistory(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin11(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/matchmaker/lobbies/export-history`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.ExportMatchmakerLobbyHistoryRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ExportMatchmakerLobbyHistoryResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/matchmaker/lobbies/export-history."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Deletes a matchmaker lobby, stopping it immediately.
   *
   * @param {string} gameId
   * @param {string} lobbyId
   * @param {Matchmaker.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.matchmaker.deleteMatchmakerLobby("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async deleteMatchmakerLobby(gameId, lobbyId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin11(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/matchmaker/lobbies/${encodeURIComponent(lobbyId)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.DeleteMatchmakerLobbyResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /cloud/games/{game_id}/matchmaker/lobbies/{lobby_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns the logs for a given lobby.
   *
   * @param {string} gameId
   * @param {string} lobbyId
   * @param {Rivet.cloud.games.GetLobbyLogsRequest} request
   * @param {Matchmaker.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.matchmaker.getLobbyLogs("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         stream: "std_out",
   *         watchIndex: "string"
   *     })
   */
  async getLobbyLogs(gameId, lobbyId, request, requestOptions) {
    const { stream, watchIndex } = request;
    const _queryParams = {};
    _queryParams["stream"] = cloud_exports2.games.LogStream.jsonOrThrow(stream, {
      unrecognizedObjectKeys: "strip"
    });
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin11(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/matchmaker/lobbies/${encodeURIComponent(lobbyId)}/logs`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GetLobbyLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/matchmaker/lobbies/{lobby_id}/logs."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Generates a download URL for logs.
   *
   * @param {string} gameId
   * @param {string} lobbyId
   * @param {Rivet.cloud.games.ExportLobbyLogsRequest} request
   * @param {Matchmaker.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.matchmaker.exportLobbyLogs("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         stream: "std_out"
   *     })
   */
  async exportLobbyLogs(gameId, lobbyId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin11(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/matchmaker/lobbies/${encodeURIComponent(lobbyId)}/logs/export`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.ExportLobbyLogsRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ExportLobbyLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/matchmaker/lobbies/{lobby_id}/logs/export."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/tokens/client/Client.ts
import urlJoin12 from "url-join";
var Tokens = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Creates a new game cloud token.
   *
   * @param {string} gameId
   * @param {Tokens.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.tokens.createCloudToken("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async createCloudToken(gameId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin12(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/tokens/cloud`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.CreateCloudTokenResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/tokens/cloud."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/resources/versions/client/Client.ts
import urlJoin13 from "url-join";
var Versions = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Creates a new game version.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.CreateGameVersionRequest} request
   * @param {Versions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.versions.createGameVersion("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         config: {
   *             scripts: {
   *                 "string": "string"
   *             },
   *             engine: {
   *                 unity: {},
   *                 unreal: {
   *                     gameModule: "string"
   *                 },
   *                 godot: {},
   *                 html5: {},
   *                 custom: {}
   *             },
   *             cdn: {
   *                 buildCommand: "string",
   *                 buildOutput: "string",
   *                 buildEnv: {},
   *                 siteId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *                 routes: []
   *             },
   *             matchmaker: {
   *                 gameModes: {},
   *                 captcha: {
   *                     requestsBeforeReverify: 1,
   *                     verificationTtl: 1000000,
   *                     hcaptcha: undefined,
   *                     turnstile: undefined
   *                 },
   *                 devHostname: "string",
   *                 regions: {},
   *                 maxPlayers: 1,
   *                 maxPlayersDirect: 1,
   *                 maxPlayersParty: 1,
   *                 docker: {
   *                     dockerfile: undefined,
   *                     buildArgs: undefined,
   *                     image: undefined,
   *                     imageId: undefined,
   *                     args: undefined,
   *                     env: undefined,
   *                     networkMode: undefined,
   *                     ports: undefined
   *                 },
   *                 tier: "string",
   *                 idleLobbies: {
   *                     min: 1,
   *                     max: 1
   *                 },
   *                 lobbyGroups: []
   *             },
   *             kv: {},
   *             identity: {
   *                 displayNames: [],
   *                 avatars: [],
   *                 customDisplayNames: [],
   *                 customAvatars: []
   *             }
   *         }
   *     })
   */
  async createGameVersion(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin13(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/versions`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.CreateGameVersionRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.CreateGameVersionResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/versions."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Reserves a display name for the next version. Used to generate a monotomically increasing build number without causing a race condition with multiple versions getting created at the same time.
   *
   * @param {string} gameId
   * @param {Versions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.versions.reserveVersionName("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async reserveVersionName(gameId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin13(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/versions/reserve-name`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ReserveVersionNameResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/versions/reserve-name."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validates information used to create a new game version.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.ValidateGameVersionRequest} request
   * @param {Versions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.versions.validateGameVersion("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         config: {
   *             scripts: {
   *                 "string": "string"
   *             },
   *             engine: {
   *                 unity: {},
   *                 unreal: {
   *                     gameModule: "string"
   *                 },
   *                 godot: {},
   *                 html5: {},
   *                 custom: {}
   *             },
   *             cdn: {
   *                 buildCommand: "string",
   *                 buildOutput: "string",
   *                 buildEnv: {},
   *                 siteId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *                 routes: []
   *             },
   *             matchmaker: {
   *                 gameModes: {},
   *                 captcha: {
   *                     requestsBeforeReverify: 1,
   *                     verificationTtl: 1000000,
   *                     hcaptcha: undefined,
   *                     turnstile: undefined
   *                 },
   *                 devHostname: "string",
   *                 regions: {},
   *                 maxPlayers: 1,
   *                 maxPlayersDirect: 1,
   *                 maxPlayersParty: 1,
   *                 docker: {
   *                     dockerfile: undefined,
   *                     buildArgs: undefined,
   *                     image: undefined,
   *                     imageId: undefined,
   *                     args: undefined,
   *                     env: undefined,
   *                     networkMode: undefined,
   *                     ports: undefined
   *                 },
   *                 tier: "string",
   *                 idleLobbies: {
   *                     min: 1,
   *                     max: 1
   *                 },
   *                 lobbyGroups: []
   *             },
   *             kv: {},
   *             identity: {
   *                 displayNames: [],
   *                 avatars: [],
   *                 customDisplayNames: [],
   *                 customAvatars: []
   *             }
   *         }
   *     })
   */
  async validateGameVersion(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin13(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/versions/validate`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.ValidateGameVersionRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ValidateGameVersionResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/versions/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a game version by its version ID.
   *
   * @param {string} gameId
   * @param {string} versionId
   * @param {Versions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.versions.getGameVersionById("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getGameVersionById(gameId, versionId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin13(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/versions/${encodeURIComponent(versionId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GetGameVersionByIdResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /cloud/games/{game_id}/versions/{version_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/games/client/Client.ts
var Games = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _namespaces;
  _avatars;
  _builds;
  _cdn;
  _matchmaker;
  _tokens;
  _versions;
  get namespaces() {
    return this._namespaces ??= new Namespaces(this._options);
  }
  get avatars() {
    return this._avatars ??= new Avatars(this._options);
  }
  get builds() {
    return this._builds ??= new Builds2(this._options);
  }
  get cdn() {
    return this._cdn ??= new Cdn(this._options);
  }
  get matchmaker() {
    return this._matchmaker ??= new Matchmaker(this._options);
  }
  get tokens() {
    return this._tokens ??= new Tokens(this._options);
  }
  get versions() {
    return this._versions ??= new Versions(this._options);
  }
  /**
   * Returns a list of games in which the current identity is a group member of its development team.
   *
   * @param {Rivet.cloud.games.GetGamesRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.getGames({
   *         watchIndex: "string"
   *     })
   */
  async getGames(request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/games"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GetGamesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/games.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new game.
   *
   * @param {Rivet.cloud.games.CreateGameRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.createGame({
   *         nameId: "string",
   *         displayName: "string",
   *         developerGroupId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async createGame(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/games"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.CreateGameRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.CreateGameResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/games.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validates information used to create a new game.
   *
   * @param {Rivet.cloud.games.ValidateGameRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.validateGame({
   *         displayName: "string",
   *         nameId: "string"
   *     })
   */
  async validateGame(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/games/validate"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.ValidateGameRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.ValidateGameResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/games/validate.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a game by its game id.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.GetGameByIdRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.getGameById("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         watchIndex: "string"
   *     })
   */
  async getGameById(gameId, request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GetGameByIdResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/games/{game_id}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Prepares a game banner image upload.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.GameBannerUploadPrepareRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.gameBannerUploadPrepare("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         path: "string",
   *         mime: "string",
   *         contentLength: 1000000
   *     })
   */
  async gameBannerUploadPrepare(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/banner-upload/prepare`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.GameBannerUploadPrepareRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GameBannerUploadPrepareResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/banner-upload/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes an game banner image upload. Must be called after the file upload process completes.
   *
   * @param {string} gameId
   * @param {string} uploadId
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.gameBannerUploadComplete("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async gameBannerUploadComplete(gameId, uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/banner-upload/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/banner-upload/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Prepares a game logo image upload.
   *
   * @param {string} gameId
   * @param {Rivet.cloud.games.GameLogoUploadPrepareRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.gameLogoUploadPrepare("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         path: "string",
   *         mime: "string",
   *         contentLength: 1000000
   *     })
   */
  async gameLogoUploadPrepare(gameId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/logo-upload/prepare`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.games.GameLogoUploadPrepareRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.games.GameLogoUploadPrepareResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/logo-upload/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes a game logo image upload. Must be called after the file upload process completes.
   *
   * @param {string} gameId
   * @param {string} uploadId
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.games.gameLogoUploadComplete("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async gameLogoUploadComplete(gameId, uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin14(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/games/${encodeURIComponent(gameId)}/logo-upload/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/games/{game_id}/logo-upload/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/auth/client/Client.ts
import urlJoin15 from "url-join";
var Auth = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns information about the current authenticated agent.
   *
   * @param {Auth.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.auth.inspect()
   */
  async inspect(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin15(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/auth/inspect"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.InspectResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/auth/inspect.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/devices/resources/links/client/Client.ts
import urlJoin16 from "url-join";
var Links = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {Links.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.devices.links.prepare()
   */
  async prepare(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin16(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/devices/links"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.devices.PrepareDeviceLinkResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/devices/links.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {Rivet.cloud.devices.GetDeviceLinkRequest} request
   * @param {Links.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.devices.links.get({
   *         deviceLinkToken: "string",
   *         watchIndex: "string"
   *     })
   */
  async get(request, requestOptions) {
    const { deviceLinkToken, watchIndex } = request;
    const _queryParams = {};
    _queryParams["device_link_token"] = deviceLinkToken;
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin16(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/devices/links"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.devices.GetDeviceLinkResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/devices/links.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {Rivet.cloud.devices.CompleteDeviceLinkRequest} request
   * @param {Links.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.devices.links.complete({
   *         deviceLinkToken: "string",
   *         gameId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async complete(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin16(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/devices/links/complete"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.devices.CompleteDeviceLinkRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/devices/links/complete.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/devices/client/Client.ts
var Devices = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _links;
  get links() {
    return this._links ??= new Links(this._options);
  }
};

// src/api/resources/cloud/resources/groups/client/Client.ts
import urlJoin17 from "url-join";
var Groups = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Validates information used to create a new group.
   *
   * @param {Rivet.cloud.ValidateGroupRequest} request
   * @param {Groups.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.groups.validate({
   *         displayName: "string"
   *     })
   */
  async validate(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin17(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/groups/validate"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: cloud_exports2.ValidateGroupRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.ValidateGroupResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /cloud/groups/validate.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/logs/client/Client.ts
import urlJoin18 from "url-join";
var Logs3 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns performance information about a Rivet Ray.
   *
   * @param {string} rayId
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.logs.getRayPerfLogs("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getRayPerfLogs(rayId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin18(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/rays/${encodeURIComponent(rayId)}/perf`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.GetRayPerfLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/rays/{ray_id}/perf.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/tiers/client/Client.ts
import urlJoin19 from "url-join";
var Tiers = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns all available region tiers.
   *
   * @param {Tiers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.tiers.getRegionTiers()
   */
  async getRegionTiers(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin19(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/region-tiers"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.GetRegionTiersResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/region-tiers.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/resources/uploads/client/Client.ts
import urlJoin20 from "url-join";
var Uploads = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Marks an upload as complete.
   *
   * @param {string} uploadId
   * @param {Uploads.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.uploads.completeUpload("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async completeUpload(uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin20(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/cloud/uploads/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /cloud/uploads/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/cloud/client/Client.ts
var Cloud = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _games;
  _auth;
  _devices;
  _groups;
  _logs;
  _tiers;
  _uploads;
  get games() {
    return this._games ??= new Games(this._options);
  }
  get auth() {
    return this._auth ??= new Auth(this._options);
  }
  get devices() {
    return this._devices ??= new Devices(this._options);
  }
  get groups() {
    return this._groups ??= new Groups(this._options);
  }
  get logs() {
    return this._logs ??= new Logs3(this._options);
  }
  get tiers() {
    return this._tiers ??= new Tiers(this._options);
  }
  get uploads() {
    return this._uploads ??= new Uploads(this._options);
  }
  /**
   * Returns the basic information required to use the cloud APIs.
   *
   * @param {Cloud.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.cloud.bootstrap()
   */
  async bootstrap(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin21(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/cloud/bootstrap"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return cloud_exports2.BootstrapResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /cloud/bootstrap.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/coreIntercom/resources/pegboard/client/Client.ts
import urlJoin22 from "url-join";
var Pegboard = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {string} clientId
   * @param {Rivet.coreIntercom.pegboard.MarkClientRegisteredRequest} request
   * @param {Pegboard.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.coreIntercom.pegboard.markClientRegistered("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         serverId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async markClientRegistered(clientId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin22(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/pegboard/client/${encodeURIComponent(clientId)}/registered`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: coreIntercom_exports2.pegboard.MarkClientRegisteredRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /pegboard/client/{client_id}/registered."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/coreIntercom/client/Client.ts
var CoreIntercom = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _pegboard;
  get pegboard() {
    return this._pegboard ??= new Pegboard(this._options);
  }
};

// src/api/resources/edgeIntercom/resources/pegboard/client/Client.ts
import urlJoin23 from "url-join";
var Pegboard2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {string} imageId
   * @param {Rivet.edgeIntercom.pegboard.PrewarmImageRequest} request
   * @param {Pegboard.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.edgeIntercom.pegboard.prewarmImage("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {})
   */
  async prewarmImage(imageId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin23(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/pegboard/image/${encodeURIComponent(imageId)}/prewarm`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: edgeIntercom_exports2.pegboard.PrewarmImageRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /pegboard/image/{image_id}/prewarm."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} clientId
   * @param {Rivet.edgeIntercom.pegboard.ToggleClientDrainRequest} request
   * @param {Pegboard.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.edgeIntercom.pegboard.toggleClientDrain("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         draining: true,
   *         drainCompleteTs: "2024-01-15T09:30:00Z"
   *     })
   */
  async toggleClientDrain(clientId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin23(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/pegboard/client/${encodeURIComponent(clientId)}/toggle-drain`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: edgeIntercom_exports2.pegboard.ToggleClientDrainRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /pegboard/client/{client_id}/toggle-drain."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/edgeIntercom/client/Client.ts
var EdgeIntercom = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _pegboard;
  get pegboard() {
    return this._pegboard ??= new Pegboard2(this._options);
  }
};

// src/api/resources/group/client/Client.ts
import urlJoin26 from "url-join";

// src/api/resources/group/resources/invites/client/Client.ts
import urlJoin24 from "url-join";
var Invites = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Inspects a group invite returning information about the team that created it.
   *
   * @param {string} groupInviteCode - Provided by `rivet.api.group#CreateInviteResponse$code`.
   * @param {Invites.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.invites.getInvite("string")
   */
  async getInvite(groupInviteCode, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin24(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/invites/${encodeURIComponent(groupInviteCode)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetInviteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /group/invites/{group_invite_code}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Consumes a group invite to join a group.
   *
   * @param {string} groupInviteCode - Provided by `rivet.api.group#CreateInviteResponse$code`.
   * @param {Invites.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.invites.consumeInvite("string")
   */
  async consumeInvite(groupInviteCode, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin24(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/invites/${encodeURIComponent(groupInviteCode)}/consume`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.ConsumeInviteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/invites/{group_invite_code}/consume."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a group invite. Can be shared with other identities to let them join this group.
   *
   * @param {string} groupId
   * @param {Rivet.group.CreateInviteRequest} request
   * @param {Invites.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.invites.createInvite("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         ttl: 1.1,
   *         useCount: 1.1
   *     })
   */
  async createInvite(groupId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin24(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/invites`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.CreateInviteRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.CreateInviteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/invites."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/group/resources/joinRequests/client/Client.ts
import urlJoin25 from "url-join";
var JoinRequests = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Requests to join a group.
   *
   * @param {string} groupId
   * @param {JoinRequests.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.joinRequests.createJoinRequest("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async createJoinRequest(groupId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin25(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/join-request`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/join-request."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Resolves a join request for a given group.
   *
   * @param {string} groupId
   * @param {string} identityId
   * @param {Rivet.group.ResolveJoinRequestRequest} request
   * @param {JoinRequests.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.joinRequests.resolveJoinRequest("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         resolution: true
   *     })
   */
  async resolveJoinRequest(groupId, identityId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin25(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/join-request/${encodeURIComponent(identityId)}`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.ResolveJoinRequestRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/join-request/{identity_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/group/client/Client.ts
var Group2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _invites;
  _joinRequests;
  get invites() {
    return this._invites ??= new Invites(this._options);
  }
  get joinRequests() {
    return this._joinRequests ??= new JoinRequests(this._options);
  }
  /**
   * Returns a list of suggested groups.
   *
   * @param {Rivet.group.ListSuggestedRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.listSuggested({
   *         watchIndex: "string"
   *     })
   */
  async listSuggested(request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/group/groups"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.ListSuggestedResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /group/groups.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new group.
   *
   * @param {Rivet.group.CreateRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.create({
   *         displayName: "string"
   *     })
   */
  async create(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/group/groups"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.CreateRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.CreateResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /group/groups.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Prepares an avatar image upload.
   * Complete upload with `rivet.api.group#CompleteAvatarUpload`.
   *
   * @param {Rivet.group.PrepareAvatarUploadRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.prepareAvatarUpload({
   *         path: "string",
   *         mime: "string",
   *         contentLength: 1000000
   *     })
   */
  async prepareAvatarUpload(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/group/groups/avatar-upload/prepare"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.PrepareAvatarUploadRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.PrepareAvatarUploadResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/avatar-upload/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validate contents of group profile. Use to provide immediate feedback on profile changes before committing them.
   *
   * @param {Rivet.group.ValidateProfileRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.validateProfile({
   *         displayName: "string",
   *         bio: "string",
   *         publicity: "open"
   *     })
   */
  async validateProfile(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/group/groups/profile/validate"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.ValidateProfileRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.ValidateProfileResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/profile/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes an avatar image upload. Must be called after the file upload
   * process completes.
   * Call `rivet.api.group#PrepareAvatarUpload` first.
   *
   * @param {string} groupId
   * @param {string} uploadId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.completeAvatarUpload("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async completeAvatarUpload(groupId, uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/avatar-upload/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/avatar-upload/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a group's bans. Must have valid permissions to view.
   *
   * @param {string} groupId
   * @param {Rivet.group.GetBansRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.getBans("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         anchor: "string",
   *         count: 1.1,
   *         watchIndex: "string"
   *     })
   */
  async getBans(groupId, request = {}, requestOptions) {
    const { anchor, count, watchIndex } = request;
    const _queryParams = {};
    if (anchor != null) {
      _queryParams["anchor"] = anchor;
    }
    if (count != null) {
      _queryParams["count"] = count.toString();
    }
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/bans`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetBansResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /group/groups/{group_id}/bans.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Bans an identity from a group. Must be the owner of the group to perform this action. The banned identity will no longer be able to create a join request or use a group invite.
   *
   * @param {string} groupId
   * @param {string} identityId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.banIdentity("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async banIdentity(groupId, identityId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/bans/${encodeURIComponent(identityId)}`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/bans/{identity_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Unbans an identity from a group. Must be the owner of the group to perform this action.
   *
   * @param {string} groupId
   * @param {string} identityId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.unbanIdentity("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async unbanIdentity(groupId, identityId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/bans/${encodeURIComponent(identityId)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /group/groups/{group_id}/bans/{identity_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a group's join requests. Must have valid permissions to view.
   *
   * @param {string} groupId
   * @param {Rivet.group.GetJoinRequestsRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.getJoinRequests("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         anchor: "string",
   *         count: 1.1,
   *         watchIndex: "string"
   *     })
   */
  async getJoinRequests(groupId, request = {}, requestOptions) {
    const { anchor, count, watchIndex } = request;
    const _queryParams = {};
    if (anchor != null) {
      _queryParams["anchor"] = anchor;
    }
    if (count != null) {
      _queryParams["count"] = count.toString();
    }
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/join-requests`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetJoinRequestsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /group/groups/{group_id}/join-requests."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Kicks an identity from a group. Must be the owner of the group to perform this action.
   *
   * @param {string} groupId
   * @param {string} identityId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.kickMember("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async kickMember(groupId, identityId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/kick/${encodeURIComponent(identityId)}`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/kick/{identity_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Leaves a group.
   *
   * @param {string} groupId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.leave("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async leave(groupId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/leave`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/leave."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a group's members.
   *
   * @param {string} groupId
   * @param {Rivet.group.GetMembersRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.getMembers("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         anchor: "string",
   *         count: 1.1,
   *         watchIndex: "string"
   *     })
   */
  async getMembers(groupId, request = {}, requestOptions) {
    const { anchor, count, watchIndex } = request;
    const _queryParams = {};
    if (anchor != null) {
      _queryParams["anchor"] = anchor;
    }
    if (count != null) {
      _queryParams["count"] = count.toString();
    }
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/members`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetMembersResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /group/groups/{group_id}/members."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns a group profile.
   *
   * @param {string} groupId
   * @param {Rivet.group.GetProfileRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.getProfile("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         watchIndex: "string"
   *     })
   */
  async getProfile(groupId, request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/profile`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetProfileResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /group/groups/{group_id}/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} groupId
   * @param {Rivet.group.UpdateProfileRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.updateProfile("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         displayName: "string",
   *         bio: "string",
   *         publicity: "open"
   *     })
   */
  async updateProfile(groupId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/profile`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.UpdateProfileRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} groupId
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.getSummary("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getSummary(groupId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/summary`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return group_exports2.GetSummaryResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /group/groups/{group_id}/summary."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Transfers ownership of a group to another identity.
   *
   * @param {string} groupId
   * @param {Rivet.group.TransferOwnershipRequest} request
   * @param {Group.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.group.transferOwnership("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         newOwnerIdentityId: "string"
   *     })
   */
  async transferOwnership(groupId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin26(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/group/groups/${encodeURIComponent(groupId)}/transfer-owner`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: group_exports2.TransferOwnershipRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /group/groups/{group_id}/transfer-owner."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/identity/client/Client.ts
import urlJoin29 from "url-join";

// src/api/resources/identity/resources/activities/client/Client.ts
import urlJoin27 from "url-join";
var Activities = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns an overview of all players currently online or in game.
   *
   * @param {Rivet.identity.ListActivitiesRequest} request
   * @param {Activities.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.activities.list({
   *         watchIndex: "string"
   *     })
   */
  async list(request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin27(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/activities"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.ListActivitiesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /identity/activities.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/identity/resources/events/client/Client.ts
import urlJoin28 from "url-join";
var Events = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns all events relative to the current identity.
   *
   * @param {Rivet.identity.WatchEventsRequest} request
   * @param {Events.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.events.watch({
   *         watchIndex: "string"
   *     })
   */
  async watch(request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin28(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/events/live"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.WatchEventsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /identity/events/live.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/identity/client/Client.ts
var Identity = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _activities;
  _events;
  get activities() {
    return this._activities ??= new Activities(this._options);
  }
  get events() {
    return this._events ??= new Events(this._options);
  }
  /**
   * Gets or creates an identity.
   * Passing an existing identity token in the body refreshes the token.
   * Temporary Accounts
   * Until the identity is linked with the Rivet Hub (see `PrepareGameLink`), this identity will be temporary but still behave like all other identities.
   * This is intended to allow users to play the game without signing up while still having the benefits of having an account. When they are ready to save their account, they should be instructed to link their account (see `PrepareGameLink`).
   * Storing Token
   * `identity_token` should be stored in some form of persistent storage. The token should be read from storage and passed to `Setup` every time the client starts.
   *
   * @param {Rivet.identity.SetupRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.setup({
   *         existingIdentityToken: "string"
   *     })
   */
  async setup(request = {}, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.SetupRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.SetupResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /identity/identities.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Fetches an identity profile.
   *
   * @param {string} identityId
   * @param {Rivet.identity.GetProfileRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.getProfile("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         watchIndex: "string"
   *     })
   */
  async getProfile(identityId, request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/identity/identities/${encodeURIComponent(identityId)}/profile`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.GetProfileResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /identity/identities/{identity_id}/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Fetches the current identity's profile.
   *
   * @param {Rivet.identity.GetSelfProfileRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.getSelfProfile({
   *         watchIndex: "string"
   *     })
   */
  async getSelfProfile(request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/profile"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.GetProfileResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /identity/identities/self/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Fetches a list of identity handles.
   *
   * @param {Rivet.identity.GetHandlesRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.getHandles({
   *         identityIds: "string"
   *     })
   */
  async getHandles(request, requestOptions) {
    const { identityIds } = request;
    const _queryParams = {};
    if (Array.isArray(identityIds)) {
      _queryParams["identity_ids"] = identityIds.map((item) => item);
    } else {
      _queryParams["identity_ids"] = identityIds;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/batch/handle"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.GetHandlesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /identity/identities/batch/handle."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Fetches a list of identity summaries.
   *
   * @param {Rivet.identity.GetSummariesRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.getSummaries({
   *         identityIds: "string"
   *     })
   */
  async getSummaries(request, requestOptions) {
    const { identityIds } = request;
    const _queryParams = {};
    if (Array.isArray(identityIds)) {
      _queryParams["identity_ids"] = identityIds.map((item) => item);
    } else {
      _queryParams["identity_ids"] = identityIds;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/batch/summary"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.GetSummariesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /identity/identities/batch/summary."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Updates profile of the current identity.
   *
   * @param {Rivet.identity.UpdateProfileRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.updateProfile({
   *         displayName: "string",
   *         accountNumber: 1,
   *         bio: "string"
   *     })
   */
  async updateProfile(request = {}, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/profile"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.UpdateProfileRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/self/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Validate contents of identity profile. Use to provide immediate feedback on profile changes before committing them.
   *
   * @param {Rivet.identity.ValidateProfileRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.validateProfile({
   *         displayName: "string",
   *         accountNumber: 1,
   *         bio: "string"
   *     })
   */
  async validateProfile(request = {}, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/profile/validate"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.ValidateProfileRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/self/profile/validate."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Sets the current identity's game activity. This activity will automatically be removed when the identity goes offline.
   *
   * @param {Rivet.identity.SetGameActivityRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.setGameActivity({
   *         gameActivity: {
   *             message: "string",
   *             publicMetadata: {
   *                 "key": "value"
   *             },
   *             mutualMetadata: {
   *                 "key": "value"
   *             }
   *         }
   *     })
   */
  async setGameActivity(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/activity"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.SetGameActivityRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/self/activity."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Removes the current identity's game activity.
   *
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.removeGameActivity()
   */
  async removeGameActivity(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/activity"
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /identity/identities/self/activity."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Updates the current identity's status.
   *
   * @param {Rivet.identity.UpdateStatusRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.updateStatus({
   *         status: "online"
   *     })
   */
  async updateStatus(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/identities/self/status"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.UpdateStatusRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/identities/self/status."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Prepares an avatar image upload. Complete upload with `CompleteIdentityAvatarUpload`.
   *
   * @param {Rivet.identity.PrepareAvatarUploadRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.prepareAvatarUpload({
   *         path: "string",
   *         mime: "string",
   *         contentLength: 1000000
   *     })
   */
  async prepareAvatarUpload(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/avatar-upload/prepare"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.PrepareAvatarUploadRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return identity_exports5.PrepareAvatarUploadResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/avatar-upload/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes an avatar image upload. Must be called after the file upload process completes.
   *
   * @param {string} uploadId
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.completeAvatarUpload("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async completeAvatarUpload(uploadId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/identity/identities/avatar-upload/${encodeURIComponent(uploadId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/avatar-upload/{upload_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes an avatar image upload. Must be called after the file upload process completes.
   *
   * @param {Rivet.identity.SignupForBetaRequest} request
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.signupForBeta({
   *         name: "string",
   *         companyName: "string",
   *         companySize: "string",
   *         preferredTools: "string",
   *         goals: "string"
   *     })
   */
  async signupForBeta(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/beta-signup"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: identity_exports5.SignupForBetaRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/self/beta-signup."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.markDeletion()
   */
  async markDeletion(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/delete-request"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /identity/identities/self/delete-request."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {Identity.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.identity.unmarkDeletion()
   */
  async unmarkDeletion(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin29(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/identity/identities/self/delete-request"
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /identity/identities/self/delete-request."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/provision/resources/datacenters/client/Client.ts
import urlJoin30 from "url-join";
var Datacenters = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {string} datacenterId
   * @param {Datacenters.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.provision.datacenters.getTls("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getTls(datacenterId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin30(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/datacenters/${encodeURIComponent(datacenterId)}/tls`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return provision_exports2.datacenters.GetTlsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /datacenters/{datacenter_id}/tls."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} datacenterId
   * @param {Datacenters.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.provision.datacenters.getServers("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getServers(datacenterId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin30(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/datacenters/${encodeURIComponent(datacenterId)}/servers`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return provision_exports2.datacenters.GetServersResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /datacenters/{datacenter_id}/servers."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/provision/resources/servers/client/Client.ts
import urlJoin31 from "url-join";
var Servers = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {string} ip
   * @param {Servers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.provision.servers.getInfo("string")
   */
  async getInfo(ip, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin31(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/servers/${encodeURIComponent(ip)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return provision_exports2.servers.GetInfoResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /servers/{ip}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/provision/resources/tunnel/client/Client.ts
import urlJoin32 from "url-join";
var Tunnel = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {Tunnel.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.provision.tunnel.getTls()
   */
  async getTls(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin32(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/tunnel/tls"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return provision_exports2.tunnel.GetTlsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /tunnel/tls.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/provision/client/Client.ts
var Provision = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _datacenters;
  _servers;
  _tunnel;
  get datacenters() {
    return this._datacenters ??= new Datacenters(this._options);
  }
  get servers() {
    return this._servers ??= new Servers(this._options);
  }
  get tunnel() {
    return this._tunnel ??= new Tunnel(this._options);
  }
};

// src/api/resources/regions/client/Client.ts
import urlJoin33 from "url-join";
var Regions = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {Rivet.regions.ListRegionsRequestQuery} request
   * @param {Regions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.regions.list({
   *         project: "string",
   *         environment: "string"
   *     })
   */
  async list(request = {}, requestOptions) {
    const { project, environment } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin33(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/regions"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return regions_exports3.ListRegionsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /regions.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {Rivet.regions.RecommendRegionsRequestQuery} request
   * @param {Regions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.regions.recommend({
   *         project: "string",
   *         environment: "string",
   *         lat: 1.1,
   *         long: 1.1
   *     })
   */
  async recommend(request = {}, requestOptions) {
    const { project, environment, lat, long } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    if (lat != null) {
      _queryParams["lat"] = lat.toString();
    }
    if (long != null) {
      _queryParams["long"] = long.toString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin33(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/regions/recommend"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return regions_exports3.RecommendRegionResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /regions/recommend.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/routes/client/Client.ts
import urlJoin34 from "url-join";
var Routes = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Lists all routes of the given environment.
   *
   * @param {Rivet.routes.ListRoutesQuery} request
   * @param {Routes.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.routes.list({
   *         project: "string",
   *         environment: "string"
   *     })
   */
  async list(request = {}, requestOptions) {
    const { project, environment } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin34(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/routes"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return routes_exports2.ListRoutesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /routes.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates or updates a route.
   *
   * @param {string} id
   * @param {Rivet.routes.UpdateRouteQuery} request
   * @param {Routes.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.routes.update("string", {
   *         project: "string",
   *         environment: "string",
   *         body: {
   *             hostname: "string",
   *             path: "string",
   *             stripPrefix: true,
   *             routeSubpaths: true,
   *             target: {
   *                 actors: {
   *                     selectorTags: {}
   *                 }
   *             }
   *         }
   *     })
   */
  async update(id, request, requestOptions) {
    const { project, environment, body: _body } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin34(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/routes/${encodeURIComponent(id)}`
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      body: routes_exports2.UpdateRouteBody.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return routes_exports2.UpdateRouteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling PUT /routes/{id}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Deletes a route.
   *
   * @param {string} id
   * @param {Rivet.routes.DeleteRouteQuery} request
   * @param {Routes.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.routes.delete("string", {
   *         project: "string",
   *         environment: "string"
   *     })
   */
  async delete(id, request = {}, requestOptions) {
    const { project, environment } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin34(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/routes/${encodeURIComponent(id)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return routes_exports2.DeleteRouteResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling DELETE /routes/{id}.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Returns time series data for HTTP requests routed to actors. Allows filtering and grouping by various request properties.
   *
   * @param {Rivet.routes.HistoryQuery} request
   * @param {Routes.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.routes.history({
   *         project: "string",
   *         environment: "string",
   *         start: 1,
   *         end: 1,
   *         interval: 1,
   *         queryJson: "string",
   *         groupBy: "string"
   *     })
   */
  async history(request, requestOptions) {
    const { project, environment, start, end, interval, queryJson, groupBy } = request;
    const _queryParams = {};
    if (project != null) {
      _queryParams["project"] = project;
    }
    if (environment != null) {
      _queryParams["environment"] = environment;
    }
    _queryParams["start"] = start.toString();
    _queryParams["end"] = end.toString();
    _queryParams["interval"] = interval.toString();
    if (queryJson != null) {
      _queryParams["query_json"] = queryJson;
    }
    if (groupBy != null) {
      _queryParams["group_by"] = groupBy;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin34(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/routes/history"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return routes_exports2.HistoryResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /routes/history.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/servers/client/Client.ts
import urlJoin38 from "url-join";

// src/api/resources/servers/resources/builds/client/Client.ts
import urlJoin35 from "url-join";
var Builds3 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Lists all builds of the game associated with the token used. Can be filtered by tags in the query string.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} buildId
   * @param {Rivet.servers.GetBuildRequest} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.builds.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         tagsJson: "string"
   *     })
   */
  async get(gameId, environmentId, buildId, request = {}, requestOptions) {
    const { tagsJson } = request;
    const _queryParams = {};
    if (tagsJson != null) {
      _queryParams["tags_json"] = tagsJson;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin35(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/builds/${encodeURIComponent(buildId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.GetBuildResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/builds/{build_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Lists all builds of the game associated with the token used. Can be filtered by tags in the query string.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Rivet.servers.ListBuildsRequest} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.builds.list("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         tagsJson: "string"
   *     })
   */
  async list(gameId, environmentId, request = {}, requestOptions) {
    const { tagsJson } = request;
    const _queryParams = {};
    if (tagsJson != null) {
      _queryParams["tags_json"] = tagsJson;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin35(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/builds`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.ListBuildsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/builds."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} buildId
   * @param {Rivet.servers.PatchBuildTagsRequest} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.builds.patchTags("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         tags: {
   *             "key": "value"
   *         },
   *         exclusiveTags: ["string"]
   *     })
   */
  async patchTags(gameId, environmentId, buildId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin35(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/builds/${encodeURIComponent(buildId)}/tags`
      ),
      method: "PATCH",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: servers_exports4.PatchBuildTagsRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.PatchBuildTagsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling PATCH /games/{game_id}/environments/{environment_id}/builds/{build_id}/tags."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a new game build for the given game.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Rivet.servers.CreateBuildRequest} request
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.builds.prepare("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         name: "string",
   *         imageTag: "string",
   *         imageFile: {
   *             path: "string",
   *             contentType: "string",
   *             contentLength: 1000000
   *         },
   *         multipartUpload: true,
   *         kind: "docker_image",
   *         compression: "none",
   *         prewarmDatacenters: ["d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"]
   *     })
   */
  async prepare(gameId, environmentId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin35(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/builds/prepare`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: servers_exports4.CreateBuildRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.CreateBuildResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /games/{game_id}/environments/{environment_id}/builds/prepare."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Marks an upload as complete.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} buildId
   * @param {Builds.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.builds.complete("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async complete(gameId, environmentId, buildId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin35(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/builds/${encodeURIComponent(buildId)}/complete`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /games/{game_id}/environments/{environment_id}/builds/{build_id}/complete."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/servers/resources/datacenters/client/Client.ts
import urlJoin36 from "url-join";
var Datacenters2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Datacenters.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.datacenters.list("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async list(gameId, environmentId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin36(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/datacenters`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.ListDatacentersResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/datacenters."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/servers/resources/logs/client/Client.ts
import urlJoin37 from "url-join";
var Logs4 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns the logs for a given server.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} serverId
   * @param {Rivet.servers.GetServerLogsRequest} request
   * @param {Logs.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.logs.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         stream: "std_out",
   *         watchIndex: "string"
   *     })
   */
  async get(gameId, environmentId, serverId, request, requestOptions) {
    const { stream, watchIndex } = request;
    const _queryParams = {};
    _queryParams["stream"] = servers_exports4.LogStream.jsonOrThrow(stream, { unrecognizedObjectKeys: "strip" });
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin37(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/servers/${encodeURIComponent(serverId)}/logs`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.GetServerLogsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/servers/{server_id}/logs."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/servers/client/Client.ts
var Servers2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _builds;
  _datacenters;
  _logs;
  get builds() {
    return this._builds ??= new Builds3(this._options);
  }
  get datacenters() {
    return this._datacenters ??= new Datacenters2(this._options);
  }
  get logs() {
    return this._logs ??= new Logs4(this._options);
  }
  /**
   * Gets a dynamic server.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} serverId - The id of the server to destroy
   * @param {Servers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.get("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async get(gameId, environmentId, serverId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin38(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/servers/${encodeURIComponent(serverId)}`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.GetServerResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/servers/{server_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Lists all servers associated with the token used. Can be filtered by tags in the query string.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Rivet.servers.GetServersRequest} request
   * @param {Servers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.list("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         tagsJson: "string",
   *         includeDestroyed: true,
   *         cursor: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async list(gameId, environmentId, request = {}, requestOptions) {
    const { tagsJson, includeDestroyed, cursor } = request;
    const _queryParams = {};
    if (tagsJson != null) {
      _queryParams["tags_json"] = tagsJson;
    }
    if (includeDestroyed != null) {
      _queryParams["include_destroyed"] = includeDestroyed.toString();
    }
    if (cursor != null) {
      _queryParams["cursor"] = cursor;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin38(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/servers`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.ListServersResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /games/{game_id}/environments/{environment_id}/servers."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Create a new dynamic server.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Rivet.servers.CreateServerRequest} request
   * @param {Servers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.create("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         datacenter: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *         tags: {
   *             "key": "value"
   *         },
   *         runtime: {
   *             build: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *             arguments: ["string"],
   *             environment: {
   *                 "string": "string"
   *             }
   *         },
   *         network: {
   *             mode: "bridge",
   *             ports: {
   *                 "string": {
   *                     protocol: "http",
   *                     internalPort: 1,
   *                     routing: {
   *                         gameGuard: {},
   *                         host: {}
   *                     }
   *                 }
   *             }
   *         },
   *         resources: {
   *             cpu: 1,
   *             memory: 1
   *         },
   *         lifecycle: {
   *             killTimeout: 1000000
   *         }
   *     })
   */
  async create(gameId, environmentId, request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin38(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/servers`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: servers_exports4.CreateServerRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.CreateServerResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /games/{game_id}/environments/{environment_id}/servers."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Destroy a dynamic server.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {string} serverId - The id of the server to destroy
   * @param {Rivet.servers.DestroyServerRequest} request
   * @param {Servers.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.servers.destroy("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", {
   *         overrideKillTimeout: 1000000
   *     })
   */
  async destroy(gameId, environmentId, serverId, request = {}, requestOptions) {
    const { overrideKillTimeout } = request;
    const _queryParams = {};
    if (overrideKillTimeout != null) {
      _queryParams["override_kill_timeout"] = overrideKillTimeout.toString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin38(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/servers/${encodeURIComponent(serverId)}`
      ),
      method: "DELETE",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return servers_exports4.DestroyServerResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling DELETE /games/{game_id}/environments/{environment_id}/servers/{server_id}."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/auth/resources/identity/resources/email/client/Client.ts
import urlJoin39 from "url-join";
var Email2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Starts the verification process for linking an email to your identity.
   *
   * @param {Rivet.auth.identity.StartEmailVerificationRequest} request
   * @param {Email.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.auth.identity.email.startEmailVerification({
   *         email: "string",
   *         captcha: {
   *             hcaptcha: {
   *                 clientResponse: "string"
   *             },
   *             turnstile: {
   *                 clientResponse: "string"
   *             }
   *         },
   *         gameId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32"
   *     })
   */
  async startEmailVerification(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin39(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/auth/identity/email/start-verification"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: auth_exports4.identity.StartEmailVerificationRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return auth_exports4.identity.StartEmailVerificationResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /auth/identity/email/start-verification."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Completes the email verification process.
   *
   * @param {Rivet.auth.identity.CompleteEmailVerificationRequest} request
   * @param {Email.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.auth.identity.email.completeEmailVerification({
   *         verificationId: "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32",
   *         code: "string"
   *     })
   */
  async completeEmailVerification(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin39(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/auth/identity/email/complete-verification"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: auth_exports4.identity.CompleteEmailVerificationRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return auth_exports4.identity.CompleteEmailVerificationResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /auth/identity/email/complete-verification."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/auth/resources/identity/client/Client.ts
var Identity2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _email;
  get email() {
    return this._email ??= new Email2(this._options);
  }
};

// src/api/resources/auth/resources/tokens/client/Client.ts
import urlJoin40 from "url-join";
var Tokens2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Refreshes the current identity's token and sets authentication headers.
   *
   * @param {Rivet.auth.RefreshIdentityTokenRequest} request
   * @param {Tokens.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.auth.tokens.refreshIdentityToken({
   *         logout: true
   *     })
   */
  async refreshIdentityToken(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin40(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/auth/tokens/identity"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: auth_exports4.RefreshIdentityTokenRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return auth_exports4.RefreshIdentityTokenResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /auth/tokens/identity.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/auth/client/Client.ts
var Auth2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _identity;
  _tokens;
  get identity() {
    return this._identity ??= new Identity2(this._options);
  }
  get tokens() {
    return this._tokens ??= new Tokens2(this._options);
  }
};

// src/api/resources/games/resources/environments/resources/tokens/client/Client.ts
import urlJoin41 from "url-join";
var Tokens3 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Creates a new environment service token.
   *
   * @param {string} gameId
   * @param {string} environmentId
   * @param {Tokens.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.games.environments.tokens.createServiceToken("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32", "d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async createServiceToken(gameId, environmentId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin41(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/games/${encodeURIComponent(gameId)}/environments/${encodeURIComponent(environmentId)}/tokens/service`
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return games_exports5.environments.CreateServiceTokenResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /games/{game_id}/environments/{environment_id}/tokens/service."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/games/resources/environments/client/Client.ts
var Environments = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _tokens;
  get tokens() {
    return this._tokens ??= new Tokens3(this._options);
  }
};

// src/api/resources/games/client/Client.ts
var Games2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _environments;
  get environments() {
    return this._environments ??= new Environments(this._options);
  }
};

// src/api/resources/job/resources/run/client/Client.ts
import urlJoin42 from "url-join";
var Run = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * @param {Run.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.job.run.cleanup()
   */
  async cleanup(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin42(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/job/runs/cleanup"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /job/runs/cleanup.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/job/client/Client.ts
var Job = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _run;
  get run() {
    return this._run ??= new Run(this._options);
  }
};

// src/api/resources/matchmaker/resources/lobbies/client/Client.ts
import urlJoin43 from "url-join";
var Lobbies = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Marks the current lobby as ready to accept connections. Players will not be able to connect to this lobby until the lobby is flagged as ready.
   * This endpoint requires a [lobby token](/docs/general/concepts/token-types#matchmaker-lobby) for authentication, or a [development namespace token](/docs/general/concepts/token-types#namespace-development) for mock responses. When running on Rivet servers, you can access the given lobby token from the [`RIVET_TOKEN`](/docs/matchmaker/concepts/lobby-env) environment variable.
   *
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.ready()
   */
  async ready(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/ready"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /matchmaker/lobbies/ready.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * If `is_closed` is `true`, the matchmaker will no longer route players to the lobby. Players can still
   * join using the /join endpoint (this can be disabled by the developer by rejecting all new connections
   * after setting the lobby to closed).
   * Does not shutdown the lobby.
   *
   * This endpoint requires a [lobby token](/docs/general/concepts/token-types#matchmaker-lobby) for
   * authentication, or a [development namespace token](/docs/general/concepts/token-types#namespace-development)
   * for mock responses. When running on Rivet servers, you can access the given lobby token from the
   * [`RIVET_TOKEN`](/docs/matchmaker/concepts/lobby-env) environment variable.
   *
   * @param {Rivet.matchmaker.SetLobbyClosedRequest} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.setClosed({
   *         isClosed: true
   *     })
   */
  async setClosed(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/closed"
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.SetLobbyClosedRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling PUT /matchmaker/lobbies/closed.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Sets the state JSON of the current lobby.
   *
   * This endpoint requires a [lobby token](/docs/general/concepts/token-types#matchmaker-lobby) for
   * authentication, or a [development namespace token](/docs/general/concepts/token-types#namespace-development)
   * for mock responses. When running on Rivet servers, you can access the given lobby token from the
   * [`RIVET_TOKEN`](/docs/matchmaker/concepts/lobby-env) environment variable.
   *
   * @param {unknown} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.setState({
   *         "key": "value"
   *     })
   */
  async setState(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/state"
      ),
      method: "PUT",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: request != null ? matchmaker_exports6.lobbies.setState.Request.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }) : void 0,
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling PUT /matchmaker/lobbies/state.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Get the state of any lobby.
   *
   * This endpoint requires a [lobby token](/docs/general/concepts/token-types#matchmaker-lobby) for
   * authentication, or a [development namespace token](/docs/general/concepts/token-types#namespace-development)
   * for mock responses. When running on Rivet servers, you can access the given lobby token from the
   * [`RIVET_TOKEN`](/docs/matchmaker/concepts/lobby-env) environment variable.
   *
   * @param {string} lobbyId
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.getState("d5e9c84f-c2b2-4bf4-b4b0-7ffd7a9ffc32")
   */
  async getState(lobbyId, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/matchmaker/lobbies/${encodeURIComponent(lobbyId)}/state`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.lobbies.getState.Response.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /matchmaker/lobbies/{lobby_id}/state."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Finds a lobby based on the given criteria.
   * If a lobby is not found and `prevent_auto_create_lobby` is `false`,
   * a new lobby will be created.
   *
   * When [tokenless authentication](/docs/general/concepts/tokenless-authentication/web) is enabled in
   * your game namespace, this endpoint does not require a token to authenticate. Otherwise, a
   * [development namespace token](/docs/general/concepts/token-types#namespace-development) can be used
   * for mock responses and a [public namespace token](/docs/general/concepts/token-types#namespace-public)
   * can be used for general authentication.
   *
   * @param {Rivet.matchmaker.FindLobbyRequest} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.find({
   *         origin: "string",
   *         gameModes: ["string"],
   *         regions: ["string"],
   *         preventAutoCreateLobby: true,
   *         tags: {
   *             "string": "string"
   *         },
   *         maxPlayers: 1,
   *         captcha: {
   *             hcaptcha: {
   *                 clientResponse: "string"
   *             },
   *             turnstile: {
   *                 clientResponse: "string"
   *             }
   *         },
   *         verificationData: {
   *             "key": "value"
   *         }
   *     })
   */
  async find(request, requestOptions) {
    const { origin, ..._body } = request;
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/find"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        origin: origin != null ? origin : void 0,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.FindLobbyRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.FindLobbyResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /matchmaker/lobbies/find.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Joins a specific lobby.
   * This request will use the direct player count configured for the
   * lobby group.
   *
   * When [tokenless authentication](/docs/general/concepts/tokenless-authentication/web) is enabled in
   * your game namespace, this endpoint does not require a token to authenticate. Otherwise, a
   * [development namespace token](/docs/general/concepts/token-types#namespace-development) can be used
   * for mock responses and a [public namespace token](/docs/general/concepts/token-types#namespace-public)
   * can be used for general authentication.
   *
   * @param {Rivet.matchmaker.JoinLobbyRequest} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.join({
   *         lobbyId: "string",
   *         captcha: {
   *             hcaptcha: {
   *                 clientResponse: "string"
   *             },
   *             turnstile: {
   *                 clientResponse: "string"
   *             }
   *         },
   *         verificationData: {
   *             "key": "value"
   *         }
   *     })
   */
  async join(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/join"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.JoinLobbyRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.JoinLobbyResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /matchmaker/lobbies/join.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Creates a custom lobby.
   *
   * When [tokenless authentication](/docs/general/concepts/tokenless-authentication/web) is enabled in
   * your game namespace, this endpoint does not require a token to authenticate. Otherwise, a
   * [development namespace token](/docs/general/concepts/token-types#namespace-development) can be used
   * for mock responses and a [public namespace token](/docs/general/concepts/token-types#namespace-public)
   * can be used for general authentication.
   *
   * @param {Rivet.matchmaker.CreateLobbyRequest} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.create({
   *         gameMode: "string",
   *         region: "string",
   *         publicity: "public",
   *         tags: {
   *             "string": "string"
   *         },
   *         maxPlayers: 1,
   *         lobbyConfig: {
   *             "key": "value"
   *         },
   *         captcha: {
   *             hcaptcha: {
   *                 clientResponse: "string"
   *             },
   *             turnstile: {
   *                 clientResponse: "string"
   *             }
   *         },
   *         verificationData: {
   *             "key": "value"
   *         }
   *     })
   */
  async create(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/create"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.CreateLobbyRequest.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.CreateLobbyResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /matchmaker/lobbies/create.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Lists all open lobbies.
   *
   * When [tokenless authentication](/docs/general/concepts/tokenless-authentication/web) is enabled in
   * your game namespace, this endpoint does not require a token to authenticate. Otherwise, a
   * [development namespace token](/docs/general/concepts/token-types#namespace-development) can be used
   * for mock responses and a [public namespace token](/docs/general/concepts/token-types#namespace-public)
   * can be used for general authentication.
   *
   * @param {Rivet.matchmaker.ListLobbiesRequest} request
   * @param {Lobbies.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.lobbies.list({
   *         includeState: true
   *     })
   */
  async list(request = {}, requestOptions) {
    const { includeState } = request;
    const _queryParams = {};
    if (includeState != null) {
      _queryParams["include_state"] = includeState.toString();
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin43(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/lobbies/list"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.ListLobbiesResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /matchmaker/lobbies/list.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/matchmaker/resources/players/client/Client.ts
import urlJoin44 from "url-join";
var Players = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Validates the player token is valid and has not already been consumed then
   * marks the player as connected.
   *
   * # Player Tokens and Reserved Slots
   *
   * Player tokens reserve a spot in the lobby until they expire. This allows for
   * precise matchmaking up to exactly the lobby's player limit, which is
   * important for games with small lobbies and a high influx of players.
   * By calling this endpoint with the player token, the player's spot is marked
   * as connected and will not expire. If this endpoint is never called, the
   * player's token will expire and this spot will be filled by another player.
   *
   * # Anti-Botting
   *
   * Player tokens are only issued by caling `lobbies.join`, calling `lobbies.find`, or
   * from the `GlobalEventMatchmakerLobbyJoin` event.
   * These endpoints have anti-botting measures (i.e. enforcing max player
   * limits, captchas, and detecting bots), so valid player tokens provide some
   * confidence that the player is not a bot.
   * Therefore, it's important to make sure the token is valid by waiting for
   * this endpoint to return OK before allowing the connected socket to do
   * anything else. If this endpoint returns an error, the socket should be
   * disconnected immediately.
   *
   * # How to Transmit the Player Token
   *
   * The client is responsible for acquiring the player token by caling
   * `lobbies.join`, calling `lobbies.find`, or from the `GlobalEventMatchmakerLobbyJoin`
   * event. Beyond that, it's up to the developer how the player token is
   * transmitted to the lobby.
   * If using WebSockets, the player token can be transmitted as a query
   * parameter.
   * Otherwise, the player token will likely be automatically sent by the client
   * once the socket opens. As mentioned above, nothing else should happen until
   * the player token is validated.
   *
   * @param {Rivet.matchmaker.PlayerConnectedRequest} request
   * @param {Players.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.players.connected({
   *         playerToken: "string"
   *     })
   */
  async connected(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin44(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/players/connected"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.PlayerConnectedRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling POST /matchmaker/players/connected.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Marks a player as disconnected. # Ghost Players If players are not marked as disconnected, lobbies will result with "ghost players" that the matchmaker thinks exist but are no longer connected to the lobby.
   *
   * @param {Rivet.matchmaker.PlayerDisconnectedRequest} request
   * @param {Players.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.players.disconnected({
   *         playerToken: "string"
   *     })
   */
  async disconnected(request, requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin44(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/players/disconnected"
      ),
      method: "POST",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      body: matchmaker_exports6.PlayerDisconnectedRequest.jsonOrThrow(request, {
        unrecognizedObjectKeys: "strip"
      }),
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return;
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling POST /matchmaker/players/disconnected."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  /**
   * Gives matchmaker statistics about the players in game.
   *
   * @param {Players.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.players.getStatistics()
   */
  async getStatistics(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin44(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/players/statistics"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.GetStatisticsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /matchmaker/players/statistics.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/matchmaker/resources/regions/client/Client.ts
import urlJoin45 from "url-join";
var Regions2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns a list of regions available to this namespace.
   * Regions are sorted by most optimal to least optimal. The player's IP address
   * is used to calculate the regions' optimality.
   *
   * @param {Regions.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.matchmaker.regions.list()
   */
  async list(requestOptions) {
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin45(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        "/matchmaker/regions"
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return matchmaker_exports6.ListRegionsResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError("Timeout exceeded when calling GET /matchmaker/regions.");
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/matchmaker/client/Client.ts
var Matchmaker2 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _lobbies;
  _players;
  _regions;
  get lobbies() {
    return this._lobbies ??= new Lobbies(this._options);
  }
  get players() {
    return this._players ??= new Players(this._options);
  }
  get regions() {
    return this._regions ??= new Regions2(this._options);
  }
};

// src/api/resources/portal/resources/games/client/Client.ts
import urlJoin46 from "url-join";
var Games3 = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  /**
   * Returns a game profile.
   *
   * @param {string} gameNameId - A human readable short identifier used to references resources. Different than a `rivet.common#Uuid` because this is intended to be human readable. Different than `rivet.common#DisplayName` because this should not include special characters and be short.
   * @param {Rivet.portal.GetGameProfileRequest} request
   * @param {Games.RequestOptions} requestOptions - Request-specific configuration.
   *
   * @throws {@link Rivet.InternalError}
   * @throws {@link Rivet.RateLimitError}
   * @throws {@link Rivet.ForbiddenError}
   * @throws {@link Rivet.UnauthorizedError}
   * @throws {@link Rivet.NotFoundError}
   * @throws {@link Rivet.BadRequestError}
   *
   * @example
   *     await client.portal.games.getGameProfile("string", {
   *         watchIndex: "string"
   *     })
   */
  async getGameProfile(gameNameId, request = {}, requestOptions) {
    const { watchIndex } = request;
    const _queryParams = {};
    if (watchIndex != null) {
      _queryParams["watch_index"] = watchIndex;
    }
    const _response = await (this._options.fetcher ?? fetcher)({
      url: urlJoin46(
        await Supplier.get(this._options.baseUrl) ?? await Supplier.get(this._options.environment) ?? RivetEnvironment.Production,
        `/portal/games/${encodeURIComponent(gameNameId)}/profile`
      ),
      method: "GET",
      headers: {
        Authorization: await this._getAuthorizationHeader(),
        "X-Fern-Language": "JavaScript",
        "X-API-Version": requestOptions?.xApiVersion ?? this._options?.xApiVersion ?? "25.5.2",
        "X-Fern-Runtime": RUNTIME.type,
        "X-Fern-Runtime-Version": RUNTIME.version,
        ...requestOptions?.headers
      },
      contentType: "application/json",
      queryParameters: _queryParams,
      requestType: "json",
      timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1e3 : 18e4,
      maxRetries: requestOptions?.maxRetries,
      abortSignal: requestOptions?.abortSignal
    });
    if (_response.ok) {
      return portal_exports2.GetGameProfileResponse.parseOrThrow(_response.body, {
        unrecognizedObjectKeys: "passthrough",
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        skipValidation: true,
        breadcrumbsPrefix: ["response"]
      });
    }
    if (_response.error.reason === "status-code") {
      switch (_response.error.statusCode) {
        case 500:
          throw new InternalError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 429:
          throw new RateLimitError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 403:
          throw new ForbiddenError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 408:
          throw new UnauthorizedError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 404:
          throw new NotFoundError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        case 400:
          throw new BadRequestError(
            ErrorBody.parseOrThrow(_response.error.body, {
              unrecognizedObjectKeys: "passthrough",
              allowUnrecognizedUnionMembers: true,
              allowUnrecognizedEnumValues: true,
              skipValidation: true,
              breadcrumbsPrefix: ["response"]
            })
          );
        default:
          throw new RivetError({
            statusCode: _response.error.statusCode,
            body: _response.error.body
          });
      }
    }
    switch (_response.error.reason) {
      case "non-json":
        throw new RivetError({
          statusCode: _response.error.statusCode,
          body: _response.error.rawBody
        });
      case "timeout":
        throw new RivetTimeoutError(
          "Timeout exceeded when calling GET /portal/games/{game_name_id}/profile."
        );
      case "unknown":
        throw new RivetError({
          message: _response.error.errorMessage
        });
    }
  }
  async _getAuthorizationHeader() {
    const bearer = await Supplier.get(this._options.token);
    if (bearer != null) {
      return `Bearer ${bearer}`;
    }
    return void 0;
  }
};

// src/api/resources/portal/client/Client.ts
var Portal = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _games;
  get games() {
    return this._games ??= new Games3(this._options);
  }
};

// src/Client.ts
var RivetClient = class {
  constructor(_options = {}) {
    this._options = _options;
  }
  _actors;
  _builds;
  _cloud;
  _coreIntercom;
  _edgeIntercom;
  _group;
  _identity;
  _provision;
  _regions;
  _routes;
  _servers;
  _auth;
  _games;
  _job;
  _matchmaker;
  _portal;
  get actors() {
    return this._actors ??= new Actors(this._options);
  }
  get builds() {
    return this._builds ??= new Builds(this._options);
  }
  get cloud() {
    return this._cloud ??= new Cloud(this._options);
  }
  get coreIntercom() {
    return this._coreIntercom ??= new CoreIntercom(this._options);
  }
  get edgeIntercom() {
    return this._edgeIntercom ??= new EdgeIntercom(this._options);
  }
  get group() {
    return this._group ??= new Group2(this._options);
  }
  get identity() {
    return this._identity ??= new Identity(this._options);
  }
  get provision() {
    return this._provision ??= new Provision(this._options);
  }
  get regions() {
    return this._regions ??= new Regions(this._options);
  }
  get routes() {
    return this._routes ??= new Routes(this._options);
  }
  get servers() {
    return this._servers ??= new Servers2(this._options);
  }
  get auth() {
    return this._auth ??= new Auth2(this._options);
  }
  get games() {
    return this._games ??= new Games2(this._options);
  }
  get job() {
    return this._job ??= new Job(this._options);
  }
  get matchmaker() {
    return this._matchmaker ??= new Matchmaker2(this._options);
  }
  get portal() {
    return this._portal ??= new Portal(this._options);
  }
};
export {
  api_exports as Rivet,
  RivetClient,
  RivetEnvironment,
  RivetError,
  RivetTimeoutError,
  serialization_exports as serialization
};
